import { default as compare_45ownerf8dWT7A6IdMeta } from "/app/src/client/pages/design-toc/analysis/compare-owner.vue?macro=true";
import { default as compare_45region60lTZjKw2iMeta } from "/app/src/client/pages/design-toc/analysis/compare-region.vue?macro=true";
import { default as geo8pf4e8HTB1Meta } from "/app/src/client/pages/design-toc/analysis/component/geo.vue?macro=true";
import { default as ownerSearchModalUQKCdI4HxSMeta } from "/app/src/client/pages/design-toc/analysis/component/ownerSearchModal.vue?macro=true";
import { default as pvKC2qkrdxPJMeta } from "/app/src/client/pages/design-toc/analysis/component/pv.vue?macro=true";
import { default as solarheatjo1cAPMPMMMeta } from "/app/src/client/pages/design-toc/analysis/component/solarheat.vue?macro=true";
import { default as indexhiPVbt3v1oMeta } from "/app/src/client/pages/design-toc/analysis/index.vue?macro=true";
import { default as ownerI2lYy8zf4sMeta } from "/app/src/client/pages/design-toc/analysis/owner.vue?macro=true";
import { default as analysisL5sjKGJ0GRMeta } from "/app/src/client/pages/design-toc/analysis.vue?macro=true";
import { default as as_45request_45detailY78KnvZezmMeta } from "/app/src/client/pages/design-toc/asinfo/as-request-detail.vue?macro=true";
import { default as as_45request_45listLvFcwUXBrxMeta } from "/app/src/client/pages/design-toc/asinfo/as-request-list.vue?macro=true";
import { default as as_45requestJfRvJ9evkTMeta } from "/app/src/client/pages/design-toc/asinfo/as-request.vue?macro=true";
import { default as aslistT4hSpwzDOHMeta } from "/app/src/client/pages/design-toc/asinfo/aslist.vue?macro=true";
import { default as indexa3fJRjfmpUMeta } from "/app/src/client/pages/design-toc/asinfo/index.vue?macro=true";
import { default as asinfoWBls9uMFUVMeta } from "/app/src/client/pages/design-toc/asinfo.vue?macro=true";
import { default as bpm_45detailPPIzoaDucIMeta } from "/app/src/client/pages/design-toc/bpm/bpm-detail.vue?macro=true";
import { default as bpm_45upload_45modalKM1cUQOu5DMeta } from "/app/src/client/pages/design-toc/bpm/bpm-upload-modal.vue?macro=true";
import { default as bpm_45upload_45progress_45modalZY8xYCaMbvMeta } from "/app/src/client/pages/design-toc/bpm/bpm-upload-progress-modal.vue?macro=true";
import { default as bpmlistMJVoRaVrioMeta } from "/app/src/client/pages/design-toc/bpm/bpmlist.vue?macro=true";
import { default as indexIoqFROXjQQMeta } from "/app/src/client/pages/design-toc/bpm/index.vue?macro=true";
import { default as bpmrequeststhsHJRXhXgMeta } from "/app/src/client/pages/design-toc/bpmrequestinfo/bpmrequests.vue?macro=true";
import { default as cost_45estimate_45by_45companyqQHax1RlX1Meta } from "/app/src/client/pages/design-toc/bpmrequestinfo/cost-estimate-by-company.vue?macro=true";
import { default as cost_45estimateAWefPnwxoZMeta } from "/app/src/client/pages/design-toc/bpmrequestinfo/cost-estimate.vue?macro=true";
import { default as indexev64uekzi8Meta } from "/app/src/client/pages/design-toc/bpmrequestinfo/index.vue?macro=true";
import { default as BarChartxYXW54ExVUMeta } from "/app/src/client/pages/design-toc/component/BarChart.vue?macro=true";
import { default as Panning_45BarChartX6Z6sr0oIFMeta } from "/app/src/client/pages/design-toc/component/Panning-BarChart.vue?macro=true";
import { default as PieChartPjV04ehV0cMeta } from "/app/src/client/pages/design-toc/component/PieChart.vue?macro=true";
import { default as ag_45table_45boxIp9ed4dUJRMeta } from "/app/src/client/pages/design-toc/component/ag-table-box.vue?macro=true";
import { default as api_45search_45boxjsybBHzHH6Meta } from "/app/src/client/pages/design-toc/component/api-search-box.vue?macro=true";
import { default as base_45componentLxE4vGyeadMeta } from "/app/src/client/pages/design-toc/component/base-component.vue?macro=true";
import { default as base_45tablehenO3CJQkfMeta } from "/app/src/client/pages/design-toc/component/base-table.vue?macro=true";
import { default as basic_45info_45card14t9e41QKQMeta } from "/app/src/client/pages/design-toc/component/basic-info-card.vue?macro=true";
import { default as basic_45value_45carde2aj88SnJPMeta } from "/app/src/client/pages/design-toc/component/basic-value-card.vue?macro=true";
import { default as category_45chartqcdzaNYL3tMeta } from "/app/src/client/pages/design-toc/component/category-chart.vue?macro=true";
import { default as common_45code_45dropdownJFjPUls7nnMeta } from "/app/src/client/pages/design-toc/component/common-code-dropdown.vue?macro=true";
import { default as curtailment_45cardy2M7Zap6JZMeta } from "/app/src/client/pages/design-toc/component/curtailment-card.vue?macro=true";
import { default as dashboardUc0v2yRsmoMeta } from "/app/src/client/pages/design-toc/component/dashboard/dashboard.vue?macro=true";
import { default as date_45chartSTVVXpZ3AxMeta } from "/app/src/client/pages/design-toc/component/date-chart.vue?macro=true";
import { default as date_45picker612RKwgFTOMeta } from "/app/src/client/pages/design-toc/component/date-picker.vue?macro=true";
import { default as date_45set_45reportyav0DZ5j4HMeta } from "/app/src/client/pages/design-toc/component/date-set-report.vue?macro=true";
import { default as date_45setAVUrVV6wVDMeta } from "/app/src/client/pages/design-toc/component/date-set.vue?macro=true";
import { default as editable_45image_45cardNE1aiqn3FlMeta } from "/app/src/client/pages/design-toc/component/editable-image-card.vue?macro=true";
import { default as energy_45info_45cardZe0wL1Sh0hMeta } from "/app/src/client/pages/design-toc/component/energy-info-card.vue?macro=true";
import { default as equip_45infoB67g4KVlKVMeta } from "/app/src/client/pages/design-toc/component/equip-info.vue?macro=true";
import { default as event_45info_45sliderUWh5m5fODMeta } from "/app/src/client/pages/design-toc/component/event-info-slide.vue?macro=true";
import { default as event_45now_45tableYrZBDTmm8rMeta } from "/app/src/client/pages/design-toc/component/event-now-table.vue?macro=true";
import { default as event_45table8wkBrFUzVOMeta } from "/app/src/client/pages/design-toc/component/event-table.vue?macro=true";
import { default as gauge_45chartE2iWyrP5lzMeta } from "/app/src/client/pages/design-toc/component/gauge-chart.vue?macro=true";
import { default as geothermal_45prod_45usage_45chart6FFLnfX2xDMeta } from "/app/src/client/pages/design-toc/component/geothermal-prod-usage-chart.vue?macro=true";
import { default as geothermal_45schematic_45card1IpONa2F0mMeta } from "/app/src/client/pages/design-toc/component/geothermal-schematic-card.vue?macro=true";
import { default as header_45slide51pgfZOgpbMeta } from "/app/src/client/pages/design-toc/component/header-slide.vue?macro=true";
import { default as info_45tapXdUbQM4t2fMeta } from "/app/src/client/pages/design-toc/component/info-tap.vue?macro=true";
import { default as install_45infoDDhax6oiRbMeta } from "/app/src/client/pages/design-toc/component/install-info.vue?macro=true";
import { default as invert_45card_45listr39qWwXKLwMeta } from "/app/src/client/pages/design-toc/component/invert-card-list.vue?macro=true";
import { default as invert_45cardfbbtvS8kegMeta } from "/app/src/client/pages/design-toc/component/invert-card.vue?macro=true";
import { default as linkage_45info_45cardjYqNsgAmWYMeta } from "/app/src/client/pages/design-toc/component/linkage-info-card.vue?macro=true";
import { default as manager_45infoJgZyZk3hYIMeta } from "/app/src/client/pages/design-toc/component/manager-info.vue?macro=true";
import { default as map_45renderO8XWhdbSBQMeta } from "/app/src/client/pages/design-toc/component/map-render.vue?macro=true";
import { default as mix_45chart_45card9NUSio9DLEMeta } from "/app/src/client/pages/design-toc/component/mix-chart-card.vue?macro=true";
import { default as owner_45info6hVUZRflSBMeta } from "/app/src/client/pages/design-toc/component/owner-info.vue?macro=true";
import { default as ownerSearchModalNO2rgA0MK6Meta } from "/app/src/client/pages/design-toc/component/ownerSearchModal.vue?macro=true";
import { default as plain_45ag_45table_45boxuf9bdvhH7AMeta } from "/app/src/client/pages/design-toc/component/plain-ag-table-box.vue?macro=true";
import { default as plain_45date_45setMoN7KgmgxNMeta } from "/app/src/client/pages/design-toc/component/plain-date-set.vue?macro=true";
import { default as prod_45chartdWvth7eMtNMeta } from "/app/src/client/pages/design-toc/component/prod-chart.vue?macro=true";
import { default as prod_45info_45chartdHMYkc8nLIMeta } from "/app/src/client/pages/design-toc/component/prod-info-chart.vue?macro=true";
import { default as prod_45info_45slideRNnTHoM9KRMeta } from "/app/src/client/pages/design-toc/component/prod-info-slide.vue?macro=true";
import { default as prod_45infoY68hdRbNcgMeta } from "/app/src/client/pages/design-toc/component/prod-info.vue?macro=true";
import { default as raw_45data_45chart_45infoE26ZGlhSgUMeta } from "/app/src/client/pages/design-toc/component/raw-data-chart-info.vue?macro=true";
import { default as raw_45data_45infoil3ymG2zUfMeta } from "/app/src/client/pages/design-toc/component/raw-data-info.vue?macro=true";
import { default as rawdata_45cardV1halDrxHXMeta } from "/app/src/client/pages/design-toc/component/rawdata-card.vue?macro=true";
import { default as rawdata_45charttukypavj95Meta } from "/app/src/client/pages/design-toc/component/rawdata-chart.vue?macro=true";
import { default as region_45rtu_45tableuvC9hX5G0nMeta } from "/app/src/client/pages/design-toc/component/region-rtu-table.vue?macro=true";
import { default as region_45setWXadh3yYymMeta } from "/app/src/client/pages/design-toc/component/region-set.vue?macro=true";
import { default as round_45chartAtYkolxcrcMeta } from "/app/src/client/pages/design-toc/component/round-chart.vue?macro=true";
import { default as rtu_45infoCzURbadPwnMeta } from "/app/src/client/pages/design-toc/component/rtu-info.vue?macro=true";
import { default as schematic_45cardLVFpunS2n0Meta } from "/app/src/client/pages/design-toc/component/schematic-card.vue?macro=true";
import { default as simple_45equip_45status3efaTh5gNjMeta } from "/app/src/client/pages/design-toc/component/simple-equip-status.vue?macro=true";
import { default as spec_45info_45tableYbcRs0wlMeMeta } from "/app/src/client/pages/design-toc/component/spec-info-table.vue?macro=true";
import { default as spec_45infoU5uyufotp1Meta } from "/app/src/client/pages/design-toc/component/spec-info.vue?macro=true";
import { default as system_45status_45cardOpY1ohjkWaMeta } from "/app/src/client/pages/design-toc/component/system-status-card.vue?macro=true";
import { default as table_45pagingnCfbPNtCYkMeta } from "/app/src/client/pages/design-toc/component/table-paging.vue?macro=true";
import { default as total_45prod_45cardpzb7F7vH6gMeta } from "/app/src/client/pages/design-toc/component/total-prod-card.vue?macro=true";
import { default as weather_45info_45card2tS6EbRzEyMeta } from "/app/src/client/pages/design-toc/component/weather-info-card.vue?macro=true";
import { default as weather_45prod_46chartVwEzD47AdzMeta } from "/app/src/client/pages/design-toc/component/weather-prod.chart.vue?macro=true";
import { default as indexGgVefTON8EMeta } from "/app/src/client/pages/design-toc/customer/index.vue?macro=true";
import { default as notice_45detailJeabwJBU7pMeta } from "/app/src/client/pages/design-toc/customer/notice-detail.vue?macro=true";
import { default as noticeNKO6ZRfgNiMeta } from "/app/src/client/pages/design-toc/customer/notice.vue?macro=true";
import { default as qna_45detailn83DfQzoYPMeta } from "/app/src/client/pages/design-toc/customer/qna-detail.vue?macro=true";
import { default as qna_45writerdiklzQ1cEMeta } from "/app/src/client/pages/design-toc/customer/qna-write.vue?macro=true";
import { default as qnaykfIOhA8wSMeta } from "/app/src/client/pages/design-toc/customer/qna.vue?macro=true";
import { default as defaultAInPN82hj7Meta } from "/app/src/client/pages/design-toc/dashboard/default.vue?macro=true";
import { default as equip_45mapSStA9QmQgUMeta } from "/app/src/client/pages/design-toc/dashboard/equip-map.vue?macro=true";
import { default as indexqeDAVdAdXqMeta } from "/app/src/client/pages/design-toc/dashboard/index.vue?macro=true";
import { default as map_45dashboardtWQxhs6PGjMeta } from "/app/src/client/pages/design-toc/dashboard/map-dashboard.vue?macro=true";
import { default as indexDoNkMFDnkWMeta } from "/app/src/client/pages/design-toc/dashboard/site/equip/index.vue?macro=true";
import { default as index9xgObzsDXzMeta } from "/app/src/client/pages/design-toc/dashboard/site/index.vue?macro=true";
import { default as dashboard3xqwMUIhjzMeta } from "/app/src/client/pages/design-toc/dashboard.vue?macro=true";
import { default as _91eventId_93cQD7WjLGmmMeta } from "/app/src/client/pages/design-toc/eventinfo/event-detail/[eventId].vue?macro=true";
import { default as eventlistQ4vfMampCEMeta } from "/app/src/client/pages/design-toc/eventinfo/eventlist.vue?macro=true";
import { default as index4A5kJAzmeXMeta } from "/app/src/client/pages/design-toc/eventinfo/index.vue?macro=true";
import { default as indexG0dkqxj3VuMeta } from "/app/src/client/pages/design-toc/index.vue?macro=true";
import { default as as_45equip_45detailrbMqVth3SfMeta } from "/app/src/client/pages/design-toc/management/as-equip-detail.vue?macro=true";
import { default as as_45equip_45infoNLhabJxTRJMeta } from "/app/src/client/pages/design-toc/management/as-equip-info.vue?macro=true";
import { default as as_45owner_45detailNjXx4VPK7uMeta } from "/app/src/client/pages/design-toc/management/as-owner-detail.vue?macro=true";
import { default as as_45owner_45infoKRU6FhcZfEMeta } from "/app/src/client/pages/design-toc/management/as-owner-info.vue?macro=true";
import { default as construction_45pdf_45progress_45modalR9yYFr7TG6Meta } from "/app/src/client/pages/design-toc/management/construction-pdf-progress-modal.vue?macro=true";
import { default as rtu_45event_45history8WSxiriZObMeta } from "/app/src/client/pages/design-toc/management/detailComponent/rtu-event-history.vue?macro=true";
import { default as work_45history_46infogVfcCWldrgMeta } from "/app/src/client/pages/design-toc/management/detailComponent/work-history.info.vue?macro=true";
import { default as work_45install_45infoyYKdSVw7lIMeta } from "/app/src/client/pages/design-toc/management/detailComponent/work-install-info.vue?macro=true";
import { default as indexkdlq2WxWgXMeta } from "/app/src/client/pages/design-toc/management/index.vue?macro=true";
import { default as installerHa6vG1j1TIMeta } from "/app/src/client/pages/design-toc/management/installer.vue?macro=true";
import { default as complement_45modaljV12VPYWLTMeta } from "/app/src/client/pages/design-toc/management/modal/complement-modal.vue?macro=true";
import { default as complete_45modalM9MjSHKgNoMeta } from "/app/src/client/pages/design-toc/management/modal/complete-modal.vue?macro=true";
import { default as installer_45req_45modaln0EX3VtDBAMeta } from "/app/src/client/pages/design-toc/management/modal/installer-req-modal.vue?macro=true";
import { default as owner_45modal0ejhg9PuNtMeta } from "/app/src/client/pages/design-toc/management/modal/owner-modal.vue?macro=true";
import { default as reset_45modalLnfhEk42HNMeta } from "/app/src/client/pages/design-toc/management/modal/reset-modal.vue?macro=true";
import { default as rtu_45chg_45modalG3N799iJWfMeta } from "/app/src/client/pages/design-toc/management/modal/rtu-chg-modal.vue?macro=true";
import { default as rtu_45sms_45modalcNtoVBOqGkMeta } from "/app/src/client/pages/design-toc/management/modal/rtu-sms-modal.vue?macro=true";
import { default as req_45detailsHN9PEGL0bMeta } from "/app/src/client/pages/design-toc/management/req-detail.vue?macro=true";
import { default as rtu_45info_45details0MQp5If2MMeta } from "/app/src/client/pages/design-toc/management/rtu-info-detail.vue?macro=true";
import { default as rtu_45infoT1ratNSEmSMeta } from "/app/src/client/pages/design-toc/management/rtu-info.vue?macro=true";
import { default as rtu_45install_45companyV5Xahk4aI0Meta } from "/app/src/client/pages/design-toc/management/rtu-install-company.vue?macro=true";
import { default as rtu_45install_45regionPkXXhFUkWoMeta } from "/app/src/client/pages/design-toc/management/rtu-install-region.vue?macro=true";
import { default as rtu_45install_45reportNKtBztNMGkMeta } from "/app/src/client/pages/design-toc/management/rtu-install-report.vue?macro=true";
import { default as rtu_45installerMIq8QiOz2DMeta } from "/app/src/client/pages/design-toc/management/rtu-installer.vue?macro=true";
import { default as indexwvq2GRzRuJMeta } from "/app/src/client/pages/design-toc/map/index.vue?macro=true";
import { default as indexynUrh6V8vmMeta } from "/app/src/client/pages/design-toc/setting/index.vue?macro=true";
import { default as settingT7nSD26frsMeta } from "/app/src/client/pages/design-toc/setting.vue?macro=true";
import { default as siteecHL6Fl0W9Meta } from "/app/src/client/pages/design-toc/site.vue?macro=true";
import { default as detail8LlGCoQOaKMeta } from "/app/src/client/pages/design-toc/sites/detail.vue?macro=true";
import { default as detail2fxGcmceo4Meta } from "/app/src/client/pages/design-toc/sites/equip/detail.vue?macro=true";
import { default as indexpa59JuyEpzMeta } from "/app/src/client/pages/design-toc/sites/equip/index.vue?macro=true";
import { default as indexf7Gb0hQhyIMeta } from "/app/src/client/pages/design-toc/sites/index.vue?macro=true";
import { default as prod_45infoFxTiLKfHYeMeta } from "/app/src/client/pages/design-toc/sites/prod-info.vue?macro=true";
import { default as indexfjgNVMrd1HMeta } from "/app/src/client/pages/design-toc/terms/index.vue?macro=true";
import { default as terms1ttUJ7FSjUaMeta } from "/app/src/client/pages/design-toc/terms/terms-list/terms1.vue?macro=true";
import { default as terms2NN2TRyEy00Meta } from "/app/src/client/pages/design-toc/terms/terms-list/terms2.vue?macro=true";
import { default as termsh1lf427VlmMeta } from "/app/src/client/pages/design-toc/terms/terms.vue?macro=true";
import { default as indexoKMCly8tx4Meta } from "/app/src/client/pages/design-toc/user-service/index.vue?macro=true";
import { default as manager_45info0RwoHnf4xCMeta } from "/app/src/client/pages/design-toc/user-service/manager-info.vue?macro=true";
import { default as confirm_45modalJlCONOWSliMeta } from "/app/src/client/pages/design-toc/user-service/modal/confirm-modal.vue?macro=true";
import { default as manager_45add_45modalp8uivch4uyMeta } from "/app/src/client/pages/design-toc/user-service/modal/manager-add-modal.vue?macro=true";
import { default as manager_45modify_45modalfjkcj0yWZmMeta } from "/app/src/client/pages/design-toc/user-service/modal/manager-modify-modal.vue?macro=true";
import { default as set_45manager_45all_45modalb984jpFvQSMeta } from "/app/src/client/pages/design-toc/user-service/modal/set-manager-all-modal.vue?macro=true";
import { default as set_45manager_45select_45modalTUCFTOMcLOMeta } from "/app/src/client/pages/design-toc/user-service/modal/set-manager-select-modal.vue?macro=true";
import { default as set_45managerHQqzYZVq9OMeta } from "/app/src/client/pages/design-toc/user-service/set-manager.vue?macro=true";
import { default as user_45infoZRxxclCgNVMeta } from "/app/src/client/pages/design-toc/user-service/user-info.vue?macro=true";
import { default as user_45setting5yq3gbt3hUMeta } from "/app/src/client/pages/design-toc/user-service/user-setting.vue?macro=true";
import { default as indexZBweQnTq6FMeta } from "/app/src/client/pages/design-toc/user/index.vue?macro=true";
import { default as loginyiMfkX8WLJMeta } from "/app/src/client/pages/design-toc/user/login.vue?macro=true";
import { default as design_45tocgeG2RHQ6fOMeta } from "/app/src/client/pages/design-toc.vue?macro=true";
import { default as erroru1QQm49Hu7Meta } from "/app/src/client/pages/error.vue?macro=true";
import { default as indexKgX6wSpKKqMeta } from "/app/src/client/pages/index.vue?macro=true";
import { default as search_45regionFvGl40tZ7gMeta } from "/app/src/client/pages/mobile/components/search-region.vue?macro=true";
import { default as error_45pagegd3QzkZlRtMeta } from "/app/src/client/pages/mobile/error-page.vue?macro=true";
import { default as rtu_45100a_45guidexxXTDs5gkhMeta } from "/app/src/client/pages/mobile/install-guide/rtu-100a-guide.vue?macro=true";
import { default as rtu_45200_45guideKZx48GzXNRMeta } from "/app/src/client/pages/mobile/install-guide/rtu-200-guide.vue?macro=true";
import { default as install_45guideMOBq51LFu0Meta } from "/app/src/client/pages/mobile/install-guide.vue?macro=true";
import { default as installer_45headerj35zyAjF1gMeta } from "/app/src/client/pages/mobile/installer/installer-header.vue?macro=true";
import { default as all_45request88LuJUN6nSMeta } from "/app/src/client/pages/mobile/installer/ownerwork/all-request.vue?macro=true";
import { default as check_45owner_45formerWNVyfsAziKMeta } from "/app/src/client/pages/mobile/installer/ownerwork/check-owner-former.vue?macro=true";
import { default as check_45owner_45map_45kakaood6t2eceSDMeta } from "/app/src/client/pages/mobile/installer/ownerwork/check-owner-map-kakao.vue?macro=true";
import { default as check_45owner_45mapAdNrdedzVHMeta } from "/app/src/client/pages/mobile/installer/ownerwork/check-owner-map.vue?macro=true";
import { default as check_45ownerMhgJTNXBoXMeta } from "/app/src/client/pages/mobile/installer/ownerwork/check-owner.vue?macro=true";
import { default as history_45requestgcpBNbRELFMeta } from "/app/src/client/pages/mobile/installer/ownerwork/history-request.vue?macro=true";
import { default as historylistuMmAbwRNSpMeta } from "/app/src/client/pages/mobile/installer/ownerwork/historylist.vue?macro=true";
import { default as indexeiO0LGCiQuMeta } from "/app/src/client/pages/mobile/installer/ownerwork/index.vue?macro=true";
import { default as ownerlistRzmkrSrCLuMeta } from "/app/src/client/pages/mobile/installer/ownerwork/ownerlist.vue?macro=true";
import { default as all_45policyBu0fBa3ehWMeta } from "/app/src/client/pages/mobile/installer/policy/all-policy.vue?macro=true";
import { default as indexE8V9GrkgZPMeta } from "/app/src/client/pages/mobile/installer/policy/index.vue?macro=true";
import { default as install_45policyEhZ8RSYwPaMeta } from "/app/src/client/pages/mobile/installer/policy/install-policy.vue?macro=true";
import { default as check6ONBUrMmyTMeta } from "/app/src/client/pages/mobile/installer/rtu-connect/check.vue?macro=true";
import { default as connectrfXg06JpAHMeta } from "/app/src/client/pages/mobile/installer/rtu-connect/connect.vue?macro=true";
import { default as indexhmGnI7bVCDMeta } from "/app/src/client/pages/mobile/installer/rtu-connect/index.vue?macro=true";
import { default as rtu_45isonB2H5FzlwluMeta } from "/app/src/client/pages/mobile/installer/rtu-connect/rtu-ison.vue?macro=true";
import { default as indexd6o5Lcf0x6Meta } from "/app/src/client/pages/mobile/installer/rtu-install/index.vue?macro=true";
import { default as installgcnCgnsrmEMeta } from "/app/src/client/pages/mobile/installer/rtu-install/install.vue?macro=true";
import { default as qr_45readerqCFUb3XO3xMeta } from "/app/src/client/pages/mobile/installer/rtu-install/qr-reader.vue?macro=true";
import { default as uninstallT0yFzqW24RMeta } from "/app/src/client/pages/mobile/installer/rtu-install/uninstall.vue?macro=true";
import { default as cmpl_workinfoUygdbbAzhrMeta } from "/app/src/client/pages/mobile/installer/workhistory/cmpl_workinfo.vue?macro=true";
import { default as indexwKKj6HNr0iMeta } from "/app/src/client/pages/mobile/installer/workhistory/index.vue?macro=true";
import { default as workinfo0fwMCbv3dTMeta } from "/app/src/client/pages/mobile/installer/workhistory/workinfo.vue?macro=true";
import { default as installerreUCNJy71YMeta } from "/app/src/client/pages/mobile/installer.vue?macro=true";
import { default as none_45contents_45page9mtv6jLHcOMeta } from "/app/src/client/pages/mobile/none-contents-page.vue?macro=true";
import { default as _250208rwWS04dcTOMeta } from "/app/src/client/pages/mobile/old-privacy-policy/250208.vue?macro=true";
import { default as old_45privacy_45policyhqEoMKZucUMeta } from "/app/src/client/pages/mobile/old-privacy-policy.vue?macro=true";
import { default as privacy_45policy8i18rpCMKzMeta } from "/app/src/client/pages/mobile/privacy-policy.vue?macro=true";
import { default as usage_45policyeH2fQENuhfMeta } from "/app/src/client/pages/mobile/usage-policy.vue?macro=true";
import { default as changePassa5jkUYfIVtMeta } from "/app/src/client/pages/mobile/user/[id]/changePass.vue?macro=true";
import { default as _10_questionUhaJztsKtuMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/10_question.vue?macro=true";
import { default as _1_serviceOverview4fAgJNtHdYMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/1_serviceOverview.vue?macro=true";
import { default as _2_statusxZmLFuxE5dMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/2_status.vue?macro=true";
import { default as _3_equipSelectYhvglSooSAMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/3_equipSelect.vue?macro=true";
import { default as _4_instruAokjzCll1UMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/4_instru.vue?macro=true";
import { default as _5_equipInfookaltzIB1MMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/5_equipInfo.vue?macro=true";
import { default as _6_eventqAFOXtSCvyMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/6_event.vue?macro=true";
import { default as _7_powerGenerationOPC5OnnsSAMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/7_powerGeneration.vue?macro=true";
import { default as _8_installInfo2WGCKhAWcUMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/8_installInfo.vue?macro=true";
import { default as _9_ownerInfoGwQYAOlyWLMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/company/9_ownerInfo.vue?macro=true";
import { default as indexdNacet36upMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/index.vue?macro=true";
import { default as _1_serviceOverviewEal3g8UmBhMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/1_serviceOverview.vue?macro=true";
import { default as _2_statusFadXcGUhj7Meta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/2_status.vue?macro=true";
import { default as _3_monitoringiLFWm9BgSzMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/3_monitoring.vue?macro=true";
import { default as _4_equipInfoJMZ4XEpxAHMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/4_equipInfo.vue?macro=true";
import { default as _5_powerGenerationQMxo83H1DsMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/5_powerGeneration.vue?macro=true";
import { default as _6_report1wZvp5N7d4Meta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/6_report.vue?macro=true";
import { default as _7_eventDgd2gt2X4jMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/7_event.vue?macro=true";
import { default as _8_ownerInfoKke0JbLevNMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/8_ownerInfo.vue?macro=true";
import { default as _9_questionMlYyxsojGOMeta } from "/app/src/client/pages/mobile/user/[id]/cs/guide/owner/9_question.vue?macro=true";
import { default as locationTermsycrGNDeCs5Meta } from "/app/src/client/pages/mobile/user/[id]/cs/locationTerms.vue?macro=true";
import { default as maincghzDswFwXMeta } from "/app/src/client/pages/mobile/user/[id]/cs/main.vue?macro=true";
import { default as locationTermsHlGfDjKnivMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms/locationTerms.vue?macro=true";
import { default as _2503141HH4IgyoWUMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms/personTerms/250314.vue?macro=true";
import { default as personTermsNS9GRhiqDbMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms/personTerms.vue?macro=true";
import { default as _250314Dh2n0VTWDeMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms/useTerms/250314.vue?macro=true";
import { default as useTerms0iVQX1KCSzMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms/useTerms.vue?macro=true";
import { default as oldTermswHlciJRmXrMeta } from "/app/src/client/pages/mobile/user/[id]/cs/oldTerms.vue?macro=true";
import { default as openSourceLKUf9m9LE7Meta } from "/app/src/client/pages/mobile/user/[id]/cs/openSource.vue?macro=true";
import { default as personTermsq0iTvkRuZSMeta } from "/app/src/client/pages/mobile/user/[id]/cs/personTerms.vue?macro=true";
import { default as questionI7dI2QticZMeta } from "/app/src/client/pages/mobile/user/[id]/cs/question.vue?macro=true";
import { default as useTermslVIazhU4o7Meta } from "/app/src/client/pages/mobile/user/[id]/cs/useTerms.vue?macro=true";
import { default as csuSGXCnJn8DMeta } from "/app/src/client/pages/mobile/user/[id]/cs.vue?macro=true";
import { default as equip_45owner_45listDQl7G2CqYeMeta } from "/app/src/client/pages/mobile/user/[id]/equip-owner-list.vue?macro=true";
import { default as equipListko84NL5Al6Meta } from "/app/src/client/pages/mobile/user/[id]/equipList.vue?macro=true";
import { default as equipMapZ2Ve56Rar8Meta } from "/app/src/client/pages/mobile/user/[id]/equipMap.vue?macro=true";
import { default as equipseAV7JZ3QwNMeta } from "/app/src/client/pages/mobile/user/[id]/equips.vue?macro=true";
import { default as alarmETCvOiJo7GuYrMeta } from "/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmETC.vue?macro=true";
import { default as alarmOBS8bJKLk3cImMeta } from "/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmOBS.vue?macro=true";
import { default as alarmRTUmq8yQInxEHMeta } from "/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmRTU.vue?macro=true";
import { default as allpKo9wqVJdeMeta } from "/app/src/client/pages/mobile/user/[id]/etc/alarm/all.vue?macro=true";
import { default as alarmdpf5LOGcrMMeta } from "/app/src/client/pages/mobile/user/[id]/etc/alarm.vue?macro=true";
import { default as _91noticeid_93HBb2dstsHqMeta } from "/app/src/client/pages/mobile/user/[id]/etc/notice/[noticeid].vue?macro=true";
import { default as indexxlXe4hF25mMeta } from "/app/src/client/pages/mobile/user/[id]/etc/notice/index.vue?macro=true";
import { default as noticeBoEVNs49J7Meta } from "/app/src/client/pages/mobile/user/[id]/etc/notice.vue?macro=true";
import { default as etcLpaOXbZJC4Meta } from "/app/src/client/pages/mobile/user/[id]/etc.vue?macro=true";
import { default as index5DGxlHQAx3Meta } from "/app/src/client/pages/mobile/user/[id]/index.vue?macro=true";
import { default as contact_45changeEAVTIKTiAVMeta } from "/app/src/client/pages/mobile/user/[id]/info/contact-change.vue?macro=true";
import { default as mainZ8720bc55AMeta } from "/app/src/client/pages/mobile/user/[id]/info/main.vue?macro=true";
import { default as pw_45change7yOdLClfHaMeta } from "/app/src/client/pages/mobile/user/[id]/info/pw-change.vue?macro=true";
import { default as user_45deleteOUrFbmh5GEMeta } from "/app/src/client/pages/mobile/user/[id]/info/user-delete.vue?macro=true";
import { default as infoIuPzo4ZYbKMeta } from "/app/src/client/pages/mobile/user/[id]/info.vue?macro=true";
import { default as settingzkUO04faLqMeta } from "/app/src/client/pages/mobile/user/[id]/setting.vue?macro=true";
import { default as siteListsYmrvNvSH6Meta } from "/app/src/client/pages/mobile/user/[id]/siteList.vue?macro=true";
import { default as users_45list16WGW1zftqMeta } from "/app/src/client/pages/mobile/user/[id]/users-list.vue?macro=true";
import { default as FailoverEditdPz42QUPHtMeta } from "/app/src/client/pages/mobile/user/[id]/views/FailoverEdit.vue?macro=true";
import { default as indexjnbdSCAwfhMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstallInfo/index.vue?macro=true";
import { default as InstallInfoSCoQjQxhVDMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstallInfo.vue?macro=true";
import { default as chartPCwUz3Qq4cMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo/chart.vue?macro=true";
import { default as now5nOOXViatqMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo/now.vue?macro=true";
import { default as InstruInfolCQzttoBnxMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo.vue?macro=true";
import { default as index9gC8J1d1FyMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/index.vue?macro=true";
import { default as ess29N7ZiWh1rMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess.vue?macro=true";
import { default as indexGp8J0Ohat7Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstallInfo/index.vue?macro=true";
import { default as InstallInfoSOL8OMaZPGMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstallInfo.vue?macro=true";
import { default as chartxlXkv5Ctd3Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo/chart.vue?macro=true";
import { default as nowCZV6vGlFivMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo/now.vue?macro=true";
import { default as InstruInfoz8FdG2gKksMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo.vue?macro=true";
import { default as indexNSWRw01f5qMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/index.vue?macro=true";
import { default as fuelcell0UmRTgXimdMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell.vue?macro=true";
import { default as installV0g3gl4PVZMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo/install.vue?macro=true";
import { default as managerFIRdyUC3wpMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo/manager.vue?macro=true";
import { default as InstallInfoiZxbvLV3p3Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo.vue?macro=true";
import { default as chartUzQkJLj0UXMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo/chart.vue?macro=true";
import { default as nowh2TgZ792anMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo/now.vue?macro=true";
import { default as InstruInfoZueZdDK2QpMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo.vue?macro=true";
import { default as rtuMFOdbC2BHoMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo/rtu.vue?macro=true";
import { default as specZjMHtaCHhzMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo/spec.vue?macro=true";
import { default as SpecInfoWctTfs4VYMMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo.vue?macro=true";
import { default as geo0eOUKSHfxlMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo.vue?macro=true";
import { default as installKCshUDarkyMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo/install.vue?macro=true";
import { default as managerCPaRTXz4ogMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo/manager.vue?macro=true";
import { default as InstallInfoQmXG4Wqob3Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo.vue?macro=true";
import { default as chartuzS9UiCmy5Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo/chart.vue?macro=true";
import { default as nowvk6GPxh59FMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo/now.vue?macro=true";
import { default as InstruInfo2CASGnKrWMMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo.vue?macro=true";
import { default as rtukv2qCoOLZtMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo/rtu.vue?macro=true";
import { default as specZNqZc5JK57Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo/spec.vue?macro=true";
import { default as SpecInfo7PJO9Ztg3mMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo.vue?macro=true";
import { default as pvexD2ZMAQmfMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv.vue?macro=true";
import { default as installiUjcf24s0AMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo/install.vue?macro=true";
import { default as managerfo4oRVfk6FMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo/manager.vue?macro=true";
import { default as InstallInfosk1jaeYwBxMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo.vue?macro=true";
import { default as chartHaAaC2qj5JMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo/chart.vue?macro=true";
import { default as nowQys5c7gXNLMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo/now.vue?macro=true";
import { default as InstruInfopgFn8JEgf0Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo.vue?macro=true";
import { default as rtu9lAfIt83KFMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo/rtu.vue?macro=true";
import { default as spechM2v445rRuMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo/spec.vue?macro=true";
import { default as SpecInfotr8YVg17r3Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo.vue?macro=true";
import { default as solarheatcMxzJDauprMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat.vue?macro=true";
import { default as index29V72ffyz3Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstallInfo/index.vue?macro=true";
import { default as InstallInfoSyB30KMCaJMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstallInfo.vue?macro=true";
import { default as chartGQfRpICnAlMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo/chart.vue?macro=true";
import { default as nowe15Vw0ZAzDMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo/now.vue?macro=true";
import { default as InstruInfoa0viLaWHKwMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo.vue?macro=true";
import { default as index9hW5rA0fqOMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/index.vue?macro=true";
import { default as wf5OeLTQXOHUMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf.vue?macro=true";
import { default as indexIXxoE27wd0Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstallInfo/index.vue?macro=true";
import { default as InstallInfos59l9Z6JVXMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstallInfo.vue?macro=true";
import { default as chartlidyWJbiicMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo/chart.vue?macro=true";
import { default as now45iDhU7J4HMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo/now.vue?macro=true";
import { default as InstruInfo4GEkXYelnlMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo.vue?macro=true";
import { default as indexT0TRoqLjhmMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/index.vue?macro=true";
import { default as esszz4qViiwfsMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess.vue?macro=true";
import { default as index9iLvWRi4WSMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstallInfo/index.vue?macro=true";
import { default as InstallInfokiL2WDfGiXMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstallInfo.vue?macro=true";
import { default as chartSGCbTC3alcMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo/chart.vue?macro=true";
import { default as nowAVDMgeJsVjMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo/now.vue?macro=true";
import { default as InstruInfoWQpnXK6yCJMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo.vue?macro=true";
import { default as indexKutBRsIvqAMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/index.vue?macro=true";
import { default as fuelcellIP0L82YMVeMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell.vue?macro=true";
import { default as installAWFWcJTgf6Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo/install.vue?macro=true";
import { default as managerYU4RNCpZXFMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo/manager.vue?macro=true";
import { default as InstallInfoEuQCZuO8hRMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo.vue?macro=true";
import { default as chartama5HOwZaFMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo/chart.vue?macro=true";
import { default as now4iLwoxQkFKMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo/now.vue?macro=true";
import { default as InstruInfoahRdT9FihrMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo.vue?macro=true";
import { default as indexM38GfIN34KMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/index.vue?macro=true";
import { default as rtueb1aE0ySDLMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/rtu.vue?macro=true";
import { default as specLIm9El39UXMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/spec.vue?macro=true";
import { default as geo2lun2n81PVMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo.vue?macro=true";
import { default as installZSIj55JUIyMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo/install.vue?macro=true";
import { default as managerYau2lDOlZfMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo/manager.vue?macro=true";
import { default as InstallInfo9CuHGW3pqfMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo.vue?macro=true";
import { default as charto3v4YLhsMlMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/chart.vue?macro=true";
import { default as instruinfo_45rawdatayrZlH8oBJxMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/instruinfo-rawdata.vue?macro=true";
import { default as nowgs9T6vWk36Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/now.vue?macro=true";
import { default as InstruInfohCHvPu2apPMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo.vue?macro=true";
import { default as indexNBtapoBwxXMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/index.vue?macro=true";
import { default as rtuMzDt7jQR6vMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/rtu.vue?macro=true";
import { default as specn9kdAIPRcMMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/spec.vue?macro=true";
import { default as pvY9U64PkXxVMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv.vue?macro=true";
import { default as installAuV6NSv9GTMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo/install.vue?macro=true";
import { default as managerOr7AeD2AV6Meta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo/manager.vue?macro=true";
import { default as InstallInfoCkCMhFBXQRMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo.vue?macro=true";
import { default as chartu81clMuhepMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/chart.vue?macro=true";
import { default as indexuU58h0aQbfMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/index.vue?macro=true";
import { default as nowQvVZ6LXD5XMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/now.vue?macro=true";
import { default as InstruInfoTVHlDbKQcKMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo.vue?macro=true";
import { default as indexhtJ4Yo4fIEMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/index.vue?macro=true";
import { default as rtuZPz1kE6hSBMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/rtu.vue?macro=true";
import { default as speckAJmWN15pFMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/spec.vue?macro=true";
import { default as solarheat9FVmUtVm9XMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat.vue?macro=true";
import { default as indexbF5463gc7dMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstallInfo/index.vue?macro=true";
import { default as InstallInfoLzgS4c5oZOMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstallInfo.vue?macro=true";
import { default as chartg0MmcZcq1TMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo/chart.vue?macro=true";
import { default as nowTPgCuIND4pMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo/now.vue?macro=true";
import { default as InstruInfou3KIf9hA3nMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo.vue?macro=true";
import { default as indexwQn6usTnDrMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/index.vue?macro=true";
import { default as wfV8lH7QrPCqMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf.vue?macro=true";
import { default as equipInfogzGiusuikAMeta } from "/app/src/client/pages/mobile/user/[id]/views/equipInfo.vue?macro=true";
import { default as FailoverUnU9JMLC5UMeta } from "/app/src/client/pages/mobile/user/[id]/views/event/Failover.vue?macro=true";
import { default as FailureZ8yMCqiawtMeta } from "/app/src/client/pages/mobile/user/[id]/views/event/Failure.vue?macro=true";
import { default as allOJFFiPHoKBMeta } from "/app/src/client/pages/mobile/user/[id]/views/event/all.vue?macro=true";
import { default as eventHistory4A5SIUSq9hMeta } from "/app/src/client/pages/mobile/user/[id]/views/event/eventHistory.vue?macro=true";
import { default as rtuEventyp9TVkEYs8Meta } from "/app/src/client/pages/mobile/user/[id]/views/event/rtuEvent.vue?macro=true";
import { default as eventYU5lQ9KjzTMeta } from "/app/src/client/pages/mobile/user/[id]/views/event.vue?macro=true";
import { default as essVHuR8v64iJMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/ess.vue?macro=true";
import { default as fuelcellz2BbkeNLu1Meta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/fuelcell.vue?macro=true";
import { default as geoRCJjOSXlrUMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/geo.vue?macro=true";
import { default as pvxX8D5sRrfBMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/pv.vue?macro=true";
import { default as solarheatojqsLDG2gBMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/solarheat.vue?macro=true";
import { default as wfCjKnxSvDYNMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring/wf.vue?macro=true";
import { default as monitoringtKEmCBOlH5Meta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring.vue?macro=true";
import { default as monitoring_testKoT8seb0XFMeta } from "/app/src/client/pages/mobile/user/[id]/views/monitoring_test.vue?macro=true";
import { default as InstallInfogv8XlDmHO3Meta } from "/app/src/client/pages/mobile/user/[id]/views/more/InstallInfo.vue?macro=true";
import { default as contractsxEEeAZpi30Meta } from "/app/src/client/pages/mobile/user/[id]/views/more/contracts.vue?macro=true";
import { default as geoNFXLkYMBwRMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/indicators/geo.vue?macro=true";
import { default as pvhTgBMnvEfyMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/indicators/pv.vue?macro=true";
import { default as solarheatgzG2mBgtHoMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/indicators/solarheat.vue?macro=true";
import { default as indicatorslTBHwmVNA7Meta } from "/app/src/client/pages/mobile/user/[id]/views/more/indicators.vue?macro=true";
import { default as changeOwnerListGxWOUW5pdMMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/changeOwnerList.vue?macro=true";
import { default as indexAxN9x43NtkMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/index.vue?macro=true";
import { default as installerConfirmeRcdBOlWi9Meta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirm.vue?macro=true";
import { default as installerConfirmDetail3FPUJQoDy7Meta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmDetail.vue?macro=true";
import { default as installerConfirmHistoryBVOEkNJ5tHMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmHistory.vue?macro=true";
import { default as installerConfirmRequest8uZrcmp4GlMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmRequest.vue?macro=true";
import { default as menugoSDo9KwhpMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/menu.vue?macro=true";
import { default as _91noticeid_93BwZ5sVKBtwMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/menuToNotice/[noticeid].vue?macro=true";
import { default as ownerInfogdIt45mWisMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/ownerInfo.vue?macro=true";
import { default as predictedPowerxCoNgTtD3jMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/predictedPower.vue?macro=true";
import { default as siteInfo3rKAuABNMyMeta } from "/app/src/client/pages/mobile/user/[id]/views/more/siteInfo.vue?macro=true";
import { default as more1xCZhk6kImMeta } from "/app/src/client/pages/mobile/user/[id]/views/more.vue?macro=true";
import { default as essssFYC19flxMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/ess.vue?macro=true";
import { default as fuelcellj0VexK96PlMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/fuelcell.vue?macro=true";
import { default as geo3AXsqr6wBmMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/geo.vue?macro=true";
import { default as pvrAuxcRX4hOMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/pv.vue?macro=true";
import { default as solarheatVjV095UmPhMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/solarheat.vue?macro=true";
import { default as wfTjbvvX6V6VMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration/wf.vue?macro=true";
import { default as powerGenerationSxzCnLIvpcMeta } from "/app/src/client/pages/mobile/user/[id]/views/powerGeneration.vue?macro=true";
import { default as geoULoa8dMqgiMeta } from "/app/src/client/pages/mobile/user/[id]/views/report/geo.vue?macro=true";
import { default as pvuerSFRiCxLMeta } from "/app/src/client/pages/mobile/user/[id]/views/report/pv.vue?macro=true";
import { default as solarheatPaBz7oozmXMeta } from "/app/src/client/pages/mobile/user/[id]/views/report/solarheat.vue?macro=true";
import { default as reportjFIXpSqMrSMeta } from "/app/src/client/pages/mobile/user/[id]/views/report.vue?macro=true";
import { default as pvkmw8RnaW27Meta } from "/app/src/client/pages/mobile/user/[id]/views/reportPDF/pv.vue?macro=true";
import { default as reportPDFj4ZWiBewIDMeta } from "/app/src/client/pages/mobile/user/[id]/views/reportPDF.vue?macro=true";
import { default as statusv9FFWoeKv3Meta } from "/app/src/client/pages/mobile/user/[id]/views/status.vue?macro=true";
import { default as viewsTgO1hONktvMeta } from "/app/src/client/pages/mobile/user/[id]/views.vue?macro=true";
import { default as _91id_93j66U11xk1tMeta } from "/app/src/client/pages/mobile/user/[id].vue?macro=true";
import { default as doneFindidXB5xXJ1SjyMeta } from "/app/src/client/pages/mobile/user/finduser/doneFindid.vue?macro=true";
import { default as doneFindpassrCDDd63g03Meta } from "/app/src/client/pages/mobile/user/finduser/doneFindpass.vue?macro=true";
import { default as findidiEdh8BqGTbMeta } from "/app/src/client/pages/mobile/user/finduser/findid.vue?macro=true";
import { default as findpassJPUBsYtZz9Meta } from "/app/src/client/pages/mobile/user/finduser/findpass.vue?macro=true";
import { default as finduser1LGhhE9mJgMeta } from "/app/src/client/pages/mobile/user/finduser.vue?macro=true";
import { default as introRJNIMvgIDoMeta } from "/app/src/client/pages/mobile/user/intro.vue?macro=true";
import { default as loginrDUoUsXnwcMeta } from "/app/src/client/pages/mobile/user/login.vue?macro=true";
import { default as logoutwQZ9g2XbjAMeta } from "/app/src/client/pages/mobile/user/logout.vue?macro=true";
import { default as personTermsIjzMQKOHODMeta } from "/app/src/client/pages/mobile/user/signin/personTerms.vue?macro=true";
import { default as termOC8rNE4AElMeta } from "/app/src/client/pages/mobile/user/signin/term.vue?macro=true";
import { default as useTerms1mhkKmnBrZMeta } from "/app/src/client/pages/mobile/user/signin/useTerms.vue?macro=true";
import { default as signinnIEp8PzLseMeta } from "/app/src/client/pages/mobile/user/signin.vue?macro=true";
import { default as userP7Jquh6C14Meta } from "/app/src/client/pages/mobile/user.vue?macro=true";
import { default as mobilerx7WDqPN3bMeta } from "/app/src/client/pages/mobile.vue?macro=true";
import { default as swagger_45uiHGOjzT6Py4Meta } from "/app/src/client/pages/swagger-ui.vue?macro=true";
import { default as geowFZo9UadM0Meta } from "/app/src/client/pages/test/geo.vue?macro=true";
import { default as loginA02WcsSjBGMeta } from "/app/src/client/pages/test/login.vue?macro=true";
import { default as mainLz9O4UYe9PMeta } from "/app/src/client/pages/test/main.vue?macro=true";
import { default as qrcode0MRjuisfOHMeta } from "/app/src/client/pages/test/qrcode.vue?macro=true";
import { default as qrtestosfshLcHizMeta } from "/app/src/client/pages/test/qrtest.vue?macro=true";
import { default as compare_45ownerREcV2U89V3Meta } from "/app/src/client/pages/toc/analysis/compare-owner.vue?macro=true";
import { default as compare_45region1piR78OrYZMeta } from "/app/src/client/pages/toc/analysis/compare-region.vue?macro=true";
import { default as geoFy7ugrnLBMMeta } from "/app/src/client/pages/toc/analysis/component/geo.vue?macro=true";
import { default as ownerSearchModalumHUBtK2SiMeta } from "/app/src/client/pages/toc/analysis/component/ownerSearchModal.vue?macro=true";
import { default as pv9ZYdHtBDoTMeta } from "/app/src/client/pages/toc/analysis/component/pv.vue?macro=true";
import { default as solarheatPNIelAfq80Meta } from "/app/src/client/pages/toc/analysis/component/solarheat.vue?macro=true";
import { default as owner2KnuIa4CctMeta } from "/app/src/client/pages/toc/analysis/owner.vue?macro=true";
import { default as analysisV40t4ezNkuMeta } from "/app/src/client/pages/toc/analysis.vue?macro=true";
import { default as Energy_45ListlkBcvyNijKMeta } from "/app/src/client/pages/toc/component/Dashboard/Energy-List.vue?macro=true";
import { default as card_45base5NQrwo7IcIMeta } from "/app/src/client/pages/toc/component/Dashboard/card-base.vue?macro=true";
import { default as energy_45cardvSiztHtrWrMeta } from "/app/src/client/pages/toc/component/Dashboard/energy-card.vue?macro=true";
import { default as energy_45card2ZXKdzrj1oeMeta } from "/app/src/client/pages/toc/component/Dashboard/energy-card2.vue?macro=true";
import { default as info_45card8M5WadTLAEMeta } from "/app/src/client/pages/toc/component/Dashboard/info-card.vue?macro=true";
import { default as link_45rate_45card6TZBPloFCGMeta } from "/app/src/client/pages/toc/component/Dashboard/link-rate-card.vue?macro=true";
import { default as FileUploadBFXJ6by9kPMeta } from "/app/src/client/pages/toc/component/FileUpload.vue?macro=true";
import { default as indexwpcWiiAdk0Meta } from "/app/src/client/pages/toc/component/InstallInfo/index.vue?macro=true";
import { default as pvjWo2DscdXHMeta } from "/app/src/client/pages/toc/component/InstallInfo/pv.vue?macro=true";
import { default as solarheatZHkxgGHwdZMeta } from "/app/src/client/pages/toc/component/InstallInfo/solarheat.vue?macro=true";
import { default as pvEMEODNvJmWMeta } from "/app/src/client/pages/toc/component/InstruInfo/pv.vue?macro=true";
import { default as indexw0HxA1k91XMeta } from "/app/src/client/pages/toc/component/ManagerInfo/index.vue?macro=true";
import { default as pvCrjeKNE9jbMeta } from "/app/src/client/pages/toc/component/ManagerInfo/pv.vue?macro=true";
import { default as solarheathi4AU9vrkgMeta } from "/app/src/client/pages/toc/component/ManagerInfo/solarheat.vue?macro=true";
import { default as pvt2t8OQsVS4Meta } from "/app/src/client/pages/toc/component/OwnerInfo/ManagerInfo/pv.vue?macro=true";
import { default as solarheatnx8xMyYiItMeta } from "/app/src/client/pages/toc/component/OwnerInfo/ManagerInfo/solarheat.vue?macro=true";
import { default as index1VnMCWuLWxMeta } from "/app/src/client/pages/toc/component/OwnerInfo/index.vue?macro=true";
import { default as pvFYx95WluolMeta } from "/app/src/client/pages/toc/component/OwnerInfo/pv.vue?macro=true";
import { default as solar9NLBST37DwMeta } from "/app/src/client/pages/toc/component/OwnerInfo/solar.vue?macro=true";
import { default as indexwj8wQSEIGSMeta } from "/app/src/client/pages/toc/component/RtuInfo/index.vue?macro=true";
import { default as common_45code_45dropdownAEtlgs4XmBMeta } from "/app/src/client/pages/toc/component/SearchBox/common-code-dropdown.vue?macro=true";
import { default as date_45set_45reportEiVIE8oOD3Meta } from "/app/src/client/pages/toc/component/SearchBox/date-set-report.vue?macro=true";
import { default as date_45setTHTzvwxslUMeta } from "/app/src/client/pages/toc/component/SearchBox/date-set.vue?macro=true";
import { default as plain_45date_45setjZyPEn09YgMeta } from "/app/src/client/pages/toc/component/SearchBox/plain-date-set.vue?macro=true";
import { default as region_45setajDBOA3J3BMeta } from "/app/src/client/pages/toc/component/SearchBox/region-set.vue?macro=true";
import { default as geoYeV2nIPQRmMeta } from "/app/src/client/pages/toc/component/SpecInfo/geo.vue?macro=true";
import { default as pvhQljqa5Q8gMeta } from "/app/src/client/pages/toc/component/SpecInfo/pv.vue?macro=true";
import { default as solarheatnsB7uGr7DTMeta } from "/app/src/client/pages/toc/component/SpecInfo/solarheat.vue?macro=true";
import { default as Table_45BoxiZEJQwuJkvMeta } from "/app/src/client/pages/toc/component/Table-Box.vue?macro=true";
import { default as api_45search_45box6pvbqi0Rt8Meta } from "/app/src/client/pages/toc/component/api-search-box.vue?macro=true";
import { default as data_45tableIG3HUIuZNnMeta } from "/app/src/client/pages/toc/component/data-table.vue?macro=true";
import { default as event_45search_45gridxXrzTSCAk9Meta } from "/app/src/client/pages/toc/component/event-search-grid.vue?macro=true";
import { default as info_45boxUnyKmQqWB0Meta } from "/app/src/client/pages/toc/component/info-box.vue?macro=true";
import { default as plain_45search_45boxViL2mgKQGZMeta } from "/app/src/client/pages/toc/component/plain-search-box.vue?macro=true";
import { default as region_45selectYyhuaOoRg8Meta } from "/app/src/client/pages/toc/component/region-select.vue?macro=true";
import { default as search_45boxrj545dRYokMeta } from "/app/src/client/pages/toc/component/search-box.vue?macro=true";
import { default as table_45pagingRd9YzmQWp0Meta } from "/app/src/client/pages/toc/component/table-paging.vue?macro=true";
import { default as toc_45templateYD5sOfSTlmMeta } from "/app/src/client/pages/toc/component/template/toc-template.vue?macro=true";
import { default as test_45grid6ja8QqbtUqMeta } from "/app/src/client/pages/toc/component/test-grid.vue?macro=true";
import { default as _91id_937pcLoLwkWRMeta } from "/app/src/client/pages/toc/customer/faq/[id].vue?macro=true";
import { default as index2l9RlEWuDcMeta } from "/app/src/client/pages/toc/customer/faq/index.vue?macro=true";
import { default as faq_companyyKRJvVBVZZMeta } from "/app/src/client/pages/toc/customer/faq_company.vue?macro=true";
import { default as login_45termsbrwmNGwtqhMeta } from "/app/src/client/pages/toc/customer/login-terms.vue?macro=true";
import { default as _91id_93qj3MdQcdYPMeta } from "/app/src/client/pages/toc/customer/notice/[id].vue?macro=true";
import { default as index1yVUukORuKMeta } from "/app/src/client/pages/toc/customer/notice/index.vue?macro=true";
import { default as noticeH3HTs7zw5YMeta } from "/app/src/client/pages/toc/customer/notice.vue?macro=true";
import { default as _91id_93NqfjpqEVDOMeta } from "/app/src/client/pages/toc/customer/qna/[id].vue?macro=true";
import { default as addaBndsbcdE0Meta } from "/app/src/client/pages/toc/customer/qna/add.vue?macro=true";
import { default as indexMrL2kx6htIMeta } from "/app/src/client/pages/toc/customer/qna/index.vue?macro=true";
import { default as qna1jX9EF711KMeta } from "/app/src/client/pages/toc/customer/qna.vue?macro=true";
import { default as _91id_93HFrk4JGRN7Meta } from "/app/src/client/pages/toc/customer/reference/[id].vue?macro=true";
import { default as indexRXApMp6VDRMeta } from "/app/src/client/pages/toc/customer/reference/index.vue?macro=true";
import { default as referenceDfOwQGHTtyMeta } from "/app/src/client/pages/toc/customer/reference.vue?macro=true";
import { default as terms1dzOWJxIguOMeta } from "/app/src/client/pages/toc/customer/terms-list/terms1.vue?macro=true";
import { default as terms2DvYPppf15KMeta } from "/app/src/client/pages/toc/customer/terms-list/terms2.vue?macro=true";
import { default as termsGc1OpbLz5MMeta } from "/app/src/client/pages/toc/customer/terms.vue?macro=true";
import { default as customerTVXLAru08XMeta } from "/app/src/client/pages/toc/customer.vue?macro=true";
import { default as geo_45prod_45cardaM73Tp5ZdBMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-prod-card.vue?macro=true";
import { default as geo_45prod_45chartihws93A6wCMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-prod-chart.vue?macro=true";
import { default as geo_45usage_45cardXoyoxJFesvMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-usage-card.vue?macro=true";
import { default as geo_45usage_45chartLOhWX0zyeIMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-usage-chart.vue?macro=true";
import { default as raw_45data_45chartyGDhcseML2Meta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/raw-data-chart.vue?macro=true";
import { default as raw_45data_45infoRkv8S6Z9vqMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/raw-data-info.vue?macro=true";
import { default as solarheat_45prod_45cardC9tk04myUnMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-prod-card.vue?macro=true";
import { default as solarheat_45prod_45chartYKUVhvMSfYMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-prod-chart.vue?macro=true";
import { default as solarheat_45usage_45cardmDwGnB40hZMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-usage-card.vue?macro=true";
import { default as solarheat_45usage_45chartoBgjKwlMv8Meta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-usage-chart.vue?macro=true";
import { default as geo_45prodnFoZHqX169Meta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo-prod.vue?macro=true";
import { default as geo_45usageoUvOl8pJRzMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo-usage.vue?macro=true";
import { default as geoGETsmGVTbfMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo.vue?macro=true";
import { default as pvtTEFRi55OYMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/pv.vue?macro=true";
import { default as solarheatncph8OKdDpMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/solarheat.vue?macro=true";
import { default as _91cid_932B48DwJmLPMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid].vue?macro=true";
import { default as equip_45detailkGGa0mwPIOMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-detail.vue?macro=true";
import { default as equip_45list7PxcA0qV7bMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-list.vue?macro=true";
import { default as equip_45mapVyAySJchiQMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/equip-map.vue?macro=true";
import { default as measureo5Q3ZCMEKGMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/measure.vue?macro=true";
import { default as monitoring_45mapojZPJMa2UYMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/monitoring-map.vue?macro=true";
import { default as indexbWO8sybH7BMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/power-generate/index.vue?macro=true";
import { default as power_45generatesfCHX7KiHWMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/power-generate.vue?macro=true";
import { default as rtu7q0sGTBAbpMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/rtu.vue?macro=true";
import { default as geo4Td68yrpqoMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/geo.vue?macro=true";
import { default as pvmG7KI09NT9Meta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/pv.vue?macro=true";
import { default as solarheatqw2dqJ2EuWMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/solarheat.vue?macro=true";
import { default as geojuDjGvOX47Meta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/geo.vue?macro=true";
import { default as pvOrKOg5LvDXMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/pv.vue?macro=true";
import { default as solarheatMe6YgBS1EDMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/solarheat.vue?macro=true";
import { default as _91sitename_93wMsXHZRfPdMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename].vue?macro=true";
import { default as indexgyNLtITETRMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/index.vue?macro=true";
import { default as _91newsitename_93HKfYFd4AszMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site/test/[newsitename].vue?macro=true";
import { default as siteC23kAPScFAMeta } from "/app/src/client/pages/toc/equip/[pathinfo]/site.vue?macro=true";
import { default as equipnBhvoO3FtOMeta } from "/app/src/client/pages/toc/equip.vue?macro=true";
import { default as equipinfoOXbPvtEFJ7Meta } from "/app/src/client/pages/toc/equipinfo.vue?macro=true";
import { default as errorIdztcyDUpbMeta } from "/app/src/client/pages/toc/error.vue?macro=true";
import { default as _91eventId_93QMnfWb99bRMeta } from "/app/src/client/pages/toc/event/event-list/[eventId].vue?macro=true";
import { default as event_45listnNFIELmhBzMeta } from "/app/src/client/pages/toc/event/event-list.vue?macro=true";
import { default as index0LTps87GEOMeta } from "/app/src/client/pages/toc/event/index.vue?macro=true";
import { default as eventnmy4yXKqpRMeta } from "/app/src/client/pages/toc/event.vue?macro=true";
import { default as installXNKiQBGNQ6Meta } from "/app/src/client/pages/toc/install.vue?macro=true";
import { default as addraTcmAHHSOMeta } from "/app/src/client/pages/toc/inventory/equip-company/add.vue?macro=true";
import { default as productHkkDzNh0eTMeta } from "/app/src/client/pages/toc/inventory/equip-company/product.vue?macro=true";
import { default as inventorypDiQA2qar2Meta } from "/app/src/client/pages/toc/inventory.vue?macro=true";
import { default as maintainencemMWyEF6YV0Meta } from "/app/src/client/pages/toc/maintainence.vue?macro=true";
import { default as bpm_45detailE3kauLIG5MMeta } from "/app/src/client/pages/toc/management/bpm/bpm-detail.vue?macro=true";
import { default as bpm_45table_45boxMgddtumOUOMeta } from "/app/src/client/pages/toc/management/bpm/bpm-table-box.vue?macro=true";
import { default as bpm_45upload_45modalOrJUfjAKxUMeta } from "/app/src/client/pages/toc/management/bpm/bpm-upload-modal.vue?macro=true";
import { default as bpm_45upload_45progress_45modalykw7kHa8EdMeta } from "/app/src/client/pages/toc/management/bpm/bpm-upload-progress-modal.vue?macro=true";
import { default as indexWvqql8GP4DMeta } from "/app/src/client/pages/toc/management/bpm/index.vue?macro=true";
import { default as bpm9roC7nJsEwMeta } from "/app/src/client/pages/toc/management/bpm.vue?macro=true";
import { default as adddXxCNB7oHQMeta } from "/app/src/client/pages/toc/management/company/add.vue?macro=true";
import { default as indexqXGzHKqEaZMeta } from "/app/src/client/pages/toc/management/company/index.vue?macro=true";
import { default as companywmmz7UHNiVMeta } from "/app/src/client/pages/toc/management/company.vue?macro=true";
import { default as equip_45modelFJz4rL4nDaMeta } from "/app/src/client/pages/toc/management/equip-model.vue?macro=true";
import { default as find_45ownerW7nhZrwEEKMeta } from "/app/src/client/pages/toc/management/equip/add/find-owner.vue?macro=true";
import { default as geo_45specibPgG65rjAMeta } from "/app/src/client/pages/toc/management/equip/add/geo-spec.vue?macro=true";
import { default as pv_45specy5YVNMTNKMMeta } from "/app/src/client/pages/toc/management/equip/add/pv-spec.vue?macro=true";
import { default as solarheat_45specjNywurCmLkMeta } from "/app/src/client/pages/toc/management/equip/add/solarheat-spec.vue?macro=true";
import { default as addw1oY11yl7AMeta } from "/app/src/client/pages/toc/management/equip/add.vue?macro=true";
import { default as indexW3qWgZaYdJMeta } from "/app/src/client/pages/toc/management/equip/index.vue?macro=true";
import { default as equipfeysV7ejlNMeta } from "/app/src/client/pages/toc/management/equip.vue?macro=true";
import { default as indexdtOUXrczAAMeta } from "/app/src/client/pages/toc/management/installer/index.vue?macro=true";
import { default as installer_45req_45modalbJLgqZaD3uMeta } from "/app/src/client/pages/toc/management/installer/installer-req-modal.vue?macro=true";
import { default as installerq33YFabtq3Meta } from "/app/src/client/pages/toc/management/installer.vue?macro=true";
import { default as management46Qxl8286WMeta } from "/app/src/client/pages/toc/management/management.vue?macro=true";
import { default as indexx4KtKwuOODMeta } from "/app/src/client/pages/toc/management/manager/index.vue?macro=true";
import { default as noticeHkpQYwJNBTMeta } from "/app/src/client/pages/toc/management/notice.vue?macro=true";
import { default as add_45componentyew87FOYHxMeta } from "/app/src/client/pages/toc/management/owner/add-component.vue?macro=true";
import { default as add0MTaf7pJXhMeta } from "/app/src/client/pages/toc/management/owner/add.vue?macro=true";
import { default as indexyrePqMXEfJMeta } from "/app/src/client/pages/toc/management/owner/index.vue?macro=true";
import { default as owner3BOLtxAD17Meta } from "/app/src/client/pages/toc/management/owner.vue?macro=true";
import { default as indexyxGyHuMsBUMeta } from "/app/src/client/pages/toc/management/permit/index.vue?macro=true";
import { default as permitI7OLVj90JSMeta } from "/app/src/client/pages/toc/management/permit.vue?macro=true";
import { default as indexjRJkPjfhwdMeta } from "/app/src/client/pages/toc/management/rtu-oper/index.vue?macro=true";
import { default as send_45rems_45modalKYoz0J17WoMeta } from "/app/src/client/pages/toc/management/rtu-oper/send-rems-modal.vue?macro=true";
import { default as rtu_45operZPRnPPQngKMeta } from "/app/src/client/pages/toc/management/rtu-oper.vue?macro=true";
import { default as operator5p4HcVJ0AmMeta } from "/app/src/client/pages/toc/member/operator.vue?macro=true";
import { default as geoDjHJsxgcSgMeta } from "/app/src/client/pages/toc/member/owner-member/[id]/geo.vue?macro=true";
import { default as pvfmb9LS4YLKMeta } from "/app/src/client/pages/toc/member/owner-member/[id]/pv.vue?macro=true";
import { default as solarheatFAwHrRvuxSMeta } from "/app/src/client/pages/toc/member/owner-member/[id]/solarheat.vue?macro=true";
import { default as _91id_93r9lTpKGJE5Meta } from "/app/src/client/pages/toc/member/owner-member/[id].vue?macro=true";
import { default as owner_45registS00Zc5AyC6Meta } from "/app/src/client/pages/toc/member/owner-member/owner-regist.vue?macro=true";
import { default as owner_45searchbFec8NN4ICMeta } from "/app/src/client/pages/toc/member/owner-member/owner-search.vue?macro=true";
import { default as ownerZuCUCc0MbyMeta } from "/app/src/client/pages/toc/member/owner.vue?macro=true";
import { default as systemsGq3gUaPQEMeta } from "/app/src/client/pages/toc/member/system.vue?macro=true";
import { default as memberY5S10LujOjMeta } from "/app/src/client/pages/toc/member.vue?macro=true";
import { default as alarm_45sendingoVVnHCubmHMeta } from "/app/src/client/pages/toc/message/alarm-sending.vue?macro=true";
import { default as email_45sending7GCBLiLuGeMeta } from "/app/src/client/pages/toc/message/email-sending.vue?macro=true";
import { default as messagegGle26j6NoMeta } from "/app/src/client/pages/toc/message.vue?macro=true";
import { default as comprehensive_45slidefjwtxgogEMMeta } from "/app/src/client/pages/toc/monitoring/comprehensive-slide.vue?macro=true";
import { default as dashboardOQu0MPO9FSMeta } from "/app/src/client/pages/toc/monitoring/dashboard.vue?macro=true";
import { default as equip_dashboardciTMMCgnkxMeta } from "/app/src/client/pages/toc/monitoring/equip_dashboard.vue?macro=true";
import { default as newDashboardgPy5ZC8ctKMeta } from "/app/src/client/pages/toc/monitoring/newDashboard.vue?macro=true";
import { default as prod_45slideqscf4zBUKIMeta } from "/app/src/client/pages/toc/monitoring/prod-slide.vue?macro=true";
import { default as temp_newDashboardFRjOIADYneMeta } from "/app/src/client/pages/toc/monitoring/temp_newDashboard.vue?macro=true";
import { default as monitoringYDLAykCA3fMeta } from "/app/src/client/pages/toc/monitoring.vue?macro=true";
import { default as not_45foundeAtdoFsRPMMeta } from "/app/src/client/pages/toc/not-found.vue?macro=true";
import { default as operate2hQ0mZx4rXMeta } from "/app/src/client/pages/toc/operate.vue?macro=true";
import { default as ownersXMSKWTVPPwMeta } from "/app/src/client/pages/toc/report/analyze-efficient/owners.vue?macro=true";
import { default as prjkindsvSo4mY9TckMeta } from "/app/src/client/pages/toc/report/analyze-efficient/prjkinds.vue?macro=true";
import { default as regionsvyqrXuJQUCMeta } from "/app/src/client/pages/toc/report/analyze-efficient/regions.vue?macro=true";
import { default as analyze_45efficientnWVlM3rUpXMeta } from "/app/src/client/pages/toc/report/analyze-efficient.vue?macro=true";
import { default as ownersrvmO3HwHBlMeta } from "/app/src/client/pages/toc/report/analyze-product/owners.vue?macro=true";
import { default as prjkindsuVWtp4hdQHMeta } from "/app/src/client/pages/toc/report/analyze-product/prjkinds.vue?macro=true";
import { default as regions5tuAQHUUf3Meta } from "/app/src/client/pages/toc/report/analyze-product/regions.vue?macro=true";
import { default as analyze_45product7AfSA9wtfeMeta } from "/app/src/client/pages/toc/report/analyze-product.vue?macro=true";
import { default as env_45factorNs7PifOINWMeta } from "/app/src/client/pages/toc/report/env-factor.vue?macro=true";
import { default as eventQZuH7UHp9BMeta } from "/app/src/client/pages/toc/report/event.vue?macro=true";
import { default as predictOc8NLwoUvVMeta } from "/app/src/client/pages/toc/report/predict.vue?macro=true";
import { default as productXNrbypNBU6Meta } from "/app/src/client/pages/toc/report/product.vue?macro=true";
import { default as reporteQTfNPHzo0Meta } from "/app/src/client/pages/toc/report.vue?macro=true";
import { default as app_45versioneQoMeMz6wMMeta } from "/app/src/client/pages/toc/service-info/app-version.vue?macro=true";
import { default as service_45infoz31N6C6vitMeta } from "/app/src/client/pages/toc/service-info.vue?macro=true";
import { default as test1Af9BPP2PrMeta } from "/app/src/client/pages/toc/test.vue?macro=true";
import { default as complement_45modalWIl2PFNF8fMeta } from "/app/src/client/pages/toc/user-service/install-request/complement-modal.vue?macro=true";
import { default as complete_45modaltYVA7LPPSDMeta } from "/app/src/client/pages/toc/user-service/install-request/complete-modal.vue?macro=true";
import { default as work_45history_46infonBZP1A83DwMeta } from "/app/src/client/pages/toc/user-service/install-request/detailComponent/work-history.info.vue?macro=true";
import { default as work_45install_45infopipSBrvil0Meta } from "/app/src/client/pages/toc/user-service/install-request/detailComponent/work-install-info.vue?macro=true";
import { default as index6e66svvpSSMeta } from "/app/src/client/pages/toc/user-service/install-request/index.vue?macro=true";
import { default as owner_45modal5AIc4QfomVMeta } from "/app/src/client/pages/toc/user-service/install-request/owner-modal.vue?macro=true";
import { default as req_45detailwlCkAaC3CRMeta } from "/app/src/client/pages/toc/user-service/install-request/req-detail.vue?macro=true";
import { default as rtu_45chg_45modaln7ZXYRsBRRMeta } from "/app/src/client/pages/toc/user-service/install-request/rtu-chg-modal.vue?macro=true";
import { default as install_45request68PZLotpb2Meta } from "/app/src/client/pages/toc/user-service/install-request.vue?macro=true";
import { default as manager_45info9CA1zyi4EIMeta } from "/app/src/client/pages/toc/user-service/manager-info.vue?macro=true";
import { default as confirm_45modalQdriLbcZiLMeta } from "/app/src/client/pages/toc/user-service/modal/confirm-modal.vue?macro=true";
import { default as manager_45add_45modalVRdD058MjgMeta } from "/app/src/client/pages/toc/user-service/modal/manager-add-modal.vue?macro=true";
import { default as manager_45modify_45modalzIHzPFyP4YMeta } from "/app/src/client/pages/toc/user-service/modal/manager-modify-modal.vue?macro=true";
import { default as set_45manager_45all_45modal6T6r7dbE1UMeta } from "/app/src/client/pages/toc/user-service/modal/set-manager-all-modal.vue?macro=true";
import { default as set_45manager_45select_45modalrQjZn7fLMsMeta } from "/app/src/client/pages/toc/user-service/modal/set-manager-select-modal.vue?macro=true";
import { default as set_45managerpC1XrULe8uMeta } from "/app/src/client/pages/toc/user-service/set-manager.vue?macro=true";
import { default as indexU5rzUOySK4Meta } from "/app/src/client/pages/toc/user-service/user-as-company/index.vue?macro=true";
import { default as user_45as_45companywJMbWlm6esMeta } from "/app/src/client/pages/toc/user-service/user-as-company.vue?macro=true";
import { default as equip_45detailxyZhHRSDfDMeta } from "/app/src/client/pages/toc/user-service/user-as-equipinfo/equip-detail.vue?macro=true";
import { default as indexV5Pa4AWV7zMeta } from "/app/src/client/pages/toc/user-service/user-as-equipinfo/index.vue?macro=true";
import { default as user_45as_45equipinfoGUweeSIgP0Meta } from "/app/src/client/pages/toc/user-service/user-as-equipinfo.vue?macro=true";
import { default as indexwFCuNGk6mDMeta } from "/app/src/client/pages/toc/user-service/user-as-management/index.vue?macro=true";
import { default as infoVoDvfnfpqlMeta } from "/app/src/client/pages/toc/user-service/user-as-management/info.vue?macro=true";
import { default as user_45as_45managementCUE6RPjuANMeta } from "/app/src/client/pages/toc/user-service/user-as-management.vue?macro=true";
import { default as indexGQqkWJ7TXiMeta } from "/app/src/client/pages/toc/user-service/user-as-ownerinfo/index.vue?macro=true";
import { default as owner_45detailSPukpxIazIMeta } from "/app/src/client/pages/toc/user-service/user-as-ownerinfo/owner-detail.vue?macro=true";
import { default as user_45as_45ownerinfoC7BqSnbyqrMeta } from "/app/src/client/pages/toc/user-service/user-as-ownerinfo.vue?macro=true";
import { default as indexNfbGaYWRZ7Meta } from "/app/src/client/pages/toc/user-service/user-as-request/index.vue?macro=true";
import { default as infoYdoy9rPZT8Meta } from "/app/src/client/pages/toc/user-service/user-as-request/info.vue?macro=true";
import { default as user_45as_45requesthpQ0LIptE7Meta } from "/app/src/client/pages/toc/user-service/user-as-request.vue?macro=true";
import { default as user_45infohdzNvUZMOuMeta } from "/app/src/client/pages/toc/user-service/user-info.vue?macro=true";
import { default as user_45settingKd0fk3baNCMeta } from "/app/src/client/pages/toc/user-service/user-setting.vue?macro=true";
import { default as user_45serviceRyvDUJhYbsMeta } from "/app/src/client/pages/toc/user-service.vue?macro=true";
import { default as find_45id5r16OoY32MMeta } from "/app/src/client/pages/toc/user/find-id.vue?macro=true";
import { default as index11JOt9jAqJMeta } from "/app/src/client/pages/toc/user/index.vue?macro=true";
import { default as loginNUHbzvlnoaMeta } from "/app/src/client/pages/toc/user/login.vue?macro=true";
import { default as tocxWmTkQMz4uMeta } from "/app/src/client/pages/toc.vue?macro=true";
export default [
  {
    path: design_45tocgeG2RHQ6fOMeta?.path ?? "/design-toc",
    children: [
  {
    path: analysisL5sjKGJ0GRMeta?.path ?? "analysis",
    children: [
  {
    name: compare_45ownerf8dWT7A6IdMeta?.name ?? "design-toc-analysis-compare-owner",
    path: compare_45ownerf8dWT7A6IdMeta?.path ?? "compare-owner",
    meta: compare_45ownerf8dWT7A6IdMeta || {},
    alias: compare_45ownerf8dWT7A6IdMeta?.alias || [],
    redirect: compare_45ownerf8dWT7A6IdMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/compare-owner.vue").then(m => m.default || m)
  },
  {
    name: compare_45region60lTZjKw2iMeta?.name ?? "design-toc-analysis-compare-region",
    path: compare_45region60lTZjKw2iMeta?.path ?? "compare-region",
    meta: compare_45region60lTZjKw2iMeta || {},
    alias: compare_45region60lTZjKw2iMeta?.alias || [],
    redirect: compare_45region60lTZjKw2iMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/compare-region.vue").then(m => m.default || m)
  },
  {
    name: geo8pf4e8HTB1Meta?.name ?? "design-toc-analysis-component-geo",
    path: geo8pf4e8HTB1Meta?.path ?? "component/geo",
    meta: geo8pf4e8HTB1Meta || {},
    alias: geo8pf4e8HTB1Meta?.alias || [],
    redirect: geo8pf4e8HTB1Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/component/geo.vue").then(m => m.default || m)
  },
  {
    name: ownerSearchModalUQKCdI4HxSMeta?.name ?? "design-toc-analysis-component-ownerSearchModal",
    path: ownerSearchModalUQKCdI4HxSMeta?.path ?? "component/ownerSearchModal",
    meta: ownerSearchModalUQKCdI4HxSMeta || {},
    alias: ownerSearchModalUQKCdI4HxSMeta?.alias || [],
    redirect: ownerSearchModalUQKCdI4HxSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/component/ownerSearchModal.vue").then(m => m.default || m)
  },
  {
    name: pvKC2qkrdxPJMeta?.name ?? "design-toc-analysis-component-pv",
    path: pvKC2qkrdxPJMeta?.path ?? "component/pv",
    meta: pvKC2qkrdxPJMeta || {},
    alias: pvKC2qkrdxPJMeta?.alias || [],
    redirect: pvKC2qkrdxPJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/component/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatjo1cAPMPMMMeta?.name ?? "design-toc-analysis-component-solarheat",
    path: solarheatjo1cAPMPMMMeta?.path ?? "component/solarheat",
    meta: solarheatjo1cAPMPMMMeta || {},
    alias: solarheatjo1cAPMPMMMeta?.alias || [],
    redirect: solarheatjo1cAPMPMMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/component/solarheat.vue").then(m => m.default || m)
  },
  {
    name: indexhiPVbt3v1oMeta?.name ?? "design-toc-analysis",
    path: indexhiPVbt3v1oMeta?.path ?? "",
    meta: indexhiPVbt3v1oMeta || {},
    alias: indexhiPVbt3v1oMeta?.alias || [],
    redirect: indexhiPVbt3v1oMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/index.vue").then(m => m.default || m)
  },
  {
    name: ownerI2lYy8zf4sMeta?.name ?? "design-toc-analysis-owner",
    path: ownerI2lYy8zf4sMeta?.path ?? "owner",
    meta: ownerI2lYy8zf4sMeta || {},
    alias: ownerI2lYy8zf4sMeta?.alias || [],
    redirect: ownerI2lYy8zf4sMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis/owner.vue").then(m => m.default || m)
  }
],
    name: analysisL5sjKGJ0GRMeta?.name ?? undefined,
    meta: analysisL5sjKGJ0GRMeta || {},
    alias: analysisL5sjKGJ0GRMeta?.alias || [],
    redirect: analysisL5sjKGJ0GRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/analysis.vue").then(m => m.default || m)
  },
  {
    path: asinfoWBls9uMFUVMeta?.path ?? "asinfo",
    children: [
  {
    name: as_45request_45detailY78KnvZezmMeta?.name ?? "design-toc-asinfo-as-request-detail",
    path: as_45request_45detailY78KnvZezmMeta?.path ?? "as-request-detail",
    meta: as_45request_45detailY78KnvZezmMeta || {},
    alias: as_45request_45detailY78KnvZezmMeta?.alias || [],
    redirect: as_45request_45detailY78KnvZezmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo/as-request-detail.vue").then(m => m.default || m)
  },
  {
    name: as_45request_45listLvFcwUXBrxMeta?.name ?? "design-toc-asinfo-as-request-list",
    path: as_45request_45listLvFcwUXBrxMeta?.path ?? "as-request-list",
    meta: as_45request_45listLvFcwUXBrxMeta || {},
    alias: as_45request_45listLvFcwUXBrxMeta?.alias || [],
    redirect: as_45request_45listLvFcwUXBrxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo/as-request-list.vue").then(m => m.default || m)
  },
  {
    name: as_45requestJfRvJ9evkTMeta?.name ?? "design-toc-asinfo-as-request",
    path: as_45requestJfRvJ9evkTMeta?.path ?? "as-request",
    meta: as_45requestJfRvJ9evkTMeta || {},
    alias: as_45requestJfRvJ9evkTMeta?.alias || [],
    redirect: as_45requestJfRvJ9evkTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo/as-request.vue").then(m => m.default || m)
  },
  {
    name: aslistT4hSpwzDOHMeta?.name ?? "design-toc-asinfo-aslist",
    path: aslistT4hSpwzDOHMeta?.path ?? "aslist",
    meta: aslistT4hSpwzDOHMeta || {},
    alias: aslistT4hSpwzDOHMeta?.alias || [],
    redirect: aslistT4hSpwzDOHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo/aslist.vue").then(m => m.default || m)
  },
  {
    name: indexa3fJRjfmpUMeta?.name ?? "design-toc-asinfo",
    path: indexa3fJRjfmpUMeta?.path ?? "",
    meta: indexa3fJRjfmpUMeta || {},
    alias: indexa3fJRjfmpUMeta?.alias || [],
    redirect: indexa3fJRjfmpUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo/index.vue").then(m => m.default || m)
  }
],
    name: asinfoWBls9uMFUVMeta?.name ?? undefined,
    meta: asinfoWBls9uMFUVMeta || {},
    alias: asinfoWBls9uMFUVMeta?.alias || [],
    redirect: asinfoWBls9uMFUVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/asinfo.vue").then(m => m.default || m)
  },
  {
    name: bpm_45detailPPIzoaDucIMeta?.name ?? "design-toc-bpm-bpm-detail",
    path: bpm_45detailPPIzoaDucIMeta?.path ?? "bpm/bpm-detail",
    meta: bpm_45detailPPIzoaDucIMeta || {},
    alias: bpm_45detailPPIzoaDucIMeta?.alias || [],
    redirect: bpm_45detailPPIzoaDucIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpm/bpm-detail.vue").then(m => m.default || m)
  },
  {
    name: bpm_45upload_45modalKM1cUQOu5DMeta?.name ?? "design-toc-bpm-bpm-upload-modal",
    path: bpm_45upload_45modalKM1cUQOu5DMeta?.path ?? "bpm/bpm-upload-modal",
    meta: bpm_45upload_45modalKM1cUQOu5DMeta || {},
    alias: bpm_45upload_45modalKM1cUQOu5DMeta?.alias || [],
    redirect: bpm_45upload_45modalKM1cUQOu5DMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpm/bpm-upload-modal.vue").then(m => m.default || m)
  },
  {
    name: bpm_45upload_45progress_45modalZY8xYCaMbvMeta?.name ?? "design-toc-bpm-bpm-upload-progress-modal",
    path: bpm_45upload_45progress_45modalZY8xYCaMbvMeta?.path ?? "bpm/bpm-upload-progress-modal",
    meta: bpm_45upload_45progress_45modalZY8xYCaMbvMeta || {},
    alias: bpm_45upload_45progress_45modalZY8xYCaMbvMeta?.alias || [],
    redirect: bpm_45upload_45progress_45modalZY8xYCaMbvMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpm/bpm-upload-progress-modal.vue").then(m => m.default || m)
  },
  {
    name: bpmlistMJVoRaVrioMeta?.name ?? "design-toc-bpm-bpmlist",
    path: bpmlistMJVoRaVrioMeta?.path ?? "bpm/bpmlist",
    meta: bpmlistMJVoRaVrioMeta || {},
    alias: bpmlistMJVoRaVrioMeta?.alias || [],
    redirect: bpmlistMJVoRaVrioMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpm/bpmlist.vue").then(m => m.default || m)
  },
  {
    name: indexIoqFROXjQQMeta?.name ?? "design-toc-bpm",
    path: indexIoqFROXjQQMeta?.path ?? "bpm",
    meta: indexIoqFROXjQQMeta || {},
    alias: indexIoqFROXjQQMeta?.alias || [],
    redirect: indexIoqFROXjQQMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpm/index.vue").then(m => m.default || m)
  },
  {
    name: bpmrequeststhsHJRXhXgMeta?.name ?? "design-toc-bpmrequestinfo-bpmrequests",
    path: bpmrequeststhsHJRXhXgMeta?.path ?? "bpmrequestinfo/bpmrequests",
    meta: bpmrequeststhsHJRXhXgMeta || {},
    alias: bpmrequeststhsHJRXhXgMeta?.alias || [],
    redirect: bpmrequeststhsHJRXhXgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpmrequestinfo/bpmrequests.vue").then(m => m.default || m)
  },
  {
    name: cost_45estimate_45by_45companyqQHax1RlX1Meta?.name ?? "design-toc-bpmrequestinfo-cost-estimate-by-company",
    path: cost_45estimate_45by_45companyqQHax1RlX1Meta?.path ?? "bpmrequestinfo/cost-estimate-by-company",
    meta: cost_45estimate_45by_45companyqQHax1RlX1Meta || {},
    alias: cost_45estimate_45by_45companyqQHax1RlX1Meta?.alias || [],
    redirect: cost_45estimate_45by_45companyqQHax1RlX1Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpmrequestinfo/cost-estimate-by-company.vue").then(m => m.default || m)
  },
  {
    name: cost_45estimateAWefPnwxoZMeta?.name ?? "design-toc-bpmrequestinfo-cost-estimate",
    path: cost_45estimateAWefPnwxoZMeta?.path ?? "bpmrequestinfo/cost-estimate",
    meta: cost_45estimateAWefPnwxoZMeta || {},
    alias: cost_45estimateAWefPnwxoZMeta?.alias || [],
    redirect: cost_45estimateAWefPnwxoZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpmrequestinfo/cost-estimate.vue").then(m => m.default || m)
  },
  {
    name: indexev64uekzi8Meta?.name ?? "design-toc-bpmrequestinfo",
    path: indexev64uekzi8Meta?.path ?? "bpmrequestinfo",
    meta: indexev64uekzi8Meta || {},
    alias: indexev64uekzi8Meta?.alias || [],
    redirect: indexev64uekzi8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/bpmrequestinfo/index.vue").then(m => m.default || m)
  },
  {
    name: BarChartxYXW54ExVUMeta?.name ?? "design-toc-component-BarChart",
    path: BarChartxYXW54ExVUMeta?.path ?? "component/BarChart",
    meta: BarChartxYXW54ExVUMeta || {},
    alias: BarChartxYXW54ExVUMeta?.alias || [],
    redirect: BarChartxYXW54ExVUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/BarChart.vue").then(m => m.default || m)
  },
  {
    name: Panning_45BarChartX6Z6sr0oIFMeta?.name ?? "design-toc-component-Panning-BarChart",
    path: Panning_45BarChartX6Z6sr0oIFMeta?.path ?? "component/Panning-BarChart",
    meta: Panning_45BarChartX6Z6sr0oIFMeta || {},
    alias: Panning_45BarChartX6Z6sr0oIFMeta?.alias || [],
    redirect: Panning_45BarChartX6Z6sr0oIFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/Panning-BarChart.vue").then(m => m.default || m)
  },
  {
    name: PieChartPjV04ehV0cMeta?.name ?? "design-toc-component-PieChart",
    path: PieChartPjV04ehV0cMeta?.path ?? "component/PieChart",
    meta: PieChartPjV04ehV0cMeta || {},
    alias: PieChartPjV04ehV0cMeta?.alias || [],
    redirect: PieChartPjV04ehV0cMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/PieChart.vue").then(m => m.default || m)
  },
  {
    name: ag_45table_45boxIp9ed4dUJRMeta?.name ?? "design-toc-component-ag-table-box",
    path: ag_45table_45boxIp9ed4dUJRMeta?.path ?? "component/ag-table-box",
    meta: ag_45table_45boxIp9ed4dUJRMeta || {},
    alias: ag_45table_45boxIp9ed4dUJRMeta?.alias || [],
    redirect: ag_45table_45boxIp9ed4dUJRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/ag-table-box.vue").then(m => m.default || m)
  },
  {
    name: api_45search_45boxjsybBHzHH6Meta?.name ?? "design-toc-component-api-search-box",
    path: api_45search_45boxjsybBHzHH6Meta?.path ?? "component/api-search-box",
    meta: api_45search_45boxjsybBHzHH6Meta || {},
    alias: api_45search_45boxjsybBHzHH6Meta?.alias || [],
    redirect: api_45search_45boxjsybBHzHH6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/api-search-box.vue").then(m => m.default || m)
  },
  {
    name: base_45componentLxE4vGyeadMeta?.name ?? "design-toc-component-base-component",
    path: base_45componentLxE4vGyeadMeta?.path ?? "component/base-component",
    meta: base_45componentLxE4vGyeadMeta || {},
    alias: base_45componentLxE4vGyeadMeta?.alias || [],
    redirect: base_45componentLxE4vGyeadMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/base-component.vue").then(m => m.default || m)
  },
  {
    name: base_45tablehenO3CJQkfMeta?.name ?? "design-toc-component-base-table",
    path: base_45tablehenO3CJQkfMeta?.path ?? "component/base-table",
    meta: base_45tablehenO3CJQkfMeta || {},
    alias: base_45tablehenO3CJQkfMeta?.alias || [],
    redirect: base_45tablehenO3CJQkfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/base-table.vue").then(m => m.default || m)
  },
  {
    name: basic_45info_45card14t9e41QKQMeta?.name ?? "design-toc-component-basic-info-card",
    path: basic_45info_45card14t9e41QKQMeta?.path ?? "component/basic-info-card",
    meta: basic_45info_45card14t9e41QKQMeta || {},
    alias: basic_45info_45card14t9e41QKQMeta?.alias || [],
    redirect: basic_45info_45card14t9e41QKQMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/basic-info-card.vue").then(m => m.default || m)
  },
  {
    name: basic_45value_45carde2aj88SnJPMeta?.name ?? "design-toc-component-basic-value-card",
    path: basic_45value_45carde2aj88SnJPMeta?.path ?? "component/basic-value-card",
    meta: basic_45value_45carde2aj88SnJPMeta || {},
    alias: basic_45value_45carde2aj88SnJPMeta?.alias || [],
    redirect: basic_45value_45carde2aj88SnJPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/basic-value-card.vue").then(m => m.default || m)
  },
  {
    name: category_45chartqcdzaNYL3tMeta?.name ?? "design-toc-component-category-chart",
    path: category_45chartqcdzaNYL3tMeta?.path ?? "component/category-chart",
    meta: category_45chartqcdzaNYL3tMeta || {},
    alias: category_45chartqcdzaNYL3tMeta?.alias || [],
    redirect: category_45chartqcdzaNYL3tMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/category-chart.vue").then(m => m.default || m)
  },
  {
    name: common_45code_45dropdownJFjPUls7nnMeta?.name ?? "design-toc-component-common-code-dropdown",
    path: common_45code_45dropdownJFjPUls7nnMeta?.path ?? "component/common-code-dropdown",
    meta: common_45code_45dropdownJFjPUls7nnMeta || {},
    alias: common_45code_45dropdownJFjPUls7nnMeta?.alias || [],
    redirect: common_45code_45dropdownJFjPUls7nnMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/common-code-dropdown.vue").then(m => m.default || m)
  },
  {
    name: curtailment_45cardy2M7Zap6JZMeta?.name ?? "design-toc-component-curtailment-card",
    path: curtailment_45cardy2M7Zap6JZMeta?.path ?? "component/curtailment-card",
    meta: curtailment_45cardy2M7Zap6JZMeta || {},
    alias: curtailment_45cardy2M7Zap6JZMeta?.alias || [],
    redirect: curtailment_45cardy2M7Zap6JZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/curtailment-card.vue").then(m => m.default || m)
  },
  {
    name: dashboardUc0v2yRsmoMeta?.name ?? "design-toc-component-dashboard-dashboard",
    path: dashboardUc0v2yRsmoMeta?.path ?? "component/dashboard/dashboard",
    meta: dashboardUc0v2yRsmoMeta || {},
    alias: dashboardUc0v2yRsmoMeta?.alias || [],
    redirect: dashboardUc0v2yRsmoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/dashboard/dashboard.vue").then(m => m.default || m)
  },
  {
    name: date_45chartSTVVXpZ3AxMeta?.name ?? "design-toc-component-date-chart",
    path: date_45chartSTVVXpZ3AxMeta?.path ?? "component/date-chart",
    meta: date_45chartSTVVXpZ3AxMeta || {},
    alias: date_45chartSTVVXpZ3AxMeta?.alias || [],
    redirect: date_45chartSTVVXpZ3AxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/date-chart.vue").then(m => m.default || m)
  },
  {
    name: date_45picker612RKwgFTOMeta?.name ?? "design-toc-component-date-picker",
    path: date_45picker612RKwgFTOMeta?.path ?? "component/date-picker",
    meta: date_45picker612RKwgFTOMeta || {},
    alias: date_45picker612RKwgFTOMeta?.alias || [],
    redirect: date_45picker612RKwgFTOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/date-picker.vue").then(m => m.default || m)
  },
  {
    name: date_45set_45reportyav0DZ5j4HMeta?.name ?? "design-toc-component-date-set-report",
    path: date_45set_45reportyav0DZ5j4HMeta?.path ?? "component/date-set-report",
    meta: date_45set_45reportyav0DZ5j4HMeta || {},
    alias: date_45set_45reportyav0DZ5j4HMeta?.alias || [],
    redirect: date_45set_45reportyav0DZ5j4HMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/date-set-report.vue").then(m => m.default || m)
  },
  {
    name: date_45setAVUrVV6wVDMeta?.name ?? "design-toc-component-date-set",
    path: date_45setAVUrVV6wVDMeta?.path ?? "component/date-set",
    meta: date_45setAVUrVV6wVDMeta || {},
    alias: date_45setAVUrVV6wVDMeta?.alias || [],
    redirect: date_45setAVUrVV6wVDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/date-set.vue").then(m => m.default || m)
  },
  {
    name: editable_45image_45cardNE1aiqn3FlMeta?.name ?? "design-toc-component-editable-image-card",
    path: editable_45image_45cardNE1aiqn3FlMeta?.path ?? "component/editable-image-card",
    meta: editable_45image_45cardNE1aiqn3FlMeta || {},
    alias: editable_45image_45cardNE1aiqn3FlMeta?.alias || [],
    redirect: editable_45image_45cardNE1aiqn3FlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/editable-image-card.vue").then(m => m.default || m)
  },
  {
    name: energy_45info_45cardZe0wL1Sh0hMeta?.name ?? "design-toc-component-energy-info-card",
    path: energy_45info_45cardZe0wL1Sh0hMeta?.path ?? "component/energy-info-card",
    meta: energy_45info_45cardZe0wL1Sh0hMeta || {},
    alias: energy_45info_45cardZe0wL1Sh0hMeta?.alias || [],
    redirect: energy_45info_45cardZe0wL1Sh0hMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/energy-info-card.vue").then(m => m.default || m)
  },
  {
    name: equip_45infoB67g4KVlKVMeta?.name ?? "design-toc-component-equip-info",
    path: equip_45infoB67g4KVlKVMeta?.path ?? "component/equip-info",
    meta: equip_45infoB67g4KVlKVMeta || {},
    alias: equip_45infoB67g4KVlKVMeta?.alias || [],
    redirect: equip_45infoB67g4KVlKVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/equip-info.vue").then(m => m.default || m)
  },
  {
    name: event_45info_45sliderUWh5m5fODMeta?.name ?? "design-toc-component-event-info-slide",
    path: event_45info_45sliderUWh5m5fODMeta?.path ?? "component/event-info-slide",
    meta: event_45info_45sliderUWh5m5fODMeta || {},
    alias: event_45info_45sliderUWh5m5fODMeta?.alias || [],
    redirect: event_45info_45sliderUWh5m5fODMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/event-info-slide.vue").then(m => m.default || m)
  },
  {
    name: event_45now_45tableYrZBDTmm8rMeta?.name ?? "design-toc-component-event-now-table",
    path: event_45now_45tableYrZBDTmm8rMeta?.path ?? "component/event-now-table",
    meta: event_45now_45tableYrZBDTmm8rMeta || {},
    alias: event_45now_45tableYrZBDTmm8rMeta?.alias || [],
    redirect: event_45now_45tableYrZBDTmm8rMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/event-now-table.vue").then(m => m.default || m)
  },
  {
    name: event_45table8wkBrFUzVOMeta?.name ?? "design-toc-component-event-table",
    path: event_45table8wkBrFUzVOMeta?.path ?? "component/event-table",
    meta: event_45table8wkBrFUzVOMeta || {},
    alias: event_45table8wkBrFUzVOMeta?.alias || [],
    redirect: event_45table8wkBrFUzVOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/event-table.vue").then(m => m.default || m)
  },
  {
    name: gauge_45chartE2iWyrP5lzMeta?.name ?? "design-toc-component-gauge-chart",
    path: gauge_45chartE2iWyrP5lzMeta?.path ?? "component/gauge-chart",
    meta: gauge_45chartE2iWyrP5lzMeta || {},
    alias: gauge_45chartE2iWyrP5lzMeta?.alias || [],
    redirect: gauge_45chartE2iWyrP5lzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/gauge-chart.vue").then(m => m.default || m)
  },
  {
    name: geothermal_45prod_45usage_45chart6FFLnfX2xDMeta?.name ?? "design-toc-component-geothermal-prod-usage-chart",
    path: geothermal_45prod_45usage_45chart6FFLnfX2xDMeta?.path ?? "component/geothermal-prod-usage-chart",
    meta: geothermal_45prod_45usage_45chart6FFLnfX2xDMeta || {},
    alias: geothermal_45prod_45usage_45chart6FFLnfX2xDMeta?.alias || [],
    redirect: geothermal_45prod_45usage_45chart6FFLnfX2xDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/geothermal-prod-usage-chart.vue").then(m => m.default || m)
  },
  {
    name: geothermal_45schematic_45card1IpONa2F0mMeta?.name ?? "design-toc-component-geothermal-schematic-card",
    path: geothermal_45schematic_45card1IpONa2F0mMeta?.path ?? "component/geothermal-schematic-card",
    meta: geothermal_45schematic_45card1IpONa2F0mMeta || {},
    alias: geothermal_45schematic_45card1IpONa2F0mMeta?.alias || [],
    redirect: geothermal_45schematic_45card1IpONa2F0mMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/geothermal-schematic-card.vue").then(m => m.default || m)
  },
  {
    name: header_45slide51pgfZOgpbMeta?.name ?? "design-toc-component-header-slide",
    path: header_45slide51pgfZOgpbMeta?.path ?? "component/header-slide",
    meta: header_45slide51pgfZOgpbMeta || {},
    alias: header_45slide51pgfZOgpbMeta?.alias || [],
    redirect: header_45slide51pgfZOgpbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/header-slide.vue").then(m => m.default || m)
  },
  {
    name: info_45tapXdUbQM4t2fMeta?.name ?? "design-toc-component-info-tap",
    path: info_45tapXdUbQM4t2fMeta?.path ?? "component/info-tap",
    meta: info_45tapXdUbQM4t2fMeta || {},
    alias: info_45tapXdUbQM4t2fMeta?.alias || [],
    redirect: info_45tapXdUbQM4t2fMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/info-tap.vue").then(m => m.default || m)
  },
  {
    name: install_45infoDDhax6oiRbMeta?.name ?? "design-toc-component-install-info",
    path: install_45infoDDhax6oiRbMeta?.path ?? "component/install-info",
    meta: install_45infoDDhax6oiRbMeta || {},
    alias: install_45infoDDhax6oiRbMeta?.alias || [],
    redirect: install_45infoDDhax6oiRbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/install-info.vue").then(m => m.default || m)
  },
  {
    name: invert_45card_45listr39qWwXKLwMeta?.name ?? "design-toc-component-invert-card-list",
    path: invert_45card_45listr39qWwXKLwMeta?.path ?? "component/invert-card-list",
    meta: invert_45card_45listr39qWwXKLwMeta || {},
    alias: invert_45card_45listr39qWwXKLwMeta?.alias || [],
    redirect: invert_45card_45listr39qWwXKLwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/invert-card-list.vue").then(m => m.default || m)
  },
  {
    name: invert_45cardfbbtvS8kegMeta?.name ?? "design-toc-component-invert-card",
    path: invert_45cardfbbtvS8kegMeta?.path ?? "component/invert-card",
    meta: invert_45cardfbbtvS8kegMeta || {},
    alias: invert_45cardfbbtvS8kegMeta?.alias || [],
    redirect: invert_45cardfbbtvS8kegMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/invert-card.vue").then(m => m.default || m)
  },
  {
    name: linkage_45info_45cardjYqNsgAmWYMeta?.name ?? "design-toc-component-linkage-info-card",
    path: linkage_45info_45cardjYqNsgAmWYMeta?.path ?? "component/linkage-info-card",
    meta: linkage_45info_45cardjYqNsgAmWYMeta || {},
    alias: linkage_45info_45cardjYqNsgAmWYMeta?.alias || [],
    redirect: linkage_45info_45cardjYqNsgAmWYMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/linkage-info-card.vue").then(m => m.default || m)
  },
  {
    name: manager_45infoJgZyZk3hYIMeta?.name ?? "design-toc-component-manager-info",
    path: manager_45infoJgZyZk3hYIMeta?.path ?? "component/manager-info",
    meta: manager_45infoJgZyZk3hYIMeta || {},
    alias: manager_45infoJgZyZk3hYIMeta?.alias || [],
    redirect: manager_45infoJgZyZk3hYIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/manager-info.vue").then(m => m.default || m)
  },
  {
    name: map_45renderO8XWhdbSBQMeta?.name ?? "design-toc-component-map-render",
    path: map_45renderO8XWhdbSBQMeta?.path ?? "component/map-render",
    meta: map_45renderO8XWhdbSBQMeta || {},
    alias: map_45renderO8XWhdbSBQMeta?.alias || [],
    redirect: map_45renderO8XWhdbSBQMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/map-render.vue").then(m => m.default || m)
  },
  {
    name: mix_45chart_45card9NUSio9DLEMeta?.name ?? "design-toc-component-mix-chart-card",
    path: mix_45chart_45card9NUSio9DLEMeta?.path ?? "component/mix-chart-card",
    meta: mix_45chart_45card9NUSio9DLEMeta || {},
    alias: mix_45chart_45card9NUSio9DLEMeta?.alias || [],
    redirect: mix_45chart_45card9NUSio9DLEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/mix-chart-card.vue").then(m => m.default || m)
  },
  {
    name: owner_45info6hVUZRflSBMeta?.name ?? "design-toc-component-owner-info",
    path: owner_45info6hVUZRflSBMeta?.path ?? "component/owner-info",
    meta: owner_45info6hVUZRflSBMeta || {},
    alias: owner_45info6hVUZRflSBMeta?.alias || [],
    redirect: owner_45info6hVUZRflSBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/owner-info.vue").then(m => m.default || m)
  },
  {
    name: ownerSearchModalNO2rgA0MK6Meta?.name ?? "design-toc-component-ownerSearchModal",
    path: ownerSearchModalNO2rgA0MK6Meta?.path ?? "component/ownerSearchModal",
    meta: ownerSearchModalNO2rgA0MK6Meta || {},
    alias: ownerSearchModalNO2rgA0MK6Meta?.alias || [],
    redirect: ownerSearchModalNO2rgA0MK6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/ownerSearchModal.vue").then(m => m.default || m)
  },
  {
    name: plain_45ag_45table_45boxuf9bdvhH7AMeta?.name ?? "design-toc-component-plain-ag-table-box",
    path: plain_45ag_45table_45boxuf9bdvhH7AMeta?.path ?? "component/plain-ag-table-box",
    meta: plain_45ag_45table_45boxuf9bdvhH7AMeta || {},
    alias: plain_45ag_45table_45boxuf9bdvhH7AMeta?.alias || [],
    redirect: plain_45ag_45table_45boxuf9bdvhH7AMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/plain-ag-table-box.vue").then(m => m.default || m)
  },
  {
    name: plain_45date_45setMoN7KgmgxNMeta?.name ?? "design-toc-component-plain-date-set",
    path: plain_45date_45setMoN7KgmgxNMeta?.path ?? "component/plain-date-set",
    meta: plain_45date_45setMoN7KgmgxNMeta || {},
    alias: plain_45date_45setMoN7KgmgxNMeta?.alias || [],
    redirect: plain_45date_45setMoN7KgmgxNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/plain-date-set.vue").then(m => m.default || m)
  },
  {
    name: prod_45chartdWvth7eMtNMeta?.name ?? "design-toc-component-prod-chart",
    path: prod_45chartdWvth7eMtNMeta?.path ?? "component/prod-chart",
    meta: prod_45chartdWvth7eMtNMeta || {},
    alias: prod_45chartdWvth7eMtNMeta?.alias || [],
    redirect: prod_45chartdWvth7eMtNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/prod-chart.vue").then(m => m.default || m)
  },
  {
    name: prod_45info_45chartdHMYkc8nLIMeta?.name ?? "design-toc-component-prod-info-chart",
    path: prod_45info_45chartdHMYkc8nLIMeta?.path ?? "component/prod-info-chart",
    meta: prod_45info_45chartdHMYkc8nLIMeta || {},
    alias: prod_45info_45chartdHMYkc8nLIMeta?.alias || [],
    redirect: prod_45info_45chartdHMYkc8nLIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/prod-info-chart.vue").then(m => m.default || m)
  },
  {
    name: prod_45info_45slideRNnTHoM9KRMeta?.name ?? "design-toc-component-prod-info-slide",
    path: prod_45info_45slideRNnTHoM9KRMeta?.path ?? "component/prod-info-slide",
    meta: prod_45info_45slideRNnTHoM9KRMeta || {},
    alias: prod_45info_45slideRNnTHoM9KRMeta?.alias || [],
    redirect: prod_45info_45slideRNnTHoM9KRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/prod-info-slide.vue").then(m => m.default || m)
  },
  {
    name: prod_45infoY68hdRbNcgMeta?.name ?? "design-toc-component-prod-info",
    path: prod_45infoY68hdRbNcgMeta?.path ?? "component/prod-info",
    meta: prod_45infoY68hdRbNcgMeta || {},
    alias: prod_45infoY68hdRbNcgMeta?.alias || [],
    redirect: prod_45infoY68hdRbNcgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/prod-info.vue").then(m => m.default || m)
  },
  {
    name: raw_45data_45chart_45infoE26ZGlhSgUMeta?.name ?? "design-toc-component-raw-data-chart-info",
    path: raw_45data_45chart_45infoE26ZGlhSgUMeta?.path ?? "component/raw-data-chart-info",
    meta: raw_45data_45chart_45infoE26ZGlhSgUMeta || {},
    alias: raw_45data_45chart_45infoE26ZGlhSgUMeta?.alias || [],
    redirect: raw_45data_45chart_45infoE26ZGlhSgUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/raw-data-chart-info.vue").then(m => m.default || m)
  },
  {
    name: raw_45data_45infoil3ymG2zUfMeta?.name ?? "design-toc-component-raw-data-info",
    path: raw_45data_45infoil3ymG2zUfMeta?.path ?? "component/raw-data-info",
    meta: raw_45data_45infoil3ymG2zUfMeta || {},
    alias: raw_45data_45infoil3ymG2zUfMeta?.alias || [],
    redirect: raw_45data_45infoil3ymG2zUfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/raw-data-info.vue").then(m => m.default || m)
  },
  {
    name: rawdata_45cardV1halDrxHXMeta?.name ?? "design-toc-component-rawdata-card",
    path: rawdata_45cardV1halDrxHXMeta?.path ?? "component/rawdata-card",
    meta: rawdata_45cardV1halDrxHXMeta || {},
    alias: rawdata_45cardV1halDrxHXMeta?.alias || [],
    redirect: rawdata_45cardV1halDrxHXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/rawdata-card.vue").then(m => m.default || m)
  },
  {
    name: rawdata_45charttukypavj95Meta?.name ?? "design-toc-component-rawdata-chart",
    path: rawdata_45charttukypavj95Meta?.path ?? "component/rawdata-chart",
    meta: rawdata_45charttukypavj95Meta || {},
    alias: rawdata_45charttukypavj95Meta?.alias || [],
    redirect: rawdata_45charttukypavj95Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/rawdata-chart.vue").then(m => m.default || m)
  },
  {
    name: region_45rtu_45tableuvC9hX5G0nMeta?.name ?? "design-toc-component-region-rtu-table",
    path: region_45rtu_45tableuvC9hX5G0nMeta?.path ?? "component/region-rtu-table",
    meta: region_45rtu_45tableuvC9hX5G0nMeta || {},
    alias: region_45rtu_45tableuvC9hX5G0nMeta?.alias || [],
    redirect: region_45rtu_45tableuvC9hX5G0nMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/region-rtu-table.vue").then(m => m.default || m)
  },
  {
    name: region_45setWXadh3yYymMeta?.name ?? "design-toc-component-region-set",
    path: region_45setWXadh3yYymMeta?.path ?? "component/region-set",
    meta: region_45setWXadh3yYymMeta || {},
    alias: region_45setWXadh3yYymMeta?.alias || [],
    redirect: region_45setWXadh3yYymMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/region-set.vue").then(m => m.default || m)
  },
  {
    name: round_45chartAtYkolxcrcMeta?.name ?? "design-toc-component-round-chart",
    path: round_45chartAtYkolxcrcMeta?.path ?? "component/round-chart",
    meta: round_45chartAtYkolxcrcMeta || {},
    alias: round_45chartAtYkolxcrcMeta?.alias || [],
    redirect: round_45chartAtYkolxcrcMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/round-chart.vue").then(m => m.default || m)
  },
  {
    name: rtu_45infoCzURbadPwnMeta?.name ?? "design-toc-component-rtu-info",
    path: rtu_45infoCzURbadPwnMeta?.path ?? "component/rtu-info",
    meta: rtu_45infoCzURbadPwnMeta || {},
    alias: rtu_45infoCzURbadPwnMeta?.alias || [],
    redirect: rtu_45infoCzURbadPwnMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/rtu-info.vue").then(m => m.default || m)
  },
  {
    name: schematic_45cardLVFpunS2n0Meta?.name ?? "design-toc-component-schematic-card",
    path: schematic_45cardLVFpunS2n0Meta?.path ?? "component/schematic-card",
    meta: schematic_45cardLVFpunS2n0Meta || {},
    alias: schematic_45cardLVFpunS2n0Meta?.alias || [],
    redirect: schematic_45cardLVFpunS2n0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/schematic-card.vue").then(m => m.default || m)
  },
  {
    name: simple_45equip_45status3efaTh5gNjMeta?.name ?? "design-toc-component-simple-equip-status",
    path: simple_45equip_45status3efaTh5gNjMeta?.path ?? "component/simple-equip-status",
    meta: simple_45equip_45status3efaTh5gNjMeta || {},
    alias: simple_45equip_45status3efaTh5gNjMeta?.alias || [],
    redirect: simple_45equip_45status3efaTh5gNjMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/simple-equip-status.vue").then(m => m.default || m)
  },
  {
    name: spec_45info_45tableYbcRs0wlMeMeta?.name ?? "design-toc-component-spec-info-table",
    path: spec_45info_45tableYbcRs0wlMeMeta?.path ?? "component/spec-info-table",
    meta: spec_45info_45tableYbcRs0wlMeMeta || {},
    alias: spec_45info_45tableYbcRs0wlMeMeta?.alias || [],
    redirect: spec_45info_45tableYbcRs0wlMeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/spec-info-table.vue").then(m => m.default || m)
  },
  {
    name: spec_45infoU5uyufotp1Meta?.name ?? "design-toc-component-spec-info",
    path: spec_45infoU5uyufotp1Meta?.path ?? "component/spec-info",
    meta: spec_45infoU5uyufotp1Meta || {},
    alias: spec_45infoU5uyufotp1Meta?.alias || [],
    redirect: spec_45infoU5uyufotp1Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/spec-info.vue").then(m => m.default || m)
  },
  {
    name: system_45status_45cardOpY1ohjkWaMeta?.name ?? "design-toc-component-system-status-card",
    path: system_45status_45cardOpY1ohjkWaMeta?.path ?? "component/system-status-card",
    meta: system_45status_45cardOpY1ohjkWaMeta || {},
    alias: system_45status_45cardOpY1ohjkWaMeta?.alias || [],
    redirect: system_45status_45cardOpY1ohjkWaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/system-status-card.vue").then(m => m.default || m)
  },
  {
    name: table_45pagingnCfbPNtCYkMeta?.name ?? "design-toc-component-table-paging",
    path: table_45pagingnCfbPNtCYkMeta?.path ?? "component/table-paging",
    meta: table_45pagingnCfbPNtCYkMeta || {},
    alias: table_45pagingnCfbPNtCYkMeta?.alias || [],
    redirect: table_45pagingnCfbPNtCYkMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/table-paging.vue").then(m => m.default || m)
  },
  {
    name: total_45prod_45cardpzb7F7vH6gMeta?.name ?? "design-toc-component-total-prod-card",
    path: total_45prod_45cardpzb7F7vH6gMeta?.path ?? "component/total-prod-card",
    meta: total_45prod_45cardpzb7F7vH6gMeta || {},
    alias: total_45prod_45cardpzb7F7vH6gMeta?.alias || [],
    redirect: total_45prod_45cardpzb7F7vH6gMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/total-prod-card.vue").then(m => m.default || m)
  },
  {
    name: weather_45info_45card2tS6EbRzEyMeta?.name ?? "design-toc-component-weather-info-card",
    path: weather_45info_45card2tS6EbRzEyMeta?.path ?? "component/weather-info-card",
    meta: weather_45info_45card2tS6EbRzEyMeta || {},
    alias: weather_45info_45card2tS6EbRzEyMeta?.alias || [],
    redirect: weather_45info_45card2tS6EbRzEyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/weather-info-card.vue").then(m => m.default || m)
  },
  {
    name: weather_45prod_46chartVwEzD47AdzMeta?.name ?? "design-toc-component-weather-prod.chart",
    path: weather_45prod_46chartVwEzD47AdzMeta?.path ?? "component/weather-prod.chart",
    meta: weather_45prod_46chartVwEzD47AdzMeta || {},
    alias: weather_45prod_46chartVwEzD47AdzMeta?.alias || [],
    redirect: weather_45prod_46chartVwEzD47AdzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/component/weather-prod.chart.vue").then(m => m.default || m)
  },
  {
    name: indexGgVefTON8EMeta?.name ?? "design-toc-customer",
    path: indexGgVefTON8EMeta?.path ?? "customer",
    meta: indexGgVefTON8EMeta || {},
    alias: indexGgVefTON8EMeta?.alias || [],
    redirect: indexGgVefTON8EMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/index.vue").then(m => m.default || m)
  },
  {
    name: notice_45detailJeabwJBU7pMeta?.name ?? "design-toc-customer-notice-detail",
    path: notice_45detailJeabwJBU7pMeta?.path ?? "customer/notice-detail",
    meta: notice_45detailJeabwJBU7pMeta || {},
    alias: notice_45detailJeabwJBU7pMeta?.alias || [],
    redirect: notice_45detailJeabwJBU7pMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/notice-detail.vue").then(m => m.default || m)
  },
  {
    name: noticeNKO6ZRfgNiMeta?.name ?? "design-toc-customer-notice",
    path: noticeNKO6ZRfgNiMeta?.path ?? "customer/notice",
    meta: noticeNKO6ZRfgNiMeta || {},
    alias: noticeNKO6ZRfgNiMeta?.alias || [],
    redirect: noticeNKO6ZRfgNiMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/notice.vue").then(m => m.default || m)
  },
  {
    name: qna_45detailn83DfQzoYPMeta?.name ?? "design-toc-customer-qna-detail",
    path: qna_45detailn83DfQzoYPMeta?.path ?? "customer/qna-detail",
    meta: qna_45detailn83DfQzoYPMeta || {},
    alias: qna_45detailn83DfQzoYPMeta?.alias || [],
    redirect: qna_45detailn83DfQzoYPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/qna-detail.vue").then(m => m.default || m)
  },
  {
    name: qna_45writerdiklzQ1cEMeta?.name ?? "design-toc-customer-qna-write",
    path: qna_45writerdiklzQ1cEMeta?.path ?? "customer/qna-write",
    meta: qna_45writerdiklzQ1cEMeta || {},
    alias: qna_45writerdiklzQ1cEMeta?.alias || [],
    redirect: qna_45writerdiklzQ1cEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/qna-write.vue").then(m => m.default || m)
  },
  {
    name: qnaykfIOhA8wSMeta?.name ?? "design-toc-customer-qna",
    path: qnaykfIOhA8wSMeta?.path ?? "customer/qna",
    meta: qnaykfIOhA8wSMeta || {},
    alias: qnaykfIOhA8wSMeta?.alias || [],
    redirect: qnaykfIOhA8wSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/customer/qna.vue").then(m => m.default || m)
  },
  {
    path: dashboard3xqwMUIhjzMeta?.path ?? "dashboard",
    children: [
  {
    name: defaultAInPN82hj7Meta?.name ?? "design-toc-dashboard-default",
    path: defaultAInPN82hj7Meta?.path ?? "default",
    meta: defaultAInPN82hj7Meta || {},
    alias: defaultAInPN82hj7Meta?.alias || [],
    redirect: defaultAInPN82hj7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/default.vue").then(m => m.default || m)
  },
  {
    name: equip_45mapSStA9QmQgUMeta?.name ?? "design-toc-dashboard-equip-map",
    path: equip_45mapSStA9QmQgUMeta?.path ?? "equip-map",
    meta: equip_45mapSStA9QmQgUMeta || {},
    alias: equip_45mapSStA9QmQgUMeta?.alias || [],
    redirect: equip_45mapSStA9QmQgUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/equip-map.vue").then(m => m.default || m)
  },
  {
    name: indexqeDAVdAdXqMeta?.name ?? "design-toc-dashboard",
    path: indexqeDAVdAdXqMeta?.path ?? "",
    meta: indexqeDAVdAdXqMeta || {},
    alias: indexqeDAVdAdXqMeta?.alias || [],
    redirect: indexqeDAVdAdXqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: map_45dashboardtWQxhs6PGjMeta?.name ?? "design-toc-dashboard-map-dashboard",
    path: map_45dashboardtWQxhs6PGjMeta?.path ?? "map-dashboard",
    meta: map_45dashboardtWQxhs6PGjMeta || {},
    alias: map_45dashboardtWQxhs6PGjMeta?.alias || [],
    redirect: map_45dashboardtWQxhs6PGjMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/map-dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexDoNkMFDnkWMeta?.name ?? "design-toc-dashboard-site-equip",
    path: indexDoNkMFDnkWMeta?.path ?? "site/equip",
    meta: indexDoNkMFDnkWMeta || {},
    alias: indexDoNkMFDnkWMeta?.alias || [],
    redirect: indexDoNkMFDnkWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/site/equip/index.vue").then(m => m.default || m)
  },
  {
    name: index9xgObzsDXzMeta?.name ?? "design-toc-dashboard-site",
    path: index9xgObzsDXzMeta?.path ?? "site",
    meta: index9xgObzsDXzMeta || {},
    alias: index9xgObzsDXzMeta?.alias || [],
    redirect: index9xgObzsDXzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard/site/index.vue").then(m => m.default || m)
  }
],
    name: dashboard3xqwMUIhjzMeta?.name ?? undefined,
    meta: dashboard3xqwMUIhjzMeta || {},
    alias: dashboard3xqwMUIhjzMeta?.alias || [],
    redirect: dashboard3xqwMUIhjzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/dashboard.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93cQD7WjLGmmMeta?.name ?? "design-toc-eventinfo-event-detail-eventId",
    path: _91eventId_93cQD7WjLGmmMeta?.path ?? "eventinfo/event-detail/:eventId",
    meta: _91eventId_93cQD7WjLGmmMeta || {},
    alias: _91eventId_93cQD7WjLGmmMeta?.alias || [],
    redirect: _91eventId_93cQD7WjLGmmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/eventinfo/event-detail/[eventId].vue").then(m => m.default || m)
  },
  {
    name: eventlistQ4vfMampCEMeta?.name ?? "design-toc-eventinfo-eventlist",
    path: eventlistQ4vfMampCEMeta?.path ?? "eventinfo/eventlist",
    meta: eventlistQ4vfMampCEMeta || {},
    alias: eventlistQ4vfMampCEMeta?.alias || [],
    redirect: eventlistQ4vfMampCEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/eventinfo/eventlist.vue").then(m => m.default || m)
  },
  {
    name: index4A5kJAzmeXMeta?.name ?? "design-toc-eventinfo",
    path: index4A5kJAzmeXMeta?.path ?? "eventinfo",
    meta: index4A5kJAzmeXMeta || {},
    alias: index4A5kJAzmeXMeta?.alias || [],
    redirect: index4A5kJAzmeXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/eventinfo/index.vue").then(m => m.default || m)
  },
  {
    name: indexG0dkqxj3VuMeta?.name ?? "design-toc",
    path: indexG0dkqxj3VuMeta?.path ?? "",
    meta: indexG0dkqxj3VuMeta || {},
    alias: indexG0dkqxj3VuMeta?.alias || [],
    redirect: indexG0dkqxj3VuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/index.vue").then(m => m.default || m)
  },
  {
    name: as_45equip_45detailrbMqVth3SfMeta?.name ?? "design-toc-management-as-equip-detail",
    path: as_45equip_45detailrbMqVth3SfMeta?.path ?? "management/as-equip-detail",
    meta: as_45equip_45detailrbMqVth3SfMeta || {},
    alias: as_45equip_45detailrbMqVth3SfMeta?.alias || [],
    redirect: as_45equip_45detailrbMqVth3SfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/as-equip-detail.vue").then(m => m.default || m)
  },
  {
    name: as_45equip_45infoNLhabJxTRJMeta?.name ?? "design-toc-management-as-equip-info",
    path: as_45equip_45infoNLhabJxTRJMeta?.path ?? "management/as-equip-info",
    meta: as_45equip_45infoNLhabJxTRJMeta || {},
    alias: as_45equip_45infoNLhabJxTRJMeta?.alias || [],
    redirect: as_45equip_45infoNLhabJxTRJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/as-equip-info.vue").then(m => m.default || m)
  },
  {
    name: as_45owner_45detailNjXx4VPK7uMeta?.name ?? "design-toc-management-as-owner-detail",
    path: as_45owner_45detailNjXx4VPK7uMeta?.path ?? "management/as-owner-detail",
    meta: as_45owner_45detailNjXx4VPK7uMeta || {},
    alias: as_45owner_45detailNjXx4VPK7uMeta?.alias || [],
    redirect: as_45owner_45detailNjXx4VPK7uMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/as-owner-detail.vue").then(m => m.default || m)
  },
  {
    name: as_45owner_45infoKRU6FhcZfEMeta?.name ?? "design-toc-management-as-owner-info",
    path: as_45owner_45infoKRU6FhcZfEMeta?.path ?? "management/as-owner-info",
    meta: as_45owner_45infoKRU6FhcZfEMeta || {},
    alias: as_45owner_45infoKRU6FhcZfEMeta?.alias || [],
    redirect: as_45owner_45infoKRU6FhcZfEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/as-owner-info.vue").then(m => m.default || m)
  },
  {
    name: construction_45pdf_45progress_45modalR9yYFr7TG6Meta?.name ?? "design-toc-management-construction-pdf-progress-modal",
    path: construction_45pdf_45progress_45modalR9yYFr7TG6Meta?.path ?? "management/construction-pdf-progress-modal",
    meta: construction_45pdf_45progress_45modalR9yYFr7TG6Meta || {},
    alias: construction_45pdf_45progress_45modalR9yYFr7TG6Meta?.alias || [],
    redirect: construction_45pdf_45progress_45modalR9yYFr7TG6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/construction-pdf-progress-modal.vue").then(m => m.default || m)
  },
  {
    name: rtu_45event_45history8WSxiriZObMeta?.name ?? "design-toc-management-detailComponent-rtu-event-history",
    path: rtu_45event_45history8WSxiriZObMeta?.path ?? "management/detailComponent/rtu-event-history",
    meta: rtu_45event_45history8WSxiriZObMeta || {},
    alias: rtu_45event_45history8WSxiriZObMeta?.alias || [],
    redirect: rtu_45event_45history8WSxiriZObMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/detailComponent/rtu-event-history.vue").then(m => m.default || m)
  },
  {
    name: work_45history_46infogVfcCWldrgMeta?.name ?? "design-toc-management-detailComponent-work-history.info",
    path: work_45history_46infogVfcCWldrgMeta?.path ?? "management/detailComponent/work-history.info",
    meta: work_45history_46infogVfcCWldrgMeta || {},
    alias: work_45history_46infogVfcCWldrgMeta?.alias || [],
    redirect: work_45history_46infogVfcCWldrgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/detailComponent/work-history.info.vue").then(m => m.default || m)
  },
  {
    name: work_45install_45infoyYKdSVw7lIMeta?.name ?? "design-toc-management-detailComponent-work-install-info",
    path: work_45install_45infoyYKdSVw7lIMeta?.path ?? "management/detailComponent/work-install-info",
    meta: work_45install_45infoyYKdSVw7lIMeta || {},
    alias: work_45install_45infoyYKdSVw7lIMeta?.alias || [],
    redirect: work_45install_45infoyYKdSVw7lIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/detailComponent/work-install-info.vue").then(m => m.default || m)
  },
  {
    name: indexkdlq2WxWgXMeta?.name ?? "design-toc-management",
    path: indexkdlq2WxWgXMeta?.path ?? "management",
    meta: indexkdlq2WxWgXMeta || {},
    alias: indexkdlq2WxWgXMeta?.alias || [],
    redirect: indexkdlq2WxWgXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/index.vue").then(m => m.default || m)
  },
  {
    name: installerHa6vG1j1TIMeta?.name ?? "design-toc-management-installer",
    path: installerHa6vG1j1TIMeta?.path ?? "management/installer",
    meta: installerHa6vG1j1TIMeta || {},
    alias: installerHa6vG1j1TIMeta?.alias || [],
    redirect: installerHa6vG1j1TIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/installer.vue").then(m => m.default || m)
  },
  {
    name: complement_45modaljV12VPYWLTMeta?.name ?? "design-toc-management-modal-complement-modal",
    path: complement_45modaljV12VPYWLTMeta?.path ?? "management/modal/complement-modal",
    meta: complement_45modaljV12VPYWLTMeta || {},
    alias: complement_45modaljV12VPYWLTMeta?.alias || [],
    redirect: complement_45modaljV12VPYWLTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/complement-modal.vue").then(m => m.default || m)
  },
  {
    name: complete_45modalM9MjSHKgNoMeta?.name ?? "design-toc-management-modal-complete-modal",
    path: complete_45modalM9MjSHKgNoMeta?.path ?? "management/modal/complete-modal",
    meta: complete_45modalM9MjSHKgNoMeta || {},
    alias: complete_45modalM9MjSHKgNoMeta?.alias || [],
    redirect: complete_45modalM9MjSHKgNoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/complete-modal.vue").then(m => m.default || m)
  },
  {
    name: installer_45req_45modaln0EX3VtDBAMeta?.name ?? "design-toc-management-modal-installer-req-modal",
    path: installer_45req_45modaln0EX3VtDBAMeta?.path ?? "management/modal/installer-req-modal",
    meta: installer_45req_45modaln0EX3VtDBAMeta || {},
    alias: installer_45req_45modaln0EX3VtDBAMeta?.alias || [],
    redirect: installer_45req_45modaln0EX3VtDBAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/installer-req-modal.vue").then(m => m.default || m)
  },
  {
    name: owner_45modal0ejhg9PuNtMeta?.name ?? "design-toc-management-modal-owner-modal",
    path: owner_45modal0ejhg9PuNtMeta?.path ?? "management/modal/owner-modal",
    meta: owner_45modal0ejhg9PuNtMeta || {},
    alias: owner_45modal0ejhg9PuNtMeta?.alias || [],
    redirect: owner_45modal0ejhg9PuNtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/owner-modal.vue").then(m => m.default || m)
  },
  {
    name: reset_45modalLnfhEk42HNMeta?.name ?? "design-toc-management-modal-reset-modal",
    path: reset_45modalLnfhEk42HNMeta?.path ?? "management/modal/reset-modal",
    meta: reset_45modalLnfhEk42HNMeta || {},
    alias: reset_45modalLnfhEk42HNMeta?.alias || [],
    redirect: reset_45modalLnfhEk42HNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/reset-modal.vue").then(m => m.default || m)
  },
  {
    name: rtu_45chg_45modalG3N799iJWfMeta?.name ?? "design-toc-management-modal-rtu-chg-modal",
    path: rtu_45chg_45modalG3N799iJWfMeta?.path ?? "management/modal/rtu-chg-modal",
    meta: rtu_45chg_45modalG3N799iJWfMeta || {},
    alias: rtu_45chg_45modalG3N799iJWfMeta?.alias || [],
    redirect: rtu_45chg_45modalG3N799iJWfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/rtu-chg-modal.vue").then(m => m.default || m)
  },
  {
    name: rtu_45sms_45modalcNtoVBOqGkMeta?.name ?? "design-toc-management-modal-rtu-sms-modal",
    path: rtu_45sms_45modalcNtoVBOqGkMeta?.path ?? "management/modal/rtu-sms-modal",
    meta: rtu_45sms_45modalcNtoVBOqGkMeta || {},
    alias: rtu_45sms_45modalcNtoVBOqGkMeta?.alias || [],
    redirect: rtu_45sms_45modalcNtoVBOqGkMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/modal/rtu-sms-modal.vue").then(m => m.default || m)
  },
  {
    name: req_45detailsHN9PEGL0bMeta?.name ?? "design-toc-management-req-detail",
    path: req_45detailsHN9PEGL0bMeta?.path ?? "management/req-detail",
    meta: req_45detailsHN9PEGL0bMeta || {},
    alias: req_45detailsHN9PEGL0bMeta?.alias || [],
    redirect: req_45detailsHN9PEGL0bMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/req-detail.vue").then(m => m.default || m)
  },
  {
    name: rtu_45info_45details0MQp5If2MMeta?.name ?? "design-toc-management-rtu-info-detail",
    path: rtu_45info_45details0MQp5If2MMeta?.path ?? "management/rtu-info-detail",
    meta: rtu_45info_45details0MQp5If2MMeta || {},
    alias: rtu_45info_45details0MQp5If2MMeta?.alias || [],
    redirect: rtu_45info_45details0MQp5If2MMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-info-detail.vue").then(m => m.default || m)
  },
  {
    name: rtu_45infoT1ratNSEmSMeta?.name ?? "design-toc-management-rtu-info",
    path: rtu_45infoT1ratNSEmSMeta?.path ?? "management/rtu-info",
    meta: rtu_45infoT1ratNSEmSMeta || {},
    alias: rtu_45infoT1ratNSEmSMeta?.alias || [],
    redirect: rtu_45infoT1ratNSEmSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-info.vue").then(m => m.default || m)
  },
  {
    name: rtu_45install_45companyV5Xahk4aI0Meta?.name ?? "design-toc-management-rtu-install-company",
    path: rtu_45install_45companyV5Xahk4aI0Meta?.path ?? "management/rtu-install-company",
    meta: rtu_45install_45companyV5Xahk4aI0Meta || {},
    alias: rtu_45install_45companyV5Xahk4aI0Meta?.alias || [],
    redirect: rtu_45install_45companyV5Xahk4aI0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-install-company.vue").then(m => m.default || m)
  },
  {
    name: rtu_45install_45regionPkXXhFUkWoMeta?.name ?? "design-toc-management-rtu-install-region",
    path: rtu_45install_45regionPkXXhFUkWoMeta?.path ?? "management/rtu-install-region",
    meta: rtu_45install_45regionPkXXhFUkWoMeta || {},
    alias: rtu_45install_45regionPkXXhFUkWoMeta?.alias || [],
    redirect: rtu_45install_45regionPkXXhFUkWoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-install-region.vue").then(m => m.default || m)
  },
  {
    name: rtu_45install_45reportNKtBztNMGkMeta?.name ?? "design-toc-management-rtu-install-report",
    path: rtu_45install_45reportNKtBztNMGkMeta?.path ?? "management/rtu-install-report",
    meta: rtu_45install_45reportNKtBztNMGkMeta || {},
    alias: rtu_45install_45reportNKtBztNMGkMeta?.alias || [],
    redirect: rtu_45install_45reportNKtBztNMGkMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-install-report.vue").then(m => m.default || m)
  },
  {
    name: rtu_45installerMIq8QiOz2DMeta?.name ?? "design-toc-management-rtu-installer",
    path: rtu_45installerMIq8QiOz2DMeta?.path ?? "management/rtu-installer",
    meta: rtu_45installerMIq8QiOz2DMeta || {},
    alias: rtu_45installerMIq8QiOz2DMeta?.alias || [],
    redirect: rtu_45installerMIq8QiOz2DMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/management/rtu-installer.vue").then(m => m.default || m)
  },
  {
    name: indexwvq2GRzRuJMeta?.name ?? "design-toc-map",
    path: indexwvq2GRzRuJMeta?.path ?? "map",
    meta: indexwvq2GRzRuJMeta || {},
    alias: indexwvq2GRzRuJMeta?.alias || [],
    redirect: indexwvq2GRzRuJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/map/index.vue").then(m => m.default || m)
  },
  {
    path: settingT7nSD26frsMeta?.path ?? "setting",
    children: [
  {
    name: indexynUrh6V8vmMeta?.name ?? "design-toc-setting",
    path: indexynUrh6V8vmMeta?.path ?? "",
    meta: indexynUrh6V8vmMeta || {},
    alias: indexynUrh6V8vmMeta?.alias || [],
    redirect: indexynUrh6V8vmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/setting/index.vue").then(m => m.default || m)
  }
],
    name: settingT7nSD26frsMeta?.name ?? undefined,
    meta: settingT7nSD26frsMeta || {},
    alias: settingT7nSD26frsMeta?.alias || [],
    redirect: settingT7nSD26frsMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/setting.vue").then(m => m.default || m)
  },
  {
    name: siteecHL6Fl0W9Meta?.name ?? "design-toc-site",
    path: siteecHL6Fl0W9Meta?.path ?? "site",
    meta: siteecHL6Fl0W9Meta || {},
    alias: siteecHL6Fl0W9Meta?.alias || [],
    redirect: siteecHL6Fl0W9Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/site.vue").then(m => m.default || m)
  },
  {
    name: detail8LlGCoQOaKMeta?.name ?? "design-toc-sites-detail",
    path: detail8LlGCoQOaKMeta?.path ?? "sites/detail",
    meta: detail8LlGCoQOaKMeta || {},
    alias: detail8LlGCoQOaKMeta?.alias || [],
    redirect: detail8LlGCoQOaKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/sites/detail.vue").then(m => m.default || m)
  },
  {
    name: detail2fxGcmceo4Meta?.name ?? "design-toc-sites-equip-detail",
    path: detail2fxGcmceo4Meta?.path ?? "sites/equip/detail",
    meta: detail2fxGcmceo4Meta || {},
    alias: detail2fxGcmceo4Meta?.alias || [],
    redirect: detail2fxGcmceo4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/sites/equip/detail.vue").then(m => m.default || m)
  },
  {
    name: indexpa59JuyEpzMeta?.name ?? "design-toc-sites-equip",
    path: indexpa59JuyEpzMeta?.path ?? "sites/equip",
    meta: indexpa59JuyEpzMeta || {},
    alias: indexpa59JuyEpzMeta?.alias || [],
    redirect: indexpa59JuyEpzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/sites/equip/index.vue").then(m => m.default || m)
  },
  {
    name: indexf7Gb0hQhyIMeta?.name ?? "design-toc-sites",
    path: indexf7Gb0hQhyIMeta?.path ?? "sites",
    meta: indexf7Gb0hQhyIMeta || {},
    alias: indexf7Gb0hQhyIMeta?.alias || [],
    redirect: indexf7Gb0hQhyIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/sites/index.vue").then(m => m.default || m)
  },
  {
    name: prod_45infoFxTiLKfHYeMeta?.name ?? "design-toc-sites-prod-info",
    path: prod_45infoFxTiLKfHYeMeta?.path ?? "sites/prod-info",
    meta: prod_45infoFxTiLKfHYeMeta || {},
    alias: prod_45infoFxTiLKfHYeMeta?.alias || [],
    redirect: prod_45infoFxTiLKfHYeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/sites/prod-info.vue").then(m => m.default || m)
  },
  {
    name: indexfjgNVMrd1HMeta?.name ?? "design-toc-terms",
    path: indexfjgNVMrd1HMeta?.path ?? "terms",
    meta: indexfjgNVMrd1HMeta || {},
    alias: indexfjgNVMrd1HMeta?.alias || [],
    redirect: indexfjgNVMrd1HMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/terms/index.vue").then(m => m.default || m)
  },
  {
    name: terms1ttUJ7FSjUaMeta?.name ?? "design-toc-terms-terms-list-terms1",
    path: terms1ttUJ7FSjUaMeta?.path ?? "terms/terms-list/terms1",
    meta: terms1ttUJ7FSjUaMeta || {},
    alias: terms1ttUJ7FSjUaMeta?.alias || [],
    redirect: terms1ttUJ7FSjUaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/terms/terms-list/terms1.vue").then(m => m.default || m)
  },
  {
    name: terms2NN2TRyEy00Meta?.name ?? "design-toc-terms-terms-list-terms2",
    path: terms2NN2TRyEy00Meta?.path ?? "terms/terms-list/terms2",
    meta: terms2NN2TRyEy00Meta || {},
    alias: terms2NN2TRyEy00Meta?.alias || [],
    redirect: terms2NN2TRyEy00Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/terms/terms-list/terms2.vue").then(m => m.default || m)
  },
  {
    name: termsh1lf427VlmMeta?.name ?? "design-toc-terms-terms",
    path: termsh1lf427VlmMeta?.path ?? "terms/terms",
    meta: termsh1lf427VlmMeta || {},
    alias: termsh1lf427VlmMeta?.alias || [],
    redirect: termsh1lf427VlmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/terms/terms.vue").then(m => m.default || m)
  },
  {
    name: indexoKMCly8tx4Meta?.name ?? "design-toc-user-service",
    path: indexoKMCly8tx4Meta?.path ?? "user-service",
    meta: indexoKMCly8tx4Meta || {},
    alias: indexoKMCly8tx4Meta?.alias || [],
    redirect: indexoKMCly8tx4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/index.vue").then(m => m.default || m)
  },
  {
    name: manager_45info0RwoHnf4xCMeta?.name ?? "design-toc-user-service-manager-info",
    path: manager_45info0RwoHnf4xCMeta?.path ?? "user-service/manager-info",
    meta: manager_45info0RwoHnf4xCMeta || {},
    alias: manager_45info0RwoHnf4xCMeta?.alias || [],
    redirect: manager_45info0RwoHnf4xCMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/manager-info.vue").then(m => m.default || m)
  },
  {
    name: confirm_45modalJlCONOWSliMeta?.name ?? "design-toc-user-service-modal-confirm-modal",
    path: confirm_45modalJlCONOWSliMeta?.path ?? "user-service/modal/confirm-modal",
    meta: confirm_45modalJlCONOWSliMeta || {},
    alias: confirm_45modalJlCONOWSliMeta?.alias || [],
    redirect: confirm_45modalJlCONOWSliMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/modal/confirm-modal.vue").then(m => m.default || m)
  },
  {
    name: manager_45add_45modalp8uivch4uyMeta?.name ?? "design-toc-user-service-modal-manager-add-modal",
    path: manager_45add_45modalp8uivch4uyMeta?.path ?? "user-service/modal/manager-add-modal",
    meta: manager_45add_45modalp8uivch4uyMeta || {},
    alias: manager_45add_45modalp8uivch4uyMeta?.alias || [],
    redirect: manager_45add_45modalp8uivch4uyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/modal/manager-add-modal.vue").then(m => m.default || m)
  },
  {
    name: manager_45modify_45modalfjkcj0yWZmMeta?.name ?? "design-toc-user-service-modal-manager-modify-modal",
    path: manager_45modify_45modalfjkcj0yWZmMeta?.path ?? "user-service/modal/manager-modify-modal",
    meta: manager_45modify_45modalfjkcj0yWZmMeta || {},
    alias: manager_45modify_45modalfjkcj0yWZmMeta?.alias || [],
    redirect: manager_45modify_45modalfjkcj0yWZmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/modal/manager-modify-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45manager_45all_45modalb984jpFvQSMeta?.name ?? "design-toc-user-service-modal-set-manager-all-modal",
    path: set_45manager_45all_45modalb984jpFvQSMeta?.path ?? "user-service/modal/set-manager-all-modal",
    meta: set_45manager_45all_45modalb984jpFvQSMeta || {},
    alias: set_45manager_45all_45modalb984jpFvQSMeta?.alias || [],
    redirect: set_45manager_45all_45modalb984jpFvQSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/modal/set-manager-all-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45manager_45select_45modalTUCFTOMcLOMeta?.name ?? "design-toc-user-service-modal-set-manager-select-modal",
    path: set_45manager_45select_45modalTUCFTOMcLOMeta?.path ?? "user-service/modal/set-manager-select-modal",
    meta: set_45manager_45select_45modalTUCFTOMcLOMeta || {},
    alias: set_45manager_45select_45modalTUCFTOMcLOMeta?.alias || [],
    redirect: set_45manager_45select_45modalTUCFTOMcLOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/modal/set-manager-select-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45managerHQqzYZVq9OMeta?.name ?? "design-toc-user-service-set-manager",
    path: set_45managerHQqzYZVq9OMeta?.path ?? "user-service/set-manager",
    meta: set_45managerHQqzYZVq9OMeta || {},
    alias: set_45managerHQqzYZVq9OMeta?.alias || [],
    redirect: set_45managerHQqzYZVq9OMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/set-manager.vue").then(m => m.default || m)
  },
  {
    name: user_45infoZRxxclCgNVMeta?.name ?? "design-toc-user-service-user-info",
    path: user_45infoZRxxclCgNVMeta?.path ?? "user-service/user-info",
    meta: user_45infoZRxxclCgNVMeta || {},
    alias: user_45infoZRxxclCgNVMeta?.alias || [],
    redirect: user_45infoZRxxclCgNVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/user-info.vue").then(m => m.default || m)
  },
  {
    name: user_45setting5yq3gbt3hUMeta?.name ?? "design-toc-user-service-user-setting",
    path: user_45setting5yq3gbt3hUMeta?.path ?? "user-service/user-setting",
    meta: user_45setting5yq3gbt3hUMeta || {},
    alias: user_45setting5yq3gbt3hUMeta?.alias || [],
    redirect: user_45setting5yq3gbt3hUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user-service/user-setting.vue").then(m => m.default || m)
  },
  {
    name: indexZBweQnTq6FMeta?.name ?? "design-toc-user",
    path: indexZBweQnTq6FMeta?.path ?? "user",
    meta: indexZBweQnTq6FMeta || {},
    alias: indexZBweQnTq6FMeta?.alias || [],
    redirect: indexZBweQnTq6FMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user/index.vue").then(m => m.default || m)
  },
  {
    name: loginyiMfkX8WLJMeta?.name ?? "design-toc-user-login",
    path: loginyiMfkX8WLJMeta?.path ?? "user/login",
    meta: loginyiMfkX8WLJMeta || {},
    alias: loginyiMfkX8WLJMeta?.alias || [],
    redirect: loginyiMfkX8WLJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc/user/login.vue").then(m => m.default || m)
  }
],
    name: design_45tocgeG2RHQ6fOMeta?.name ?? undefined,
    meta: design_45tocgeG2RHQ6fOMeta || {},
    alias: design_45tocgeG2RHQ6fOMeta?.alias || [],
    redirect: design_45tocgeG2RHQ6fOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/design-toc.vue").then(m => m.default || m)
  },
  {
    name: erroru1QQm49Hu7Meta?.name ?? "error",
    path: erroru1QQm49Hu7Meta?.path ?? "/error",
    meta: erroru1QQm49Hu7Meta || {},
    alias: erroru1QQm49Hu7Meta?.alias || [],
    redirect: erroru1QQm49Hu7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/error.vue").then(m => m.default || m)
  },
  {
    name: indexKgX6wSpKKqMeta?.name ?? "index",
    path: indexKgX6wSpKKqMeta?.path ?? "/",
    meta: indexKgX6wSpKKqMeta || {},
    alias: indexKgX6wSpKKqMeta?.alias || [],
    redirect: indexKgX6wSpKKqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: mobilerx7WDqPN3bMeta?.name ?? "mobile",
    path: mobilerx7WDqPN3bMeta?.path ?? "/mobile",
    children: [
  {
    name: search_45regionFvGl40tZ7gMeta?.name ?? "mobile-components-search-region",
    path: search_45regionFvGl40tZ7gMeta?.path ?? "components/search-region",
    meta: search_45regionFvGl40tZ7gMeta || {},
    alias: search_45regionFvGl40tZ7gMeta?.alias || [],
    redirect: search_45regionFvGl40tZ7gMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/components/search-region.vue").then(m => m.default || m)
  },
  {
    name: error_45pagegd3QzkZlRtMeta?.name ?? "mobile-error-page",
    path: error_45pagegd3QzkZlRtMeta?.path ?? "error-page",
    meta: error_45pagegd3QzkZlRtMeta || {},
    alias: error_45pagegd3QzkZlRtMeta?.alias || [],
    redirect: error_45pagegd3QzkZlRtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/error-page.vue").then(m => m.default || m)
  },
  {
    name: install_45guideMOBq51LFu0Meta?.name ?? "mobile-install-guide",
    path: install_45guideMOBq51LFu0Meta?.path ?? "install-guide",
    children: [
  {
    name: rtu_45100a_45guidexxXTDs5gkhMeta?.name ?? "mobile-install-guide-rtu-100a-guide",
    path: rtu_45100a_45guidexxXTDs5gkhMeta?.path ?? "rtu-100a-guide",
    meta: rtu_45100a_45guidexxXTDs5gkhMeta || {},
    alias: rtu_45100a_45guidexxXTDs5gkhMeta?.alias || [],
    redirect: rtu_45100a_45guidexxXTDs5gkhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/install-guide/rtu-100a-guide.vue").then(m => m.default || m)
  },
  {
    name: rtu_45200_45guideKZx48GzXNRMeta?.name ?? "mobile-install-guide-rtu-200-guide",
    path: rtu_45200_45guideKZx48GzXNRMeta?.path ?? "rtu-200-guide",
    meta: rtu_45200_45guideKZx48GzXNRMeta || {},
    alias: rtu_45200_45guideKZx48GzXNRMeta?.alias || [],
    redirect: rtu_45200_45guideKZx48GzXNRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/install-guide/rtu-200-guide.vue").then(m => m.default || m)
  }
],
    meta: install_45guideMOBq51LFu0Meta || {},
    alias: install_45guideMOBq51LFu0Meta?.alias || [],
    redirect: install_45guideMOBq51LFu0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/install-guide.vue").then(m => m.default || m)
  },
  {
    name: installerreUCNJy71YMeta?.name ?? "mobile-installer",
    path: installerreUCNJy71YMeta?.path ?? "installer",
    children: [
  {
    name: installer_45headerj35zyAjF1gMeta?.name ?? "mobile-installer-installer-header",
    path: installer_45headerj35zyAjF1gMeta?.path ?? "installer-header",
    meta: installer_45headerj35zyAjF1gMeta || {},
    alias: installer_45headerj35zyAjF1gMeta?.alias || [],
    redirect: installer_45headerj35zyAjF1gMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/installer-header.vue").then(m => m.default || m)
  },
  {
    name: all_45request88LuJUN6nSMeta?.name ?? "mobile-installer-ownerwork-all-request",
    path: all_45request88LuJUN6nSMeta?.path ?? "ownerwork/all-request",
    meta: all_45request88LuJUN6nSMeta || {},
    alias: all_45request88LuJUN6nSMeta?.alias || [],
    redirect: all_45request88LuJUN6nSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/all-request.vue").then(m => m.default || m)
  },
  {
    name: check_45owner_45formerWNVyfsAziKMeta?.name ?? "mobile-installer-ownerwork-check-owner-former",
    path: check_45owner_45formerWNVyfsAziKMeta?.path ?? "ownerwork/check-owner-former",
    meta: check_45owner_45formerWNVyfsAziKMeta || {},
    alias: check_45owner_45formerWNVyfsAziKMeta?.alias || [],
    redirect: check_45owner_45formerWNVyfsAziKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/check-owner-former.vue").then(m => m.default || m)
  },
  {
    name: check_45owner_45map_45kakaood6t2eceSDMeta?.name ?? "mobile-installer-ownerwork-check-owner-map-kakao",
    path: check_45owner_45map_45kakaood6t2eceSDMeta?.path ?? "ownerwork/check-owner-map-kakao",
    meta: check_45owner_45map_45kakaood6t2eceSDMeta || {},
    alias: check_45owner_45map_45kakaood6t2eceSDMeta?.alias || [],
    redirect: check_45owner_45map_45kakaood6t2eceSDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/check-owner-map-kakao.vue").then(m => m.default || m)
  },
  {
    name: check_45owner_45mapAdNrdedzVHMeta?.name ?? "mobile-installer-ownerwork-check-owner-map",
    path: check_45owner_45mapAdNrdedzVHMeta?.path ?? "ownerwork/check-owner-map",
    meta: check_45owner_45mapAdNrdedzVHMeta || {},
    alias: check_45owner_45mapAdNrdedzVHMeta?.alias || [],
    redirect: check_45owner_45mapAdNrdedzVHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/check-owner-map.vue").then(m => m.default || m)
  },
  {
    name: check_45ownerMhgJTNXBoXMeta?.name ?? "mobile-installer-ownerwork-check-owner",
    path: check_45ownerMhgJTNXBoXMeta?.path ?? "ownerwork/check-owner",
    meta: check_45ownerMhgJTNXBoXMeta || {},
    alias: check_45ownerMhgJTNXBoXMeta?.alias || [],
    redirect: check_45ownerMhgJTNXBoXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/check-owner.vue").then(m => m.default || m)
  },
  {
    name: history_45requestgcpBNbRELFMeta?.name ?? "mobile-installer-ownerwork-history-request",
    path: history_45requestgcpBNbRELFMeta?.path ?? "ownerwork/history-request",
    meta: history_45requestgcpBNbRELFMeta || {},
    alias: history_45requestgcpBNbRELFMeta?.alias || [],
    redirect: history_45requestgcpBNbRELFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/history-request.vue").then(m => m.default || m)
  },
  {
    name: historylistuMmAbwRNSpMeta?.name ?? "mobile-installer-ownerwork-historylist",
    path: historylistuMmAbwRNSpMeta?.path ?? "ownerwork/historylist",
    meta: historylistuMmAbwRNSpMeta || {},
    alias: historylistuMmAbwRNSpMeta?.alias || [],
    redirect: historylistuMmAbwRNSpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/historylist.vue").then(m => m.default || m)
  },
  {
    name: indexeiO0LGCiQuMeta?.name ?? "mobile-installer-ownerwork",
    path: indexeiO0LGCiQuMeta?.path ?? "ownerwork",
    meta: indexeiO0LGCiQuMeta || {},
    alias: indexeiO0LGCiQuMeta?.alias || [],
    redirect: indexeiO0LGCiQuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/index.vue").then(m => m.default || m)
  },
  {
    name: ownerlistRzmkrSrCLuMeta?.name ?? "mobile-installer-ownerwork-ownerlist",
    path: ownerlistRzmkrSrCLuMeta?.path ?? "ownerwork/ownerlist",
    meta: ownerlistRzmkrSrCLuMeta || {},
    alias: ownerlistRzmkrSrCLuMeta?.alias || [],
    redirect: ownerlistRzmkrSrCLuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/ownerwork/ownerlist.vue").then(m => m.default || m)
  },
  {
    name: all_45policyBu0fBa3ehWMeta?.name ?? "mobile-installer-policy-all-policy",
    path: all_45policyBu0fBa3ehWMeta?.path ?? "policy/all-policy",
    meta: all_45policyBu0fBa3ehWMeta || {},
    alias: all_45policyBu0fBa3ehWMeta?.alias || [],
    redirect: all_45policyBu0fBa3ehWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/policy/all-policy.vue").then(m => m.default || m)
  },
  {
    name: indexE8V9GrkgZPMeta?.name ?? "mobile-installer-policy",
    path: indexE8V9GrkgZPMeta?.path ?? "policy",
    meta: indexE8V9GrkgZPMeta || {},
    alias: indexE8V9GrkgZPMeta?.alias || [],
    redirect: indexE8V9GrkgZPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/policy/index.vue").then(m => m.default || m)
  },
  {
    name: install_45policyEhZ8RSYwPaMeta?.name ?? "mobile-installer-policy-install-policy",
    path: install_45policyEhZ8RSYwPaMeta?.path ?? "policy/install-policy",
    meta: install_45policyEhZ8RSYwPaMeta || {},
    alias: install_45policyEhZ8RSYwPaMeta?.alias || [],
    redirect: install_45policyEhZ8RSYwPaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/policy/install-policy.vue").then(m => m.default || m)
  },
  {
    name: check6ONBUrMmyTMeta?.name ?? "mobile-installer-rtu-connect-check",
    path: check6ONBUrMmyTMeta?.path ?? "rtu-connect/check",
    meta: check6ONBUrMmyTMeta || {},
    alias: check6ONBUrMmyTMeta?.alias || [],
    redirect: check6ONBUrMmyTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-connect/check.vue").then(m => m.default || m)
  },
  {
    name: connectrfXg06JpAHMeta?.name ?? "mobile-installer-rtu-connect-connect",
    path: connectrfXg06JpAHMeta?.path ?? "rtu-connect/connect",
    meta: connectrfXg06JpAHMeta || {},
    alias: connectrfXg06JpAHMeta?.alias || [],
    redirect: connectrfXg06JpAHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-connect/connect.vue").then(m => m.default || m)
  },
  {
    name: indexhmGnI7bVCDMeta?.name ?? "mobile-installer-rtu-connect",
    path: indexhmGnI7bVCDMeta?.path ?? "rtu-connect",
    meta: indexhmGnI7bVCDMeta || {},
    alias: indexhmGnI7bVCDMeta?.alias || [],
    redirect: indexhmGnI7bVCDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-connect/index.vue").then(m => m.default || m)
  },
  {
    name: rtu_45isonB2H5FzlwluMeta?.name ?? "mobile-installer-rtu-connect-rtu-ison",
    path: rtu_45isonB2H5FzlwluMeta?.path ?? "rtu-connect/rtu-ison",
    meta: rtu_45isonB2H5FzlwluMeta || {},
    alias: rtu_45isonB2H5FzlwluMeta?.alias || [],
    redirect: rtu_45isonB2H5FzlwluMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-connect/rtu-ison.vue").then(m => m.default || m)
  },
  {
    name: indexd6o5Lcf0x6Meta?.name ?? "mobile-installer-rtu-install",
    path: indexd6o5Lcf0x6Meta?.path ?? "rtu-install",
    meta: indexd6o5Lcf0x6Meta || {},
    alias: indexd6o5Lcf0x6Meta?.alias || [],
    redirect: indexd6o5Lcf0x6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-install/index.vue").then(m => m.default || m)
  },
  {
    name: installgcnCgnsrmEMeta?.name ?? "mobile-installer-rtu-install-install",
    path: installgcnCgnsrmEMeta?.path ?? "rtu-install/install",
    meta: installgcnCgnsrmEMeta || {},
    alias: installgcnCgnsrmEMeta?.alias || [],
    redirect: installgcnCgnsrmEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-install/install.vue").then(m => m.default || m)
  },
  {
    name: qr_45readerqCFUb3XO3xMeta?.name ?? "mobile-installer-rtu-install-qr-reader",
    path: qr_45readerqCFUb3XO3xMeta?.path ?? "rtu-install/qr-reader",
    meta: qr_45readerqCFUb3XO3xMeta || {},
    alias: qr_45readerqCFUb3XO3xMeta?.alias || [],
    redirect: qr_45readerqCFUb3XO3xMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-install/qr-reader.vue").then(m => m.default || m)
  },
  {
    name: uninstallT0yFzqW24RMeta?.name ?? "mobile-installer-rtu-install-uninstall",
    path: uninstallT0yFzqW24RMeta?.path ?? "rtu-install/uninstall",
    meta: uninstallT0yFzqW24RMeta || {},
    alias: uninstallT0yFzqW24RMeta?.alias || [],
    redirect: uninstallT0yFzqW24RMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/rtu-install/uninstall.vue").then(m => m.default || m)
  },
  {
    name: cmpl_workinfoUygdbbAzhrMeta?.name ?? "mobile-installer-workhistory-cmpl_workinfo",
    path: cmpl_workinfoUygdbbAzhrMeta?.path ?? "workhistory/cmpl_workinfo",
    meta: cmpl_workinfoUygdbbAzhrMeta || {},
    alias: cmpl_workinfoUygdbbAzhrMeta?.alias || [],
    redirect: cmpl_workinfoUygdbbAzhrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/workhistory/cmpl_workinfo.vue").then(m => m.default || m)
  },
  {
    name: indexwKKj6HNr0iMeta?.name ?? "mobile-installer-workhistory",
    path: indexwKKj6HNr0iMeta?.path ?? "workhistory",
    meta: indexwKKj6HNr0iMeta || {},
    alias: indexwKKj6HNr0iMeta?.alias || [],
    redirect: indexwKKj6HNr0iMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/workhistory/index.vue").then(m => m.default || m)
  },
  {
    name: workinfo0fwMCbv3dTMeta?.name ?? "mobile-installer-workhistory-workinfo",
    path: workinfo0fwMCbv3dTMeta?.path ?? "workhistory/workinfo",
    meta: workinfo0fwMCbv3dTMeta || {},
    alias: workinfo0fwMCbv3dTMeta?.alias || [],
    redirect: workinfo0fwMCbv3dTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer/workhistory/workinfo.vue").then(m => m.default || m)
  }
],
    meta: installerreUCNJy71YMeta || {},
    alias: installerreUCNJy71YMeta?.alias || [],
    redirect: installerreUCNJy71YMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/installer.vue").then(m => m.default || m)
  },
  {
    name: none_45contents_45page9mtv6jLHcOMeta?.name ?? "mobile-none-contents-page",
    path: none_45contents_45page9mtv6jLHcOMeta?.path ?? "none-contents-page",
    meta: none_45contents_45page9mtv6jLHcOMeta || {},
    alias: none_45contents_45page9mtv6jLHcOMeta?.alias || [],
    redirect: none_45contents_45page9mtv6jLHcOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/none-contents-page.vue").then(m => m.default || m)
  },
  {
    name: old_45privacy_45policyhqEoMKZucUMeta?.name ?? "mobile-old-privacy-policy",
    path: old_45privacy_45policyhqEoMKZucUMeta?.path ?? "old-privacy-policy",
    children: [
  {
    name: _250208rwWS04dcTOMeta?.name ?? "mobile-old-privacy-policy-250208",
    path: _250208rwWS04dcTOMeta?.path ?? "250208",
    meta: _250208rwWS04dcTOMeta || {},
    alias: _250208rwWS04dcTOMeta?.alias || [],
    redirect: _250208rwWS04dcTOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/old-privacy-policy/250208.vue").then(m => m.default || m)
  }
],
    meta: old_45privacy_45policyhqEoMKZucUMeta || {},
    alias: old_45privacy_45policyhqEoMKZucUMeta?.alias || [],
    redirect: old_45privacy_45policyhqEoMKZucUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/old-privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy8i18rpCMKzMeta?.name ?? "mobile-privacy-policy",
    path: privacy_45policy8i18rpCMKzMeta?.path ?? "privacy-policy",
    meta: privacy_45policy8i18rpCMKzMeta || {},
    alias: privacy_45policy8i18rpCMKzMeta?.alias || [],
    redirect: privacy_45policy8i18rpCMKzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: usage_45policyeH2fQENuhfMeta?.name ?? "mobile-usage-policy",
    path: usage_45policyeH2fQENuhfMeta?.path ?? "usage-policy",
    meta: usage_45policyeH2fQENuhfMeta || {},
    alias: usage_45policyeH2fQENuhfMeta?.alias || [],
    redirect: usage_45policyeH2fQENuhfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/usage-policy.vue").then(m => m.default || m)
  },
  {
    name: userP7Jquh6C14Meta?.name ?? "mobile-user",
    path: userP7Jquh6C14Meta?.path ?? "user",
    children: [
  {
    path: _91id_93j66U11xk1tMeta?.path ?? ":id",
    children: [
  {
    name: changePassa5jkUYfIVtMeta?.name ?? "mobile-user-id-changePass",
    path: changePassa5jkUYfIVtMeta?.path ?? "changePass",
    meta: changePassa5jkUYfIVtMeta || {},
    alias: changePassa5jkUYfIVtMeta?.alias || [],
    redirect: changePassa5jkUYfIVtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/changePass.vue").then(m => m.default || m)
  },
  {
    name: csuSGXCnJn8DMeta?.name ?? "mobile-user-id-cs",
    path: csuSGXCnJn8DMeta?.path ?? "cs",
    children: [
  {
    name: _10_questionUhaJztsKtuMeta?.name ?? "mobile-user-id-cs-guide-company-10_question",
    path: _10_questionUhaJztsKtuMeta?.path ?? "guide/company/10_question",
    meta: _10_questionUhaJztsKtuMeta || {},
    alias: _10_questionUhaJztsKtuMeta?.alias || [],
    redirect: _10_questionUhaJztsKtuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/10_question.vue").then(m => m.default || m)
  },
  {
    name: _1_serviceOverview4fAgJNtHdYMeta?.name ?? "mobile-user-id-cs-guide-company-1_serviceOverview",
    path: _1_serviceOverview4fAgJNtHdYMeta?.path ?? "guide/company/1_serviceOverview",
    meta: _1_serviceOverview4fAgJNtHdYMeta || {},
    alias: _1_serviceOverview4fAgJNtHdYMeta?.alias || [],
    redirect: _1_serviceOverview4fAgJNtHdYMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/1_serviceOverview.vue").then(m => m.default || m)
  },
  {
    name: _2_statusxZmLFuxE5dMeta?.name ?? "mobile-user-id-cs-guide-company-2_status",
    path: _2_statusxZmLFuxE5dMeta?.path ?? "guide/company/2_status",
    meta: _2_statusxZmLFuxE5dMeta || {},
    alias: _2_statusxZmLFuxE5dMeta?.alias || [],
    redirect: _2_statusxZmLFuxE5dMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/2_status.vue").then(m => m.default || m)
  },
  {
    name: _3_equipSelectYhvglSooSAMeta?.name ?? "mobile-user-id-cs-guide-company-3_equipSelect",
    path: _3_equipSelectYhvglSooSAMeta?.path ?? "guide/company/3_equipSelect",
    meta: _3_equipSelectYhvglSooSAMeta || {},
    alias: _3_equipSelectYhvglSooSAMeta?.alias || [],
    redirect: _3_equipSelectYhvglSooSAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/3_equipSelect.vue").then(m => m.default || m)
  },
  {
    name: _4_instruAokjzCll1UMeta?.name ?? "mobile-user-id-cs-guide-company-4_instru",
    path: _4_instruAokjzCll1UMeta?.path ?? "guide/company/4_instru",
    meta: _4_instruAokjzCll1UMeta || {},
    alias: _4_instruAokjzCll1UMeta?.alias || [],
    redirect: _4_instruAokjzCll1UMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/4_instru.vue").then(m => m.default || m)
  },
  {
    name: _5_equipInfookaltzIB1MMeta?.name ?? "mobile-user-id-cs-guide-company-5_equipInfo",
    path: _5_equipInfookaltzIB1MMeta?.path ?? "guide/company/5_equipInfo",
    meta: _5_equipInfookaltzIB1MMeta || {},
    alias: _5_equipInfookaltzIB1MMeta?.alias || [],
    redirect: _5_equipInfookaltzIB1MMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/5_equipInfo.vue").then(m => m.default || m)
  },
  {
    name: _6_eventqAFOXtSCvyMeta?.name ?? "mobile-user-id-cs-guide-company-6_event",
    path: _6_eventqAFOXtSCvyMeta?.path ?? "guide/company/6_event",
    meta: _6_eventqAFOXtSCvyMeta || {},
    alias: _6_eventqAFOXtSCvyMeta?.alias || [],
    redirect: _6_eventqAFOXtSCvyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/6_event.vue").then(m => m.default || m)
  },
  {
    name: _7_powerGenerationOPC5OnnsSAMeta?.name ?? "mobile-user-id-cs-guide-company-7_powerGeneration",
    path: _7_powerGenerationOPC5OnnsSAMeta?.path ?? "guide/company/7_powerGeneration",
    meta: _7_powerGenerationOPC5OnnsSAMeta || {},
    alias: _7_powerGenerationOPC5OnnsSAMeta?.alias || [],
    redirect: _7_powerGenerationOPC5OnnsSAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/7_powerGeneration.vue").then(m => m.default || m)
  },
  {
    name: _8_installInfo2WGCKhAWcUMeta?.name ?? "mobile-user-id-cs-guide-company-8_installInfo",
    path: _8_installInfo2WGCKhAWcUMeta?.path ?? "guide/company/8_installInfo",
    meta: _8_installInfo2WGCKhAWcUMeta || {},
    alias: _8_installInfo2WGCKhAWcUMeta?.alias || [],
    redirect: _8_installInfo2WGCKhAWcUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/8_installInfo.vue").then(m => m.default || m)
  },
  {
    name: _9_ownerInfoGwQYAOlyWLMeta?.name ?? "mobile-user-id-cs-guide-company-9_ownerInfo",
    path: _9_ownerInfoGwQYAOlyWLMeta?.path ?? "guide/company/9_ownerInfo",
    meta: _9_ownerInfoGwQYAOlyWLMeta || {},
    alias: _9_ownerInfoGwQYAOlyWLMeta?.alias || [],
    redirect: _9_ownerInfoGwQYAOlyWLMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/company/9_ownerInfo.vue").then(m => m.default || m)
  },
  {
    name: indexdNacet36upMeta?.name ?? "mobile-user-id-cs-guide",
    path: indexdNacet36upMeta?.path ?? "guide",
    meta: indexdNacet36upMeta || {},
    alias: indexdNacet36upMeta?.alias || [],
    redirect: indexdNacet36upMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/index.vue").then(m => m.default || m)
  },
  {
    name: _1_serviceOverviewEal3g8UmBhMeta?.name ?? "mobile-user-id-cs-guide-owner-1_serviceOverview",
    path: _1_serviceOverviewEal3g8UmBhMeta?.path ?? "guide/owner/1_serviceOverview",
    meta: _1_serviceOverviewEal3g8UmBhMeta || {},
    alias: _1_serviceOverviewEal3g8UmBhMeta?.alias || [],
    redirect: _1_serviceOverviewEal3g8UmBhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/1_serviceOverview.vue").then(m => m.default || m)
  },
  {
    name: _2_statusFadXcGUhj7Meta?.name ?? "mobile-user-id-cs-guide-owner-2_status",
    path: _2_statusFadXcGUhj7Meta?.path ?? "guide/owner/2_status",
    meta: _2_statusFadXcGUhj7Meta || {},
    alias: _2_statusFadXcGUhj7Meta?.alias || [],
    redirect: _2_statusFadXcGUhj7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/2_status.vue").then(m => m.default || m)
  },
  {
    name: _3_monitoringiLFWm9BgSzMeta?.name ?? "mobile-user-id-cs-guide-owner-3_monitoring",
    path: _3_monitoringiLFWm9BgSzMeta?.path ?? "guide/owner/3_monitoring",
    meta: _3_monitoringiLFWm9BgSzMeta || {},
    alias: _3_monitoringiLFWm9BgSzMeta?.alias || [],
    redirect: _3_monitoringiLFWm9BgSzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/3_monitoring.vue").then(m => m.default || m)
  },
  {
    name: _4_equipInfoJMZ4XEpxAHMeta?.name ?? "mobile-user-id-cs-guide-owner-4_equipInfo",
    path: _4_equipInfoJMZ4XEpxAHMeta?.path ?? "guide/owner/4_equipInfo",
    meta: _4_equipInfoJMZ4XEpxAHMeta || {},
    alias: _4_equipInfoJMZ4XEpxAHMeta?.alias || [],
    redirect: _4_equipInfoJMZ4XEpxAHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/4_equipInfo.vue").then(m => m.default || m)
  },
  {
    name: _5_powerGenerationQMxo83H1DsMeta?.name ?? "mobile-user-id-cs-guide-owner-5_powerGeneration",
    path: _5_powerGenerationQMxo83H1DsMeta?.path ?? "guide/owner/5_powerGeneration",
    meta: _5_powerGenerationQMxo83H1DsMeta || {},
    alias: _5_powerGenerationQMxo83H1DsMeta?.alias || [],
    redirect: _5_powerGenerationQMxo83H1DsMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/5_powerGeneration.vue").then(m => m.default || m)
  },
  {
    name: _6_report1wZvp5N7d4Meta?.name ?? "mobile-user-id-cs-guide-owner-6_report",
    path: _6_report1wZvp5N7d4Meta?.path ?? "guide/owner/6_report",
    meta: _6_report1wZvp5N7d4Meta || {},
    alias: _6_report1wZvp5N7d4Meta?.alias || [],
    redirect: _6_report1wZvp5N7d4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/6_report.vue").then(m => m.default || m)
  },
  {
    name: _7_eventDgd2gt2X4jMeta?.name ?? "mobile-user-id-cs-guide-owner-7_event",
    path: _7_eventDgd2gt2X4jMeta?.path ?? "guide/owner/7_event",
    meta: _7_eventDgd2gt2X4jMeta || {},
    alias: _7_eventDgd2gt2X4jMeta?.alias || [],
    redirect: _7_eventDgd2gt2X4jMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/7_event.vue").then(m => m.default || m)
  },
  {
    name: _8_ownerInfoKke0JbLevNMeta?.name ?? "mobile-user-id-cs-guide-owner-8_ownerInfo",
    path: _8_ownerInfoKke0JbLevNMeta?.path ?? "guide/owner/8_ownerInfo",
    meta: _8_ownerInfoKke0JbLevNMeta || {},
    alias: _8_ownerInfoKke0JbLevNMeta?.alias || [],
    redirect: _8_ownerInfoKke0JbLevNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/8_ownerInfo.vue").then(m => m.default || m)
  },
  {
    name: _9_questionMlYyxsojGOMeta?.name ?? "mobile-user-id-cs-guide-owner-9_question",
    path: _9_questionMlYyxsojGOMeta?.path ?? "guide/owner/9_question",
    meta: _9_questionMlYyxsojGOMeta || {},
    alias: _9_questionMlYyxsojGOMeta?.alias || [],
    redirect: _9_questionMlYyxsojGOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/guide/owner/9_question.vue").then(m => m.default || m)
  },
  {
    name: locationTermsycrGNDeCs5Meta?.name ?? "mobile-user-id-cs-locationTerms",
    path: locationTermsycrGNDeCs5Meta?.path ?? "locationTerms",
    meta: locationTermsycrGNDeCs5Meta || {},
    alias: locationTermsycrGNDeCs5Meta?.alias || [],
    redirect: locationTermsycrGNDeCs5Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/locationTerms.vue").then(m => m.default || m)
  },
  {
    name: maincghzDswFwXMeta?.name ?? "mobile-user-id-cs-main",
    path: maincghzDswFwXMeta?.path ?? "main",
    meta: maincghzDswFwXMeta || {},
    alias: maincghzDswFwXMeta?.alias || [],
    redirect: maincghzDswFwXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/main.vue").then(m => m.default || m)
  },
  {
    name: oldTermswHlciJRmXrMeta?.name ?? "mobile-user-id-cs-oldTerms",
    path: oldTermswHlciJRmXrMeta?.path ?? "oldTerms",
    children: [
  {
    name: locationTermsHlGfDjKnivMeta?.name ?? "mobile-user-id-cs-oldTerms-locationTerms",
    path: locationTermsHlGfDjKnivMeta?.path ?? "locationTerms",
    meta: locationTermsHlGfDjKnivMeta || {},
    alias: locationTermsHlGfDjKnivMeta?.alias || [],
    redirect: locationTermsHlGfDjKnivMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms/locationTerms.vue").then(m => m.default || m)
  },
  {
    name: personTermsNS9GRhiqDbMeta?.name ?? "mobile-user-id-cs-oldTerms-personTerms",
    path: personTermsNS9GRhiqDbMeta?.path ?? "personTerms",
    children: [
  {
    name: _2503141HH4IgyoWUMeta?.name ?? "mobile-user-id-cs-oldTerms-personTerms-250314",
    path: _2503141HH4IgyoWUMeta?.path ?? "250314",
    meta: _2503141HH4IgyoWUMeta || {},
    alias: _2503141HH4IgyoWUMeta?.alias || [],
    redirect: _2503141HH4IgyoWUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms/personTerms/250314.vue").then(m => m.default || m)
  }
],
    meta: personTermsNS9GRhiqDbMeta || {},
    alias: personTermsNS9GRhiqDbMeta?.alias || [],
    redirect: personTermsNS9GRhiqDbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms/personTerms.vue").then(m => m.default || m)
  },
  {
    name: useTerms0iVQX1KCSzMeta?.name ?? "mobile-user-id-cs-oldTerms-useTerms",
    path: useTerms0iVQX1KCSzMeta?.path ?? "useTerms",
    children: [
  {
    name: _250314Dh2n0VTWDeMeta?.name ?? "mobile-user-id-cs-oldTerms-useTerms-250314",
    path: _250314Dh2n0VTWDeMeta?.path ?? "250314",
    meta: _250314Dh2n0VTWDeMeta || {},
    alias: _250314Dh2n0VTWDeMeta?.alias || [],
    redirect: _250314Dh2n0VTWDeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms/useTerms/250314.vue").then(m => m.default || m)
  }
],
    meta: useTerms0iVQX1KCSzMeta || {},
    alias: useTerms0iVQX1KCSzMeta?.alias || [],
    redirect: useTerms0iVQX1KCSzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms/useTerms.vue").then(m => m.default || m)
  }
],
    meta: oldTermswHlciJRmXrMeta || {},
    alias: oldTermswHlciJRmXrMeta?.alias || [],
    redirect: oldTermswHlciJRmXrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/oldTerms.vue").then(m => m.default || m)
  },
  {
    name: openSourceLKUf9m9LE7Meta?.name ?? "mobile-user-id-cs-openSource",
    path: openSourceLKUf9m9LE7Meta?.path ?? "openSource",
    meta: openSourceLKUf9m9LE7Meta || {},
    alias: openSourceLKUf9m9LE7Meta?.alias || [],
    redirect: openSourceLKUf9m9LE7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/openSource.vue").then(m => m.default || m)
  },
  {
    name: personTermsq0iTvkRuZSMeta?.name ?? "mobile-user-id-cs-personTerms",
    path: personTermsq0iTvkRuZSMeta?.path ?? "personTerms",
    meta: personTermsq0iTvkRuZSMeta || {},
    alias: personTermsq0iTvkRuZSMeta?.alias || [],
    redirect: personTermsq0iTvkRuZSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/personTerms.vue").then(m => m.default || m)
  },
  {
    name: questionI7dI2QticZMeta?.name ?? "mobile-user-id-cs-question",
    path: questionI7dI2QticZMeta?.path ?? "question",
    meta: questionI7dI2QticZMeta || {},
    alias: questionI7dI2QticZMeta?.alias || [],
    redirect: questionI7dI2QticZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/question.vue").then(m => m.default || m)
  },
  {
    name: useTermslVIazhU4o7Meta?.name ?? "mobile-user-id-cs-useTerms",
    path: useTermslVIazhU4o7Meta?.path ?? "useTerms",
    meta: useTermslVIazhU4o7Meta || {},
    alias: useTermslVIazhU4o7Meta?.alias || [],
    redirect: useTermslVIazhU4o7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs/useTerms.vue").then(m => m.default || m)
  }
],
    meta: csuSGXCnJn8DMeta || {},
    alias: csuSGXCnJn8DMeta?.alias || [],
    redirect: csuSGXCnJn8DMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/cs.vue").then(m => m.default || m)
  },
  {
    name: equip_45owner_45listDQl7G2CqYeMeta?.name ?? "mobile-user-id-equip-owner-list",
    path: equip_45owner_45listDQl7G2CqYeMeta?.path ?? "equip-owner-list",
    meta: equip_45owner_45listDQl7G2CqYeMeta || {},
    alias: equip_45owner_45listDQl7G2CqYeMeta?.alias || [],
    redirect: equip_45owner_45listDQl7G2CqYeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/equip-owner-list.vue").then(m => m.default || m)
  },
  {
    name: equipListko84NL5Al6Meta?.name ?? "mobile-user-id-equipList",
    path: equipListko84NL5Al6Meta?.path ?? "equipList",
    meta: equipListko84NL5Al6Meta || {},
    alias: equipListko84NL5Al6Meta?.alias || [],
    redirect: equipListko84NL5Al6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/equipList.vue").then(m => m.default || m)
  },
  {
    name: equipMapZ2Ve56Rar8Meta?.name ?? "mobile-user-id-equipMap",
    path: equipMapZ2Ve56Rar8Meta?.path ?? "equipMap",
    meta: equipMapZ2Ve56Rar8Meta || {},
    alias: equipMapZ2Ve56Rar8Meta?.alias || [],
    redirect: equipMapZ2Ve56Rar8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/equipMap.vue").then(m => m.default || m)
  },
  {
    name: equipseAV7JZ3QwNMeta?.name ?? "mobile-user-id-equips",
    path: equipseAV7JZ3QwNMeta?.path ?? "equips",
    meta: equipseAV7JZ3QwNMeta || {},
    alias: equipseAV7JZ3QwNMeta?.alias || [],
    redirect: equipseAV7JZ3QwNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/equips.vue").then(m => m.default || m)
  },
  {
    name: etcLpaOXbZJC4Meta?.name ?? "mobile-user-id-etc",
    path: etcLpaOXbZJC4Meta?.path ?? "etc",
    children: [
  {
    name: alarmdpf5LOGcrMMeta?.name ?? "mobile-user-id-etc-alarm",
    path: alarmdpf5LOGcrMMeta?.path ?? "alarm",
    children: [
  {
    name: alarmETCvOiJo7GuYrMeta?.name ?? "mobile-user-id-etc-alarm-alarmETC",
    path: alarmETCvOiJo7GuYrMeta?.path ?? "alarmETC",
    meta: alarmETCvOiJo7GuYrMeta || {},
    alias: alarmETCvOiJo7GuYrMeta?.alias || [],
    redirect: alarmETCvOiJo7GuYrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmETC.vue").then(m => m.default || m)
  },
  {
    name: alarmOBS8bJKLk3cImMeta?.name ?? "mobile-user-id-etc-alarm-alarmOBS",
    path: alarmOBS8bJKLk3cImMeta?.path ?? "alarmOBS",
    meta: alarmOBS8bJKLk3cImMeta || {},
    alias: alarmOBS8bJKLk3cImMeta?.alias || [],
    redirect: alarmOBS8bJKLk3cImMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmOBS.vue").then(m => m.default || m)
  },
  {
    name: alarmRTUmq8yQInxEHMeta?.name ?? "mobile-user-id-etc-alarm-alarmRTU",
    path: alarmRTUmq8yQInxEHMeta?.path ?? "alarmRTU",
    meta: alarmRTUmq8yQInxEHMeta || {},
    alias: alarmRTUmq8yQInxEHMeta?.alias || [],
    redirect: alarmRTUmq8yQInxEHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/alarm/alarmRTU.vue").then(m => m.default || m)
  },
  {
    name: allpKo9wqVJdeMeta?.name ?? "mobile-user-id-etc-alarm-all",
    path: allpKo9wqVJdeMeta?.path ?? "all",
    meta: allpKo9wqVJdeMeta || {},
    alias: allpKo9wqVJdeMeta?.alias || [],
    redirect: allpKo9wqVJdeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/alarm/all.vue").then(m => m.default || m)
  }
],
    meta: alarmdpf5LOGcrMMeta || {},
    alias: alarmdpf5LOGcrMMeta?.alias || [],
    redirect: alarmdpf5LOGcrMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/alarm.vue").then(m => m.default || m)
  },
  {
    path: noticeBoEVNs49J7Meta?.path ?? "notice",
    children: [
  {
    name: _91noticeid_93HBb2dstsHqMeta?.name ?? "mobile-user-id-etc-notice-noticeid",
    path: _91noticeid_93HBb2dstsHqMeta?.path ?? ":noticeid",
    meta: _91noticeid_93HBb2dstsHqMeta || {},
    alias: _91noticeid_93HBb2dstsHqMeta?.alias || [],
    redirect: _91noticeid_93HBb2dstsHqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/notice/[noticeid].vue").then(m => m.default || m)
  },
  {
    name: indexxlXe4hF25mMeta?.name ?? "mobile-user-id-etc-notice",
    path: indexxlXe4hF25mMeta?.path ?? "",
    meta: indexxlXe4hF25mMeta || {},
    alias: indexxlXe4hF25mMeta?.alias || [],
    redirect: indexxlXe4hF25mMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/notice/index.vue").then(m => m.default || m)
  }
],
    name: noticeBoEVNs49J7Meta?.name ?? undefined,
    meta: noticeBoEVNs49J7Meta || {},
    alias: noticeBoEVNs49J7Meta?.alias || [],
    redirect: noticeBoEVNs49J7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc/notice.vue").then(m => m.default || m)
  }
],
    meta: etcLpaOXbZJC4Meta || {},
    alias: etcLpaOXbZJC4Meta?.alias || [],
    redirect: etcLpaOXbZJC4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/etc.vue").then(m => m.default || m)
  },
  {
    name: index5DGxlHQAx3Meta?.name ?? "mobile-user-id",
    path: index5DGxlHQAx3Meta?.path ?? "",
    meta: index5DGxlHQAx3Meta || {},
    alias: index5DGxlHQAx3Meta?.alias || [],
    redirect: index5DGxlHQAx3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: infoIuPzo4ZYbKMeta?.name ?? "mobile-user-id-info",
    path: infoIuPzo4ZYbKMeta?.path ?? "info",
    children: [
  {
    name: contact_45changeEAVTIKTiAVMeta?.name ?? "mobile-user-id-info-contact-change",
    path: contact_45changeEAVTIKTiAVMeta?.path ?? "contact-change",
    meta: contact_45changeEAVTIKTiAVMeta || {},
    alias: contact_45changeEAVTIKTiAVMeta?.alias || [],
    redirect: contact_45changeEAVTIKTiAVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/info/contact-change.vue").then(m => m.default || m)
  },
  {
    name: mainZ8720bc55AMeta?.name ?? "mobile-user-id-info-main",
    path: mainZ8720bc55AMeta?.path ?? "main",
    meta: mainZ8720bc55AMeta || {},
    alias: mainZ8720bc55AMeta?.alias || [],
    redirect: mainZ8720bc55AMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/info/main.vue").then(m => m.default || m)
  },
  {
    name: pw_45change7yOdLClfHaMeta?.name ?? "mobile-user-id-info-pw-change",
    path: pw_45change7yOdLClfHaMeta?.path ?? "pw-change",
    meta: pw_45change7yOdLClfHaMeta || {},
    alias: pw_45change7yOdLClfHaMeta?.alias || [],
    redirect: pw_45change7yOdLClfHaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/info/pw-change.vue").then(m => m.default || m)
  },
  {
    name: user_45deleteOUrFbmh5GEMeta?.name ?? "mobile-user-id-info-user-delete",
    path: user_45deleteOUrFbmh5GEMeta?.path ?? "user-delete",
    meta: user_45deleteOUrFbmh5GEMeta || {},
    alias: user_45deleteOUrFbmh5GEMeta?.alias || [],
    redirect: user_45deleteOUrFbmh5GEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/info/user-delete.vue").then(m => m.default || m)
  }
],
    meta: infoIuPzo4ZYbKMeta || {},
    alias: infoIuPzo4ZYbKMeta?.alias || [],
    redirect: infoIuPzo4ZYbKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/info.vue").then(m => m.default || m)
  },
  {
    name: settingzkUO04faLqMeta?.name ?? "mobile-user-id-setting",
    path: settingzkUO04faLqMeta?.path ?? "setting",
    meta: settingzkUO04faLqMeta || {},
    alias: settingzkUO04faLqMeta?.alias || [],
    redirect: settingzkUO04faLqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/setting.vue").then(m => m.default || m)
  },
  {
    name: siteListsYmrvNvSH6Meta?.name ?? "mobile-user-id-siteList",
    path: siteListsYmrvNvSH6Meta?.path ?? "siteList",
    meta: siteListsYmrvNvSH6Meta || {},
    alias: siteListsYmrvNvSH6Meta?.alias || [],
    redirect: siteListsYmrvNvSH6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/siteList.vue").then(m => m.default || m)
  },
  {
    name: users_45list16WGW1zftqMeta?.name ?? "mobile-user-id-users-list",
    path: users_45list16WGW1zftqMeta?.path ?? "users-list",
    meta: users_45list16WGW1zftqMeta || {},
    alias: users_45list16WGW1zftqMeta?.alias || [],
    redirect: users_45list16WGW1zftqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/users-list.vue").then(m => m.default || m)
  },
  {
    name: viewsTgO1hONktvMeta?.name ?? "mobile-user-id-views",
    path: viewsTgO1hONktvMeta?.path ?? "views",
    children: [
  {
    name: FailoverEditdPz42QUPHtMeta?.name ?? "mobile-user-id-views-FailoverEdit",
    path: FailoverEditdPz42QUPHtMeta?.path ?? "FailoverEdit",
    meta: FailoverEditdPz42QUPHtMeta || {},
    alias: FailoverEditdPz42QUPHtMeta?.alias || [],
    redirect: FailoverEditdPz42QUPHtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/FailoverEdit.vue").then(m => m.default || m)
  },
  {
    name: equipInfogzGiusuikAMeta?.name ?? "mobile-user-id-views-equipInfo",
    path: equipInfogzGiusuikAMeta?.path ?? "equipInfo",
    children: [
  {
    path: ess29N7ZiWh1rMeta?.path ?? "company/ess",
    children: [
  {
    path: InstallInfoSCoQjQxhVDMeta?.path ?? "InstallInfo",
    children: [
  {
    name: indexjnbdSCAwfhMeta?.name ?? "mobile-user-id-views-equipInfo-company-ess-InstallInfo",
    path: indexjnbdSCAwfhMeta?.path ?? "",
    meta: indexjnbdSCAwfhMeta || {},
    alias: indexjnbdSCAwfhMeta?.alias || [],
    redirect: indexjnbdSCAwfhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfoSCoQjQxhVDMeta?.name ?? undefined,
    meta: InstallInfoSCoQjQxhVDMeta || {},
    alias: InstallInfoSCoQjQxhVDMeta?.alias || [],
    redirect: InstallInfoSCoQjQxhVDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfolCQzttoBnxMeta?.name ?? "mobile-user-id-views-equipInfo-company-ess-InstruInfo",
    path: InstruInfolCQzttoBnxMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartPCwUz3Qq4cMeta?.name ?? "mobile-user-id-views-equipInfo-company-ess-InstruInfo-chart",
    path: chartPCwUz3Qq4cMeta?.path ?? "chart",
    meta: chartPCwUz3Qq4cMeta || {},
    alias: chartPCwUz3Qq4cMeta?.alias || [],
    redirect: chartPCwUz3Qq4cMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: now5nOOXViatqMeta?.name ?? "mobile-user-id-views-equipInfo-company-ess-InstruInfo-now",
    path: now5nOOXViatqMeta?.path ?? "now",
    meta: now5nOOXViatqMeta || {},
    alias: now5nOOXViatqMeta?.alias || [],
    redirect: now5nOOXViatqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfolCQzttoBnxMeta || {},
    alias: InstruInfolCQzttoBnxMeta?.alias || [],
    redirect: InstruInfolCQzttoBnxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: index9gC8J1d1FyMeta?.name ?? "mobile-user-id-views-equipInfo-company-ess",
    path: index9gC8J1d1FyMeta?.path ?? "",
    meta: index9gC8J1d1FyMeta || {},
    alias: index9gC8J1d1FyMeta?.alias || [],
    redirect: index9gC8J1d1FyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess/index.vue").then(m => m.default || m)
  }
],
    name: ess29N7ZiWh1rMeta?.name ?? undefined,
    meta: ess29N7ZiWh1rMeta || {},
    alias: ess29N7ZiWh1rMeta?.alias || [],
    redirect: ess29N7ZiWh1rMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/ess.vue").then(m => m.default || m)
  },
  {
    path: fuelcell0UmRTgXimdMeta?.path ?? "company/fuelcell",
    children: [
  {
    path: InstallInfoSOL8OMaZPGMeta?.path ?? "InstallInfo",
    children: [
  {
    name: indexGp8J0Ohat7Meta?.name ?? "mobile-user-id-views-equipInfo-company-fuelcell-InstallInfo",
    path: indexGp8J0Ohat7Meta?.path ?? "",
    meta: indexGp8J0Ohat7Meta || {},
    alias: indexGp8J0Ohat7Meta?.alias || [],
    redirect: indexGp8J0Ohat7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfoSOL8OMaZPGMeta?.name ?? undefined,
    meta: InstallInfoSOL8OMaZPGMeta || {},
    alias: InstallInfoSOL8OMaZPGMeta?.alias || [],
    redirect: InstallInfoSOL8OMaZPGMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfoz8FdG2gKksMeta?.name ?? "mobile-user-id-views-equipInfo-company-fuelcell-InstruInfo",
    path: InstruInfoz8FdG2gKksMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartxlXkv5Ctd3Meta?.name ?? "mobile-user-id-views-equipInfo-company-fuelcell-InstruInfo-chart",
    path: chartxlXkv5Ctd3Meta?.path ?? "chart",
    meta: chartxlXkv5Ctd3Meta || {},
    alias: chartxlXkv5Ctd3Meta?.alias || [],
    redirect: chartxlXkv5Ctd3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowCZV6vGlFivMeta?.name ?? "mobile-user-id-views-equipInfo-company-fuelcell-InstruInfo-now",
    path: nowCZV6vGlFivMeta?.path ?? "now",
    meta: nowCZV6vGlFivMeta || {},
    alias: nowCZV6vGlFivMeta?.alias || [],
    redirect: nowCZV6vGlFivMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfoz8FdG2gKksMeta || {},
    alias: InstruInfoz8FdG2gKksMeta?.alias || [],
    redirect: InstruInfoz8FdG2gKksMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexNSWRw01f5qMeta?.name ?? "mobile-user-id-views-equipInfo-company-fuelcell",
    path: indexNSWRw01f5qMeta?.path ?? "",
    meta: indexNSWRw01f5qMeta || {},
    alias: indexNSWRw01f5qMeta?.alias || [],
    redirect: indexNSWRw01f5qMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell/index.vue").then(m => m.default || m)
  }
],
    name: fuelcell0UmRTgXimdMeta?.name ?? undefined,
    meta: fuelcell0UmRTgXimdMeta || {},
    alias: fuelcell0UmRTgXimdMeta?.alias || [],
    redirect: fuelcell0UmRTgXimdMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/fuelcell.vue").then(m => m.default || m)
  },
  {
    name: geo0eOUKSHfxlMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo",
    path: geo0eOUKSHfxlMeta?.path ?? "company/geo",
    children: [
  {
    name: InstallInfoiZxbvLV3p3Meta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstallInfo",
    path: InstallInfoiZxbvLV3p3Meta?.path ?? "InstallInfo",
    children: [
  {
    name: installV0g3gl4PVZMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstallInfo-install",
    path: installV0g3gl4PVZMeta?.path ?? "install",
    meta: installV0g3gl4PVZMeta || {},
    alias: installV0g3gl4PVZMeta?.alias || [],
    redirect: installV0g3gl4PVZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerFIRdyUC3wpMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstallInfo-manager",
    path: managerFIRdyUC3wpMeta?.path ?? "manager",
    meta: managerFIRdyUC3wpMeta || {},
    alias: managerFIRdyUC3wpMeta?.alias || [],
    redirect: managerFIRdyUC3wpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfoiZxbvLV3p3Meta || {},
    alias: InstallInfoiZxbvLV3p3Meta?.alias || [],
    redirect: InstallInfoiZxbvLV3p3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfoZueZdDK2QpMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstruInfo",
    path: InstruInfoZueZdDK2QpMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartUzQkJLj0UXMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstruInfo-chart",
    path: chartUzQkJLj0UXMeta?.path ?? "chart",
    meta: chartUzQkJLj0UXMeta || {},
    alias: chartUzQkJLj0UXMeta?.alias || [],
    redirect: chartUzQkJLj0UXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowh2TgZ792anMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-InstruInfo-now",
    path: nowh2TgZ792anMeta?.path ?? "now",
    meta: nowh2TgZ792anMeta || {},
    alias: nowh2TgZ792anMeta?.alias || [],
    redirect: nowh2TgZ792anMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfoZueZdDK2QpMeta || {},
    alias: InstruInfoZueZdDK2QpMeta?.alias || [],
    redirect: InstruInfoZueZdDK2QpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: SpecInfoWctTfs4VYMMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-SpecInfo",
    path: SpecInfoWctTfs4VYMMeta?.path ?? "SpecInfo",
    children: [
  {
    name: rtuMFOdbC2BHoMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-SpecInfo-rtu",
    path: rtuMFOdbC2BHoMeta?.path ?? "rtu",
    meta: rtuMFOdbC2BHoMeta || {},
    alias: rtuMFOdbC2BHoMeta?.alias || [],
    redirect: rtuMFOdbC2BHoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: specZjMHtaCHhzMeta?.name ?? "mobile-user-id-views-equipInfo-company-geo-SpecInfo-spec",
    path: specZjMHtaCHhzMeta?.path ?? "spec",
    meta: specZjMHtaCHhzMeta || {},
    alias: specZjMHtaCHhzMeta?.alias || [],
    redirect: specZjMHtaCHhzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: SpecInfoWctTfs4VYMMeta || {},
    alias: SpecInfoWctTfs4VYMMeta?.alias || [],
    redirect: SpecInfoWctTfs4VYMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo/SpecInfo.vue").then(m => m.default || m)
  }
],
    meta: geo0eOUKSHfxlMeta || {},
    alias: geo0eOUKSHfxlMeta?.alias || [],
    redirect: geo0eOUKSHfxlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/geo.vue").then(m => m.default || m)
  },
  {
    name: pvexD2ZMAQmfMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv",
    path: pvexD2ZMAQmfMeta?.path ?? "company/pv",
    children: [
  {
    name: InstallInfoQmXG4Wqob3Meta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstallInfo",
    path: InstallInfoQmXG4Wqob3Meta?.path ?? "InstallInfo",
    children: [
  {
    name: installKCshUDarkyMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstallInfo-install",
    path: installKCshUDarkyMeta?.path ?? "install",
    meta: installKCshUDarkyMeta || {},
    alias: installKCshUDarkyMeta?.alias || [],
    redirect: installKCshUDarkyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerCPaRTXz4ogMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstallInfo-manager",
    path: managerCPaRTXz4ogMeta?.path ?? "manager",
    meta: managerCPaRTXz4ogMeta || {},
    alias: managerCPaRTXz4ogMeta?.alias || [],
    redirect: managerCPaRTXz4ogMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfoQmXG4Wqob3Meta || {},
    alias: InstallInfoQmXG4Wqob3Meta?.alias || [],
    redirect: InstallInfoQmXG4Wqob3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfo2CASGnKrWMMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstruInfo",
    path: InstruInfo2CASGnKrWMMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartuzS9UiCmy5Meta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstruInfo-chart",
    path: chartuzS9UiCmy5Meta?.path ?? "chart",
    meta: chartuzS9UiCmy5Meta || {},
    alias: chartuzS9UiCmy5Meta?.alias || [],
    redirect: chartuzS9UiCmy5Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowvk6GPxh59FMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-InstruInfo-now",
    path: nowvk6GPxh59FMeta?.path ?? "now",
    meta: nowvk6GPxh59FMeta || {},
    alias: nowvk6GPxh59FMeta?.alias || [],
    redirect: nowvk6GPxh59FMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfo2CASGnKrWMMeta || {},
    alias: InstruInfo2CASGnKrWMMeta?.alias || [],
    redirect: InstruInfo2CASGnKrWMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: SpecInfo7PJO9Ztg3mMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-SpecInfo",
    path: SpecInfo7PJO9Ztg3mMeta?.path ?? "SpecInfo",
    children: [
  {
    name: rtukv2qCoOLZtMeta?.name ?? "mobile-user-id-views-equipInfo-company-pv-SpecInfo-rtu",
    path: rtukv2qCoOLZtMeta?.path ?? "rtu",
    meta: rtukv2qCoOLZtMeta || {},
    alias: rtukv2qCoOLZtMeta?.alias || [],
    redirect: rtukv2qCoOLZtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: specZNqZc5JK57Meta?.name ?? "mobile-user-id-views-equipInfo-company-pv-SpecInfo-spec",
    path: specZNqZc5JK57Meta?.path ?? "spec",
    meta: specZNqZc5JK57Meta || {},
    alias: specZNqZc5JK57Meta?.alias || [],
    redirect: specZNqZc5JK57Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: SpecInfo7PJO9Ztg3mMeta || {},
    alias: SpecInfo7PJO9Ztg3mMeta?.alias || [],
    redirect: SpecInfo7PJO9Ztg3mMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv/SpecInfo.vue").then(m => m.default || m)
  }
],
    meta: pvexD2ZMAQmfMeta || {},
    alias: pvexD2ZMAQmfMeta?.alias || [],
    redirect: pvexD2ZMAQmfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatcMxzJDauprMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat",
    path: solarheatcMxzJDauprMeta?.path ?? "company/solarheat",
    children: [
  {
    name: InstallInfosk1jaeYwBxMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstallInfo",
    path: InstallInfosk1jaeYwBxMeta?.path ?? "InstallInfo",
    children: [
  {
    name: installiUjcf24s0AMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstallInfo-install",
    path: installiUjcf24s0AMeta?.path ?? "install",
    meta: installiUjcf24s0AMeta || {},
    alias: installiUjcf24s0AMeta?.alias || [],
    redirect: installiUjcf24s0AMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerfo4oRVfk6FMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstallInfo-manager",
    path: managerfo4oRVfk6FMeta?.path ?? "manager",
    meta: managerfo4oRVfk6FMeta || {},
    alias: managerfo4oRVfk6FMeta?.alias || [],
    redirect: managerfo4oRVfk6FMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfosk1jaeYwBxMeta || {},
    alias: InstallInfosk1jaeYwBxMeta?.alias || [],
    redirect: InstallInfosk1jaeYwBxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfopgFn8JEgf0Meta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstruInfo",
    path: InstruInfopgFn8JEgf0Meta?.path ?? "InstruInfo",
    children: [
  {
    name: chartHaAaC2qj5JMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstruInfo-chart",
    path: chartHaAaC2qj5JMeta?.path ?? "chart",
    meta: chartHaAaC2qj5JMeta || {},
    alias: chartHaAaC2qj5JMeta?.alias || [],
    redirect: chartHaAaC2qj5JMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowQys5c7gXNLMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-InstruInfo-now",
    path: nowQys5c7gXNLMeta?.path ?? "now",
    meta: nowQys5c7gXNLMeta || {},
    alias: nowQys5c7gXNLMeta?.alias || [],
    redirect: nowQys5c7gXNLMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfopgFn8JEgf0Meta || {},
    alias: InstruInfopgFn8JEgf0Meta?.alias || [],
    redirect: InstruInfopgFn8JEgf0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: SpecInfotr8YVg17r3Meta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-SpecInfo",
    path: SpecInfotr8YVg17r3Meta?.path ?? "SpecInfo",
    children: [
  {
    name: rtu9lAfIt83KFMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-SpecInfo-rtu",
    path: rtu9lAfIt83KFMeta?.path ?? "rtu",
    meta: rtu9lAfIt83KFMeta || {},
    alias: rtu9lAfIt83KFMeta?.alias || [],
    redirect: rtu9lAfIt83KFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: spechM2v445rRuMeta?.name ?? "mobile-user-id-views-equipInfo-company-solarheat-SpecInfo-spec",
    path: spechM2v445rRuMeta?.path ?? "spec",
    meta: spechM2v445rRuMeta || {},
    alias: spechM2v445rRuMeta?.alias || [],
    redirect: spechM2v445rRuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: SpecInfotr8YVg17r3Meta || {},
    alias: SpecInfotr8YVg17r3Meta?.alias || [],
    redirect: SpecInfotr8YVg17r3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat/SpecInfo.vue").then(m => m.default || m)
  }
],
    meta: solarheatcMxzJDauprMeta || {},
    alias: solarheatcMxzJDauprMeta?.alias || [],
    redirect: solarheatcMxzJDauprMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/solarheat.vue").then(m => m.default || m)
  },
  {
    path: wf5OeLTQXOHUMeta?.path ?? "company/wf",
    children: [
  {
    path: InstallInfoSyB30KMCaJMeta?.path ?? "InstallInfo",
    children: [
  {
    name: index29V72ffyz3Meta?.name ?? "mobile-user-id-views-equipInfo-company-wf-InstallInfo",
    path: index29V72ffyz3Meta?.path ?? "",
    meta: index29V72ffyz3Meta || {},
    alias: index29V72ffyz3Meta?.alias || [],
    redirect: index29V72ffyz3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfoSyB30KMCaJMeta?.name ?? undefined,
    meta: InstallInfoSyB30KMCaJMeta || {},
    alias: InstallInfoSyB30KMCaJMeta?.alias || [],
    redirect: InstallInfoSyB30KMCaJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfoa0viLaWHKwMeta?.name ?? "mobile-user-id-views-equipInfo-company-wf-InstruInfo",
    path: InstruInfoa0viLaWHKwMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartGQfRpICnAlMeta?.name ?? "mobile-user-id-views-equipInfo-company-wf-InstruInfo-chart",
    path: chartGQfRpICnAlMeta?.path ?? "chart",
    meta: chartGQfRpICnAlMeta || {},
    alias: chartGQfRpICnAlMeta?.alias || [],
    redirect: chartGQfRpICnAlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowe15Vw0ZAzDMeta?.name ?? "mobile-user-id-views-equipInfo-company-wf-InstruInfo-now",
    path: nowe15Vw0ZAzDMeta?.path ?? "now",
    meta: nowe15Vw0ZAzDMeta || {},
    alias: nowe15Vw0ZAzDMeta?.alias || [],
    redirect: nowe15Vw0ZAzDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfoa0viLaWHKwMeta || {},
    alias: InstruInfoa0viLaWHKwMeta?.alias || [],
    redirect: InstruInfoa0viLaWHKwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: index9hW5rA0fqOMeta?.name ?? "mobile-user-id-views-equipInfo-company-wf",
    path: index9hW5rA0fqOMeta?.path ?? "",
    meta: index9hW5rA0fqOMeta || {},
    alias: index9hW5rA0fqOMeta?.alias || [],
    redirect: index9hW5rA0fqOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf/index.vue").then(m => m.default || m)
  }
],
    name: wf5OeLTQXOHUMeta?.name ?? undefined,
    meta: wf5OeLTQXOHUMeta || {},
    alias: wf5OeLTQXOHUMeta?.alias || [],
    redirect: wf5OeLTQXOHUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/company/wf.vue").then(m => m.default || m)
  },
  {
    path: esszz4qViiwfsMeta?.path ?? "owner/ess",
    children: [
  {
    path: InstallInfos59l9Z6JVXMeta?.path ?? "InstallInfo",
    children: [
  {
    name: indexIXxoE27wd0Meta?.name ?? "mobile-user-id-views-equipInfo-owner-ess-InstallInfo",
    path: indexIXxoE27wd0Meta?.path ?? "",
    meta: indexIXxoE27wd0Meta || {},
    alias: indexIXxoE27wd0Meta?.alias || [],
    redirect: indexIXxoE27wd0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfos59l9Z6JVXMeta?.name ?? undefined,
    meta: InstallInfos59l9Z6JVXMeta || {},
    alias: InstallInfos59l9Z6JVXMeta?.alias || [],
    redirect: InstallInfos59l9Z6JVXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfo4GEkXYelnlMeta?.name ?? "mobile-user-id-views-equipInfo-owner-ess-InstruInfo",
    path: InstruInfo4GEkXYelnlMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartlidyWJbiicMeta?.name ?? "mobile-user-id-views-equipInfo-owner-ess-InstruInfo-chart",
    path: chartlidyWJbiicMeta?.path ?? "chart",
    meta: chartlidyWJbiicMeta || {},
    alias: chartlidyWJbiicMeta?.alias || [],
    redirect: chartlidyWJbiicMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: now45iDhU7J4HMeta?.name ?? "mobile-user-id-views-equipInfo-owner-ess-InstruInfo-now",
    path: now45iDhU7J4HMeta?.path ?? "now",
    meta: now45iDhU7J4HMeta || {},
    alias: now45iDhU7J4HMeta?.alias || [],
    redirect: now45iDhU7J4HMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfo4GEkXYelnlMeta || {},
    alias: InstruInfo4GEkXYelnlMeta?.alias || [],
    redirect: InstruInfo4GEkXYelnlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexT0TRoqLjhmMeta?.name ?? "mobile-user-id-views-equipInfo-owner-ess",
    path: indexT0TRoqLjhmMeta?.path ?? "",
    meta: indexT0TRoqLjhmMeta || {},
    alias: indexT0TRoqLjhmMeta?.alias || [],
    redirect: indexT0TRoqLjhmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess/index.vue").then(m => m.default || m)
  }
],
    name: esszz4qViiwfsMeta?.name ?? undefined,
    meta: esszz4qViiwfsMeta || {},
    alias: esszz4qViiwfsMeta?.alias || [],
    redirect: esszz4qViiwfsMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/ess.vue").then(m => m.default || m)
  },
  {
    path: fuelcellIP0L82YMVeMeta?.path ?? "owner/fuelcell",
    children: [
  {
    path: InstallInfokiL2WDfGiXMeta?.path ?? "InstallInfo",
    children: [
  {
    name: index9iLvWRi4WSMeta?.name ?? "mobile-user-id-views-equipInfo-owner-fuelcell-InstallInfo",
    path: index9iLvWRi4WSMeta?.path ?? "",
    meta: index9iLvWRi4WSMeta || {},
    alias: index9iLvWRi4WSMeta?.alias || [],
    redirect: index9iLvWRi4WSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfokiL2WDfGiXMeta?.name ?? undefined,
    meta: InstallInfokiL2WDfGiXMeta || {},
    alias: InstallInfokiL2WDfGiXMeta?.alias || [],
    redirect: InstallInfokiL2WDfGiXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfoWQpnXK6yCJMeta?.name ?? "mobile-user-id-views-equipInfo-owner-fuelcell-InstruInfo",
    path: InstruInfoWQpnXK6yCJMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartSGCbTC3alcMeta?.name ?? "mobile-user-id-views-equipInfo-owner-fuelcell-InstruInfo-chart",
    path: chartSGCbTC3alcMeta?.path ?? "chart",
    meta: chartSGCbTC3alcMeta || {},
    alias: chartSGCbTC3alcMeta?.alias || [],
    redirect: chartSGCbTC3alcMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowAVDMgeJsVjMeta?.name ?? "mobile-user-id-views-equipInfo-owner-fuelcell-InstruInfo-now",
    path: nowAVDMgeJsVjMeta?.path ?? "now",
    meta: nowAVDMgeJsVjMeta || {},
    alias: nowAVDMgeJsVjMeta?.alias || [],
    redirect: nowAVDMgeJsVjMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfoWQpnXK6yCJMeta || {},
    alias: InstruInfoWQpnXK6yCJMeta?.alias || [],
    redirect: InstruInfoWQpnXK6yCJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexKutBRsIvqAMeta?.name ?? "mobile-user-id-views-equipInfo-owner-fuelcell",
    path: indexKutBRsIvqAMeta?.path ?? "",
    meta: indexKutBRsIvqAMeta || {},
    alias: indexKutBRsIvqAMeta?.alias || [],
    redirect: indexKutBRsIvqAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell/index.vue").then(m => m.default || m)
  }
],
    name: fuelcellIP0L82YMVeMeta?.name ?? undefined,
    meta: fuelcellIP0L82YMVeMeta || {},
    alias: fuelcellIP0L82YMVeMeta?.alias || [],
    redirect: fuelcellIP0L82YMVeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/fuelcell.vue").then(m => m.default || m)
  },
  {
    name: geo2lun2n81PVMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo",
    path: geo2lun2n81PVMeta?.path ?? "owner/geo",
    children: [
  {
    name: InstallInfoEuQCZuO8hRMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstallInfo",
    path: InstallInfoEuQCZuO8hRMeta?.path ?? "InstallInfo",
    children: [
  {
    name: installAWFWcJTgf6Meta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstallInfo-install",
    path: installAWFWcJTgf6Meta?.path ?? "install",
    meta: installAWFWcJTgf6Meta || {},
    alias: installAWFWcJTgf6Meta?.alias || [],
    redirect: installAWFWcJTgf6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerYU4RNCpZXFMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstallInfo-manager",
    path: managerYU4RNCpZXFMeta?.path ?? "manager",
    meta: managerYU4RNCpZXFMeta || {},
    alias: managerYU4RNCpZXFMeta?.alias || [],
    redirect: managerYU4RNCpZXFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfoEuQCZuO8hRMeta || {},
    alias: InstallInfoEuQCZuO8hRMeta?.alias || [],
    redirect: InstallInfoEuQCZuO8hRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfoahRdT9FihrMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstruInfo",
    path: InstruInfoahRdT9FihrMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartama5HOwZaFMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstruInfo-chart",
    path: chartama5HOwZaFMeta?.path ?? "chart",
    meta: chartama5HOwZaFMeta || {},
    alias: chartama5HOwZaFMeta?.alias || [],
    redirect: chartama5HOwZaFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: now4iLwoxQkFKMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-InstruInfo-now",
    path: now4iLwoxQkFKMeta?.path ?? "now",
    meta: now4iLwoxQkFKMeta || {},
    alias: now4iLwoxQkFKMeta?.alias || [],
    redirect: now4iLwoxQkFKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfoahRdT9FihrMeta || {},
    alias: InstruInfoahRdT9FihrMeta?.alias || [],
    redirect: InstruInfoahRdT9FihrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexM38GfIN34KMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-SpecInfo",
    path: indexM38GfIN34KMeta?.path ?? "SpecInfo",
    meta: indexM38GfIN34KMeta || {},
    alias: indexM38GfIN34KMeta?.alias || [],
    redirect: indexM38GfIN34KMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/index.vue").then(m => m.default || m)
  },
  {
    name: rtueb1aE0ySDLMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-SpecInfo-rtu",
    path: rtueb1aE0ySDLMeta?.path ?? "SpecInfo/rtu",
    meta: rtueb1aE0ySDLMeta || {},
    alias: rtueb1aE0ySDLMeta?.alias || [],
    redirect: rtueb1aE0ySDLMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: specLIm9El39UXMeta?.name ?? "mobile-user-id-views-equipInfo-owner-geo-SpecInfo-spec",
    path: specLIm9El39UXMeta?.path ?? "SpecInfo/spec",
    meta: specLIm9El39UXMeta || {},
    alias: specLIm9El39UXMeta?.alias || [],
    redirect: specLIm9El39UXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: geo2lun2n81PVMeta || {},
    alias: geo2lun2n81PVMeta?.alias || [],
    redirect: geo2lun2n81PVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/geo.vue").then(m => m.default || m)
  },
  {
    name: pvY9U64PkXxVMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv",
    path: pvY9U64PkXxVMeta?.path ?? "owner/pv",
    children: [
  {
    name: InstallInfo9CuHGW3pqfMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstallInfo",
    path: InstallInfo9CuHGW3pqfMeta?.path ?? "InstallInfo",
    children: [
  {
    name: installZSIj55JUIyMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstallInfo-install",
    path: installZSIj55JUIyMeta?.path ?? "install",
    meta: installZSIj55JUIyMeta || {},
    alias: installZSIj55JUIyMeta?.alias || [],
    redirect: installZSIj55JUIyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerYau2lDOlZfMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstallInfo-manager",
    path: managerYau2lDOlZfMeta?.path ?? "manager",
    meta: managerYau2lDOlZfMeta || {},
    alias: managerYau2lDOlZfMeta?.alias || [],
    redirect: managerYau2lDOlZfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfo9CuHGW3pqfMeta || {},
    alias: InstallInfo9CuHGW3pqfMeta?.alias || [],
    redirect: InstallInfo9CuHGW3pqfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfohCHvPu2apPMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstruInfo",
    path: InstruInfohCHvPu2apPMeta?.path ?? "InstruInfo",
    children: [
  {
    name: charto3v4YLhsMlMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstruInfo-chart",
    path: charto3v4YLhsMlMeta?.path ?? "chart",
    meta: charto3v4YLhsMlMeta || {},
    alias: charto3v4YLhsMlMeta?.alias || [],
    redirect: charto3v4YLhsMlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: instruinfo_45rawdatayrZlH8oBJxMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstruInfo-instruinfo-rawdata",
    path: instruinfo_45rawdatayrZlH8oBJxMeta?.path ?? "instruinfo-rawdata",
    meta: instruinfo_45rawdatayrZlH8oBJxMeta || {},
    alias: instruinfo_45rawdatayrZlH8oBJxMeta?.alias || [],
    redirect: instruinfo_45rawdatayrZlH8oBJxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/instruinfo-rawdata.vue").then(m => m.default || m)
  },
  {
    name: nowgs9T6vWk36Meta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-InstruInfo-now",
    path: nowgs9T6vWk36Meta?.path ?? "now",
    meta: nowgs9T6vWk36Meta || {},
    alias: nowgs9T6vWk36Meta?.alias || [],
    redirect: nowgs9T6vWk36Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfohCHvPu2apPMeta || {},
    alias: InstruInfohCHvPu2apPMeta?.alias || [],
    redirect: InstruInfohCHvPu2apPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexNBtapoBwxXMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-SpecInfo",
    path: indexNBtapoBwxXMeta?.path ?? "SpecInfo",
    meta: indexNBtapoBwxXMeta || {},
    alias: indexNBtapoBwxXMeta?.alias || [],
    redirect: indexNBtapoBwxXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/index.vue").then(m => m.default || m)
  },
  {
    name: rtuMzDt7jQR6vMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-SpecInfo-rtu",
    path: rtuMzDt7jQR6vMeta?.path ?? "SpecInfo/rtu",
    meta: rtuMzDt7jQR6vMeta || {},
    alias: rtuMzDt7jQR6vMeta?.alias || [],
    redirect: rtuMzDt7jQR6vMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: specn9kdAIPRcMMeta?.name ?? "mobile-user-id-views-equipInfo-owner-pv-SpecInfo-spec",
    path: specn9kdAIPRcMMeta?.path ?? "SpecInfo/spec",
    meta: specn9kdAIPRcMMeta || {},
    alias: specn9kdAIPRcMMeta?.alias || [],
    redirect: specn9kdAIPRcMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: pvY9U64PkXxVMeta || {},
    alias: pvY9U64PkXxVMeta?.alias || [],
    redirect: pvY9U64PkXxVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheat9FVmUtVm9XMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat",
    path: solarheat9FVmUtVm9XMeta?.path ?? "owner/solarheat",
    children: [
  {
    name: InstallInfoCkCMhFBXQRMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstallInfo",
    path: InstallInfoCkCMhFBXQRMeta?.path ?? "InstallInfo",
    children: [
  {
    name: installAuV6NSv9GTMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstallInfo-install",
    path: installAuV6NSv9GTMeta?.path ?? "install",
    meta: installAuV6NSv9GTMeta || {},
    alias: installAuV6NSv9GTMeta?.alias || [],
    redirect: installAuV6NSv9GTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo/install.vue").then(m => m.default || m)
  },
  {
    name: managerOr7AeD2AV6Meta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstallInfo-manager",
    path: managerOr7AeD2AV6Meta?.path ?? "manager",
    meta: managerOr7AeD2AV6Meta || {},
    alias: managerOr7AeD2AV6Meta?.alias || [],
    redirect: managerOr7AeD2AV6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo/manager.vue").then(m => m.default || m)
  }
],
    meta: InstallInfoCkCMhFBXQRMeta || {},
    alias: InstallInfoCkCMhFBXQRMeta?.alias || [],
    redirect: InstallInfoCkCMhFBXQRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstallInfo.vue").then(m => m.default || m)
  },
  {
    path: InstruInfoTVHlDbKQcKMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartu81clMuhepMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstruInfo-chart",
    path: chartu81clMuhepMeta?.path ?? "chart",
    meta: chartu81clMuhepMeta || {},
    alias: chartu81clMuhepMeta?.alias || [],
    redirect: chartu81clMuhepMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: indexuU58h0aQbfMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstruInfo",
    path: indexuU58h0aQbfMeta?.path ?? "",
    meta: indexuU58h0aQbfMeta || {},
    alias: indexuU58h0aQbfMeta?.alias || [],
    redirect: indexuU58h0aQbfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/index.vue").then(m => m.default || m)
  },
  {
    name: nowQvVZ6LXD5XMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-InstruInfo-now",
    path: nowQvVZ6LXD5XMeta?.path ?? "now",
    meta: nowQvVZ6LXD5XMeta || {},
    alias: nowQvVZ6LXD5XMeta?.alias || [],
    redirect: nowQvVZ6LXD5XMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    name: InstruInfoTVHlDbKQcKMeta?.name ?? undefined,
    meta: InstruInfoTVHlDbKQcKMeta || {},
    alias: InstruInfoTVHlDbKQcKMeta?.alias || [],
    redirect: InstruInfoTVHlDbKQcKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexhtJ4Yo4fIEMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-SpecInfo",
    path: indexhtJ4Yo4fIEMeta?.path ?? "SpecInfo",
    meta: indexhtJ4Yo4fIEMeta || {},
    alias: indexhtJ4Yo4fIEMeta?.alias || [],
    redirect: indexhtJ4Yo4fIEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/index.vue").then(m => m.default || m)
  },
  {
    name: rtuZPz1kE6hSBMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-SpecInfo-rtu",
    path: rtuZPz1kE6hSBMeta?.path ?? "SpecInfo/rtu",
    meta: rtuZPz1kE6hSBMeta || {},
    alias: rtuZPz1kE6hSBMeta?.alias || [],
    redirect: rtuZPz1kE6hSBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/rtu.vue").then(m => m.default || m)
  },
  {
    name: speckAJmWN15pFMeta?.name ?? "mobile-user-id-views-equipInfo-owner-solarheat-SpecInfo-spec",
    path: speckAJmWN15pFMeta?.path ?? "SpecInfo/spec",
    meta: speckAJmWN15pFMeta || {},
    alias: speckAJmWN15pFMeta?.alias || [],
    redirect: speckAJmWN15pFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat/SpecInfo/spec.vue").then(m => m.default || m)
  }
],
    meta: solarheat9FVmUtVm9XMeta || {},
    alias: solarheat9FVmUtVm9XMeta?.alias || [],
    redirect: solarheat9FVmUtVm9XMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/solarheat.vue").then(m => m.default || m)
  },
  {
    path: wfV8lH7QrPCqMeta?.path ?? "owner/wf",
    children: [
  {
    path: InstallInfoLzgS4c5oZOMeta?.path ?? "InstallInfo",
    children: [
  {
    name: indexbF5463gc7dMeta?.name ?? "mobile-user-id-views-equipInfo-owner-wf-InstallInfo",
    path: indexbF5463gc7dMeta?.path ?? "",
    meta: indexbF5463gc7dMeta || {},
    alias: indexbF5463gc7dMeta?.alias || [],
    redirect: indexbF5463gc7dMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstallInfo/index.vue").then(m => m.default || m)
  }
],
    name: InstallInfoLzgS4c5oZOMeta?.name ?? undefined,
    meta: InstallInfoLzgS4c5oZOMeta || {},
    alias: InstallInfoLzgS4c5oZOMeta?.alias || [],
    redirect: InstallInfoLzgS4c5oZOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: InstruInfou3KIf9hA3nMeta?.name ?? "mobile-user-id-views-equipInfo-owner-wf-InstruInfo",
    path: InstruInfou3KIf9hA3nMeta?.path ?? "InstruInfo",
    children: [
  {
    name: chartg0MmcZcq1TMeta?.name ?? "mobile-user-id-views-equipInfo-owner-wf-InstruInfo-chart",
    path: chartg0MmcZcq1TMeta?.path ?? "chart",
    meta: chartg0MmcZcq1TMeta || {},
    alias: chartg0MmcZcq1TMeta?.alias || [],
    redirect: chartg0MmcZcq1TMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo/chart.vue").then(m => m.default || m)
  },
  {
    name: nowTPgCuIND4pMeta?.name ?? "mobile-user-id-views-equipInfo-owner-wf-InstruInfo-now",
    path: nowTPgCuIND4pMeta?.path ?? "now",
    meta: nowTPgCuIND4pMeta || {},
    alias: nowTPgCuIND4pMeta?.alias || [],
    redirect: nowTPgCuIND4pMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo/now.vue").then(m => m.default || m)
  }
],
    meta: InstruInfou3KIf9hA3nMeta || {},
    alias: InstruInfou3KIf9hA3nMeta?.alias || [],
    redirect: InstruInfou3KIf9hA3nMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/InstruInfo.vue").then(m => m.default || m)
  },
  {
    name: indexwQn6usTnDrMeta?.name ?? "mobile-user-id-views-equipInfo-owner-wf",
    path: indexwQn6usTnDrMeta?.path ?? "",
    meta: indexwQn6usTnDrMeta || {},
    alias: indexwQn6usTnDrMeta?.alias || [],
    redirect: indexwQn6usTnDrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf/index.vue").then(m => m.default || m)
  }
],
    name: wfV8lH7QrPCqMeta?.name ?? undefined,
    meta: wfV8lH7QrPCqMeta || {},
    alias: wfV8lH7QrPCqMeta?.alias || [],
    redirect: wfV8lH7QrPCqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo/owner/wf.vue").then(m => m.default || m)
  }
],
    meta: equipInfogzGiusuikAMeta || {},
    alias: equipInfogzGiusuikAMeta?.alias || [],
    redirect: equipInfogzGiusuikAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/equipInfo.vue").then(m => m.default || m)
  },
  {
    name: eventYU5lQ9KjzTMeta?.name ?? "mobile-user-id-views-event",
    path: eventYU5lQ9KjzTMeta?.path ?? "event",
    children: [
  {
    name: FailoverUnU9JMLC5UMeta?.name ?? "mobile-user-id-views-event-Failover",
    path: FailoverUnU9JMLC5UMeta?.path ?? "Failover",
    meta: FailoverUnU9JMLC5UMeta || {},
    alias: FailoverUnU9JMLC5UMeta?.alias || [],
    redirect: FailoverUnU9JMLC5UMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event/Failover.vue").then(m => m.default || m)
  },
  {
    name: FailureZ8yMCqiawtMeta?.name ?? "mobile-user-id-views-event-Failure",
    path: FailureZ8yMCqiawtMeta?.path ?? "Failure",
    meta: FailureZ8yMCqiawtMeta || {},
    alias: FailureZ8yMCqiawtMeta?.alias || [],
    redirect: FailureZ8yMCqiawtMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event/Failure.vue").then(m => m.default || m)
  },
  {
    name: allOJFFiPHoKBMeta?.name ?? "mobile-user-id-views-event-all",
    path: allOJFFiPHoKBMeta?.path ?? "all",
    meta: allOJFFiPHoKBMeta || {},
    alias: allOJFFiPHoKBMeta?.alias || [],
    redirect: allOJFFiPHoKBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event/all.vue").then(m => m.default || m)
  },
  {
    name: eventHistory4A5SIUSq9hMeta?.name ?? "mobile-user-id-views-event-eventHistory",
    path: eventHistory4A5SIUSq9hMeta?.path ?? "eventHistory",
    meta: eventHistory4A5SIUSq9hMeta || {},
    alias: eventHistory4A5SIUSq9hMeta?.alias || [],
    redirect: eventHistory4A5SIUSq9hMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event/eventHistory.vue").then(m => m.default || m)
  },
  {
    name: rtuEventyp9TVkEYs8Meta?.name ?? "mobile-user-id-views-event-rtuEvent",
    path: rtuEventyp9TVkEYs8Meta?.path ?? "rtuEvent",
    meta: rtuEventyp9TVkEYs8Meta || {},
    alias: rtuEventyp9TVkEYs8Meta?.alias || [],
    redirect: rtuEventyp9TVkEYs8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event/rtuEvent.vue").then(m => m.default || m)
  }
],
    meta: eventYU5lQ9KjzTMeta || {},
    alias: eventYU5lQ9KjzTMeta?.alias || [],
    redirect: eventYU5lQ9KjzTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/event.vue").then(m => m.default || m)
  },
  {
    name: monitoringtKEmCBOlH5Meta?.name ?? "mobile-user-id-views-monitoring",
    path: monitoringtKEmCBOlH5Meta?.path ?? "monitoring",
    children: [
  {
    name: essVHuR8v64iJMeta?.name ?? "mobile-user-id-views-monitoring-ess",
    path: essVHuR8v64iJMeta?.path ?? "ess",
    meta: essVHuR8v64iJMeta || {},
    alias: essVHuR8v64iJMeta?.alias || [],
    redirect: essVHuR8v64iJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/ess.vue").then(m => m.default || m)
  },
  {
    name: fuelcellz2BbkeNLu1Meta?.name ?? "mobile-user-id-views-monitoring-fuelcell",
    path: fuelcellz2BbkeNLu1Meta?.path ?? "fuelcell",
    meta: fuelcellz2BbkeNLu1Meta || {},
    alias: fuelcellz2BbkeNLu1Meta?.alias || [],
    redirect: fuelcellz2BbkeNLu1Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/fuelcell.vue").then(m => m.default || m)
  },
  {
    name: geoRCJjOSXlrUMeta?.name ?? "mobile-user-id-views-monitoring-geo",
    path: geoRCJjOSXlrUMeta?.path ?? "geo",
    meta: geoRCJjOSXlrUMeta || {},
    alias: geoRCJjOSXlrUMeta?.alias || [],
    redirect: geoRCJjOSXlrUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/geo.vue").then(m => m.default || m)
  },
  {
    name: pvxX8D5sRrfBMeta?.name ?? "mobile-user-id-views-monitoring-pv",
    path: pvxX8D5sRrfBMeta?.path ?? "pv",
    meta: pvxX8D5sRrfBMeta || {},
    alias: pvxX8D5sRrfBMeta?.alias || [],
    redirect: pvxX8D5sRrfBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatojqsLDG2gBMeta?.name ?? "mobile-user-id-views-monitoring-solarheat",
    path: solarheatojqsLDG2gBMeta?.path ?? "solarheat",
    meta: solarheatojqsLDG2gBMeta || {},
    alias: solarheatojqsLDG2gBMeta?.alias || [],
    redirect: solarheatojqsLDG2gBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/solarheat.vue").then(m => m.default || m)
  },
  {
    name: wfCjKnxSvDYNMeta?.name ?? "mobile-user-id-views-monitoring-wf",
    path: wfCjKnxSvDYNMeta?.path ?? "wf",
    meta: wfCjKnxSvDYNMeta || {},
    alias: wfCjKnxSvDYNMeta?.alias || [],
    redirect: wfCjKnxSvDYNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring/wf.vue").then(m => m.default || m)
  }
],
    meta: monitoringtKEmCBOlH5Meta || {},
    alias: monitoringtKEmCBOlH5Meta?.alias || [],
    redirect: monitoringtKEmCBOlH5Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring.vue").then(m => m.default || m)
  },
  {
    name: monitoring_testKoT8seb0XFMeta?.name ?? "mobile-user-id-views-monitoring_test",
    path: monitoring_testKoT8seb0XFMeta?.path ?? "monitoring_test",
    meta: monitoring_testKoT8seb0XFMeta || {},
    alias: monitoring_testKoT8seb0XFMeta?.alias || [],
    redirect: monitoring_testKoT8seb0XFMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/monitoring_test.vue").then(m => m.default || m)
  },
  {
    name: more1xCZhk6kImMeta?.name ?? "mobile-user-id-views-more",
    path: more1xCZhk6kImMeta?.path ?? "more",
    children: [
  {
    name: InstallInfogv8XlDmHO3Meta?.name ?? "mobile-user-id-views-more-InstallInfo",
    path: InstallInfogv8XlDmHO3Meta?.path ?? "InstallInfo",
    meta: InstallInfogv8XlDmHO3Meta || {},
    alias: InstallInfogv8XlDmHO3Meta?.alias || [],
    redirect: InstallInfogv8XlDmHO3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/InstallInfo.vue").then(m => m.default || m)
  },
  {
    name: contractsxEEeAZpi30Meta?.name ?? "mobile-user-id-views-more-contracts",
    path: contractsxEEeAZpi30Meta?.path ?? "contracts",
    meta: contractsxEEeAZpi30Meta || {},
    alias: contractsxEEeAZpi30Meta?.alias || [],
    redirect: contractsxEEeAZpi30Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/contracts.vue").then(m => m.default || m)
  },
  {
    name: indicatorslTBHwmVNA7Meta?.name ?? "mobile-user-id-views-more-indicators",
    path: indicatorslTBHwmVNA7Meta?.path ?? "indicators",
    children: [
  {
    name: geoNFXLkYMBwRMeta?.name ?? "mobile-user-id-views-more-indicators-geo",
    path: geoNFXLkYMBwRMeta?.path ?? "geo",
    meta: geoNFXLkYMBwRMeta || {},
    alias: geoNFXLkYMBwRMeta?.alias || [],
    redirect: geoNFXLkYMBwRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/indicators/geo.vue").then(m => m.default || m)
  },
  {
    name: pvhTgBMnvEfyMeta?.name ?? "mobile-user-id-views-more-indicators-pv",
    path: pvhTgBMnvEfyMeta?.path ?? "pv",
    meta: pvhTgBMnvEfyMeta || {},
    alias: pvhTgBMnvEfyMeta?.alias || [],
    redirect: pvhTgBMnvEfyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/indicators/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatgzG2mBgtHoMeta?.name ?? "mobile-user-id-views-more-indicators-solarheat",
    path: solarheatgzG2mBgtHoMeta?.path ?? "solarheat",
    meta: solarheatgzG2mBgtHoMeta || {},
    alias: solarheatgzG2mBgtHoMeta?.alias || [],
    redirect: solarheatgzG2mBgtHoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/indicators/solarheat.vue").then(m => m.default || m)
  }
],
    meta: indicatorslTBHwmVNA7Meta || {},
    alias: indicatorslTBHwmVNA7Meta?.alias || [],
    redirect: indicatorslTBHwmVNA7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/indicators.vue").then(m => m.default || m)
  },
  {
    name: changeOwnerListGxWOUW5pdMMeta?.name ?? "mobile-user-id-views-more-installerConfirm-changeOwnerList",
    path: changeOwnerListGxWOUW5pdMMeta?.path ?? "installerConfirm/changeOwnerList",
    meta: changeOwnerListGxWOUW5pdMMeta || {},
    alias: changeOwnerListGxWOUW5pdMMeta?.alias || [],
    redirect: changeOwnerListGxWOUW5pdMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/changeOwnerList.vue").then(m => m.default || m)
  },
  {
    name: indexAxN9x43NtkMeta?.name ?? "mobile-user-id-views-more-installerConfirm",
    path: indexAxN9x43NtkMeta?.path ?? "installerConfirm",
    meta: indexAxN9x43NtkMeta || {},
    alias: indexAxN9x43NtkMeta?.alias || [],
    redirect: indexAxN9x43NtkMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/index.vue").then(m => m.default || m)
  },
  {
    name: installerConfirmeRcdBOlWi9Meta?.name ?? "mobile-user-id-views-more-installerConfirm-installerConfirm",
    path: installerConfirmeRcdBOlWi9Meta?.path ?? "installerConfirm/installerConfirm",
    meta: installerConfirmeRcdBOlWi9Meta || {},
    alias: installerConfirmeRcdBOlWi9Meta?.alias || [],
    redirect: installerConfirmeRcdBOlWi9Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirm.vue").then(m => m.default || m)
  },
  {
    name: installerConfirmDetail3FPUJQoDy7Meta?.name ?? "mobile-user-id-views-more-installerConfirm-installerConfirmDetail",
    path: installerConfirmDetail3FPUJQoDy7Meta?.path ?? "installerConfirm/installerConfirmDetail",
    meta: installerConfirmDetail3FPUJQoDy7Meta || {},
    alias: installerConfirmDetail3FPUJQoDy7Meta?.alias || [],
    redirect: installerConfirmDetail3FPUJQoDy7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmDetail.vue").then(m => m.default || m)
  },
  {
    name: installerConfirmHistoryBVOEkNJ5tHMeta?.name ?? "mobile-user-id-views-more-installerConfirm-installerConfirmHistory",
    path: installerConfirmHistoryBVOEkNJ5tHMeta?.path ?? "installerConfirm/installerConfirmHistory",
    meta: installerConfirmHistoryBVOEkNJ5tHMeta || {},
    alias: installerConfirmHistoryBVOEkNJ5tHMeta?.alias || [],
    redirect: installerConfirmHistoryBVOEkNJ5tHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmHistory.vue").then(m => m.default || m)
  },
  {
    name: installerConfirmRequest8uZrcmp4GlMeta?.name ?? "mobile-user-id-views-more-installerConfirm-installerConfirmRequest",
    path: installerConfirmRequest8uZrcmp4GlMeta?.path ?? "installerConfirm/installerConfirmRequest",
    meta: installerConfirmRequest8uZrcmp4GlMeta || {},
    alias: installerConfirmRequest8uZrcmp4GlMeta?.alias || [],
    redirect: installerConfirmRequest8uZrcmp4GlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/installerConfirm/installerConfirmRequest.vue").then(m => m.default || m)
  },
  {
    name: menugoSDo9KwhpMeta?.name ?? "mobile-user-id-views-more-menu",
    path: menugoSDo9KwhpMeta?.path ?? "menu",
    meta: menugoSDo9KwhpMeta || {},
    alias: menugoSDo9KwhpMeta?.alias || [],
    redirect: menugoSDo9KwhpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/menu.vue").then(m => m.default || m)
  },
  {
    name: _91noticeid_93BwZ5sVKBtwMeta?.name ?? "mobile-user-id-views-more-menuToNotice-noticeid",
    path: _91noticeid_93BwZ5sVKBtwMeta?.path ?? "menuToNotice/:noticeid",
    meta: _91noticeid_93BwZ5sVKBtwMeta || {},
    alias: _91noticeid_93BwZ5sVKBtwMeta?.alias || [],
    redirect: _91noticeid_93BwZ5sVKBtwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/menuToNotice/[noticeid].vue").then(m => m.default || m)
  },
  {
    name: ownerInfogdIt45mWisMeta?.name ?? "mobile-user-id-views-more-ownerInfo",
    path: ownerInfogdIt45mWisMeta?.path ?? "ownerInfo",
    meta: ownerInfogdIt45mWisMeta || {},
    alias: ownerInfogdIt45mWisMeta?.alias || [],
    redirect: ownerInfogdIt45mWisMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/ownerInfo.vue").then(m => m.default || m)
  },
  {
    name: predictedPowerxCoNgTtD3jMeta?.name ?? "mobile-user-id-views-more-predictedPower",
    path: predictedPowerxCoNgTtD3jMeta?.path ?? "predictedPower",
    meta: predictedPowerxCoNgTtD3jMeta || {},
    alias: predictedPowerxCoNgTtD3jMeta?.alias || [],
    redirect: predictedPowerxCoNgTtD3jMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/predictedPower.vue").then(m => m.default || m)
  },
  {
    name: siteInfo3rKAuABNMyMeta?.name ?? "mobile-user-id-views-more-siteInfo",
    path: siteInfo3rKAuABNMyMeta?.path ?? "siteInfo",
    meta: siteInfo3rKAuABNMyMeta || {},
    alias: siteInfo3rKAuABNMyMeta?.alias || [],
    redirect: siteInfo3rKAuABNMyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more/siteInfo.vue").then(m => m.default || m)
  }
],
    meta: more1xCZhk6kImMeta || {},
    alias: more1xCZhk6kImMeta?.alias || [],
    redirect: more1xCZhk6kImMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/more.vue").then(m => m.default || m)
  },
  {
    name: powerGenerationSxzCnLIvpcMeta?.name ?? "mobile-user-id-views-powerGeneration",
    path: powerGenerationSxzCnLIvpcMeta?.path ?? "powerGeneration",
    children: [
  {
    name: essssFYC19flxMeta?.name ?? "mobile-user-id-views-powerGeneration-ess",
    path: essssFYC19flxMeta?.path ?? "ess",
    meta: essssFYC19flxMeta || {},
    alias: essssFYC19flxMeta?.alias || [],
    redirect: essssFYC19flxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/ess.vue").then(m => m.default || m)
  },
  {
    name: fuelcellj0VexK96PlMeta?.name ?? "mobile-user-id-views-powerGeneration-fuelcell",
    path: fuelcellj0VexK96PlMeta?.path ?? "fuelcell",
    meta: fuelcellj0VexK96PlMeta || {},
    alias: fuelcellj0VexK96PlMeta?.alias || [],
    redirect: fuelcellj0VexK96PlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/fuelcell.vue").then(m => m.default || m)
  },
  {
    name: geo3AXsqr6wBmMeta?.name ?? "mobile-user-id-views-powerGeneration-geo",
    path: geo3AXsqr6wBmMeta?.path ?? "geo",
    meta: geo3AXsqr6wBmMeta || {},
    alias: geo3AXsqr6wBmMeta?.alias || [],
    redirect: geo3AXsqr6wBmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/geo.vue").then(m => m.default || m)
  },
  {
    name: pvrAuxcRX4hOMeta?.name ?? "mobile-user-id-views-powerGeneration-pv",
    path: pvrAuxcRX4hOMeta?.path ?? "pv",
    meta: pvrAuxcRX4hOMeta || {},
    alias: pvrAuxcRX4hOMeta?.alias || [],
    redirect: pvrAuxcRX4hOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatVjV095UmPhMeta?.name ?? "mobile-user-id-views-powerGeneration-solarheat",
    path: solarheatVjV095UmPhMeta?.path ?? "solarheat",
    meta: solarheatVjV095UmPhMeta || {},
    alias: solarheatVjV095UmPhMeta?.alias || [],
    redirect: solarheatVjV095UmPhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/solarheat.vue").then(m => m.default || m)
  },
  {
    name: wfTjbvvX6V6VMeta?.name ?? "mobile-user-id-views-powerGeneration-wf",
    path: wfTjbvvX6V6VMeta?.path ?? "wf",
    meta: wfTjbvvX6V6VMeta || {},
    alias: wfTjbvvX6V6VMeta?.alias || [],
    redirect: wfTjbvvX6V6VMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration/wf.vue").then(m => m.default || m)
  }
],
    meta: powerGenerationSxzCnLIvpcMeta || {},
    alias: powerGenerationSxzCnLIvpcMeta?.alias || [],
    redirect: powerGenerationSxzCnLIvpcMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/powerGeneration.vue").then(m => m.default || m)
  },
  {
    name: reportjFIXpSqMrSMeta?.name ?? "mobile-user-id-views-report",
    path: reportjFIXpSqMrSMeta?.path ?? "report",
    children: [
  {
    name: geoULoa8dMqgiMeta?.name ?? "mobile-user-id-views-report-geo",
    path: geoULoa8dMqgiMeta?.path ?? "geo",
    meta: geoULoa8dMqgiMeta || {},
    alias: geoULoa8dMqgiMeta?.alias || [],
    redirect: geoULoa8dMqgiMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/report/geo.vue").then(m => m.default || m)
  },
  {
    name: pvuerSFRiCxLMeta?.name ?? "mobile-user-id-views-report-pv",
    path: pvuerSFRiCxLMeta?.path ?? "pv",
    meta: pvuerSFRiCxLMeta || {},
    alias: pvuerSFRiCxLMeta?.alias || [],
    redirect: pvuerSFRiCxLMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/report/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatPaBz7oozmXMeta?.name ?? "mobile-user-id-views-report-solarheat",
    path: solarheatPaBz7oozmXMeta?.path ?? "solarheat",
    meta: solarheatPaBz7oozmXMeta || {},
    alias: solarheatPaBz7oozmXMeta?.alias || [],
    redirect: solarheatPaBz7oozmXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/report/solarheat.vue").then(m => m.default || m)
  }
],
    meta: reportjFIXpSqMrSMeta || {},
    alias: reportjFIXpSqMrSMeta?.alias || [],
    redirect: reportjFIXpSqMrSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/report.vue").then(m => m.default || m)
  },
  {
    name: reportPDFj4ZWiBewIDMeta?.name ?? "mobile-user-id-views-reportPDF",
    path: reportPDFj4ZWiBewIDMeta?.path ?? "reportPDF",
    children: [
  {
    name: pvkmw8RnaW27Meta?.name ?? "mobile-user-id-views-reportPDF-pv",
    path: pvkmw8RnaW27Meta?.path ?? "pv",
    meta: pvkmw8RnaW27Meta || {},
    alias: pvkmw8RnaW27Meta?.alias || [],
    redirect: pvkmw8RnaW27Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/reportPDF/pv.vue").then(m => m.default || m)
  }
],
    meta: reportPDFj4ZWiBewIDMeta || {},
    alias: reportPDFj4ZWiBewIDMeta?.alias || [],
    redirect: reportPDFj4ZWiBewIDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/reportPDF.vue").then(m => m.default || m)
  },
  {
    name: statusv9FFWoeKv3Meta?.name ?? "mobile-user-id-views-status",
    path: statusv9FFWoeKv3Meta?.path ?? "status",
    meta: statusv9FFWoeKv3Meta || {},
    alias: statusv9FFWoeKv3Meta?.alias || [],
    redirect: statusv9FFWoeKv3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views/status.vue").then(m => m.default || m)
  }
],
    meta: viewsTgO1hONktvMeta || {},
    alias: viewsTgO1hONktvMeta?.alias || [],
    redirect: viewsTgO1hONktvMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id]/views.vue").then(m => m.default || m)
  }
],
    name: _91id_93j66U11xk1tMeta?.name ?? undefined,
    meta: _91id_93j66U11xk1tMeta || {},
    alias: _91id_93j66U11xk1tMeta?.alias || [],
    redirect: _91id_93j66U11xk1tMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/[id].vue").then(m => m.default || m)
  },
  {
    name: finduser1LGhhE9mJgMeta?.name ?? "mobile-user-finduser",
    path: finduser1LGhhE9mJgMeta?.path ?? "finduser",
    children: [
  {
    name: doneFindidXB5xXJ1SjyMeta?.name ?? "mobile-user-finduser-doneFindid",
    path: doneFindidXB5xXJ1SjyMeta?.path ?? "doneFindid",
    meta: doneFindidXB5xXJ1SjyMeta || {},
    alias: doneFindidXB5xXJ1SjyMeta?.alias || [],
    redirect: doneFindidXB5xXJ1SjyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/finduser/doneFindid.vue").then(m => m.default || m)
  },
  {
    name: doneFindpassrCDDd63g03Meta?.name ?? "mobile-user-finduser-doneFindpass",
    path: doneFindpassrCDDd63g03Meta?.path ?? "doneFindpass",
    meta: doneFindpassrCDDd63g03Meta || {},
    alias: doneFindpassrCDDd63g03Meta?.alias || [],
    redirect: doneFindpassrCDDd63g03Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/finduser/doneFindpass.vue").then(m => m.default || m)
  },
  {
    name: findidiEdh8BqGTbMeta?.name ?? "mobile-user-finduser-findid",
    path: findidiEdh8BqGTbMeta?.path ?? "findid",
    meta: findidiEdh8BqGTbMeta || {},
    alias: findidiEdh8BqGTbMeta?.alias || [],
    redirect: findidiEdh8BqGTbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/finduser/findid.vue").then(m => m.default || m)
  },
  {
    name: findpassJPUBsYtZz9Meta?.name ?? "mobile-user-finduser-findpass",
    path: findpassJPUBsYtZz9Meta?.path ?? "findpass",
    meta: findpassJPUBsYtZz9Meta || {},
    alias: findpassJPUBsYtZz9Meta?.alias || [],
    redirect: findpassJPUBsYtZz9Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/finduser/findpass.vue").then(m => m.default || m)
  }
],
    meta: finduser1LGhhE9mJgMeta || {},
    alias: finduser1LGhhE9mJgMeta?.alias || [],
    redirect: finduser1LGhhE9mJgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/finduser.vue").then(m => m.default || m)
  },
  {
    name: introRJNIMvgIDoMeta?.name ?? "mobile-user-intro",
    path: introRJNIMvgIDoMeta?.path ?? "intro",
    meta: introRJNIMvgIDoMeta || {},
    alias: introRJNIMvgIDoMeta?.alias || [],
    redirect: introRJNIMvgIDoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/intro.vue").then(m => m.default || m)
  },
  {
    name: loginrDUoUsXnwcMeta?.name ?? "mobile-user-login",
    path: loginrDUoUsXnwcMeta?.path ?? "login",
    meta: loginrDUoUsXnwcMeta || {},
    alias: loginrDUoUsXnwcMeta?.alias || [],
    redirect: loginrDUoUsXnwcMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/login.vue").then(m => m.default || m)
  },
  {
    name: logoutwQZ9g2XbjAMeta?.name ?? "mobile-user-logout",
    path: logoutwQZ9g2XbjAMeta?.path ?? "logout",
    meta: logoutwQZ9g2XbjAMeta || {},
    alias: logoutwQZ9g2XbjAMeta?.alias || [],
    redirect: logoutwQZ9g2XbjAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/logout.vue").then(m => m.default || m)
  },
  {
    name: signinnIEp8PzLseMeta?.name ?? "mobile-user-signin",
    path: signinnIEp8PzLseMeta?.path ?? "signin",
    children: [
  {
    name: personTermsIjzMQKOHODMeta?.name ?? "mobile-user-signin-personTerms",
    path: personTermsIjzMQKOHODMeta?.path ?? "personTerms",
    meta: personTermsIjzMQKOHODMeta || {},
    alias: personTermsIjzMQKOHODMeta?.alias || [],
    redirect: personTermsIjzMQKOHODMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/signin/personTerms.vue").then(m => m.default || m)
  },
  {
    name: termOC8rNE4AElMeta?.name ?? "mobile-user-signin-term",
    path: termOC8rNE4AElMeta?.path ?? "term",
    meta: termOC8rNE4AElMeta || {},
    alias: termOC8rNE4AElMeta?.alias || [],
    redirect: termOC8rNE4AElMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/signin/term.vue").then(m => m.default || m)
  },
  {
    name: useTerms1mhkKmnBrZMeta?.name ?? "mobile-user-signin-useTerms",
    path: useTerms1mhkKmnBrZMeta?.path ?? "useTerms",
    meta: useTerms1mhkKmnBrZMeta || {},
    alias: useTerms1mhkKmnBrZMeta?.alias || [],
    redirect: useTerms1mhkKmnBrZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/signin/useTerms.vue").then(m => m.default || m)
  }
],
    meta: signinnIEp8PzLseMeta || {},
    alias: signinnIEp8PzLseMeta?.alias || [],
    redirect: signinnIEp8PzLseMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user/signin.vue").then(m => m.default || m)
  }
],
    meta: userP7Jquh6C14Meta || {},
    alias: userP7Jquh6C14Meta?.alias || [],
    redirect: userP7Jquh6C14Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile/user.vue").then(m => m.default || m)
  }
],
    meta: mobilerx7WDqPN3bMeta || {},
    alias: mobilerx7WDqPN3bMeta?.alias || [],
    redirect: mobilerx7WDqPN3bMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/mobile.vue").then(m => m.default || m)
  },
  {
    name: swagger_45uiHGOjzT6Py4Meta?.name ?? "swagger-ui",
    path: swagger_45uiHGOjzT6Py4Meta?.path ?? "/swagger-ui",
    meta: swagger_45uiHGOjzT6Py4Meta || {},
    alias: swagger_45uiHGOjzT6Py4Meta?.alias || [],
    redirect: swagger_45uiHGOjzT6Py4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/swagger-ui.vue").then(m => m.default || m)
  },
  {
    name: geowFZo9UadM0Meta?.name ?? "test-geo",
    path: geowFZo9UadM0Meta?.path ?? "/test/geo",
    meta: geowFZo9UadM0Meta || {},
    alias: geowFZo9UadM0Meta?.alias || [],
    redirect: geowFZo9UadM0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/test/geo.vue").then(m => m.default || m)
  },
  {
    name: loginA02WcsSjBGMeta?.name ?? "test-login",
    path: loginA02WcsSjBGMeta?.path ?? "/test/login",
    meta: loginA02WcsSjBGMeta || {},
    alias: loginA02WcsSjBGMeta?.alias || [],
    redirect: loginA02WcsSjBGMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/test/login.vue").then(m => m.default || m)
  },
  {
    name: mainLz9O4UYe9PMeta?.name ?? "test-main",
    path: mainLz9O4UYe9PMeta?.path ?? "/test/main",
    meta: mainLz9O4UYe9PMeta || {},
    alias: mainLz9O4UYe9PMeta?.alias || [],
    redirect: mainLz9O4UYe9PMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/test/main.vue").then(m => m.default || m)
  },
  {
    name: qrcode0MRjuisfOHMeta?.name ?? "test-qrcode",
    path: qrcode0MRjuisfOHMeta?.path ?? "/test/qrcode",
    meta: qrcode0MRjuisfOHMeta || {},
    alias: qrcode0MRjuisfOHMeta?.alias || [],
    redirect: qrcode0MRjuisfOHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/test/qrcode.vue").then(m => m.default || m)
  },
  {
    name: qrtestosfshLcHizMeta?.name ?? "test-qrtest",
    path: qrtestosfshLcHizMeta?.path ?? "/test/qrtest",
    meta: qrtestosfshLcHizMeta || {},
    alias: qrtestosfshLcHizMeta?.alias || [],
    redirect: qrtestosfshLcHizMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/test/qrtest.vue").then(m => m.default || m)
  },
  {
    name: tocxWmTkQMz4uMeta?.name ?? "toc",
    path: tocxWmTkQMz4uMeta?.path ?? "/toc",
    children: [
  {
    name: analysisV40t4ezNkuMeta?.name ?? "toc-analysis",
    path: analysisV40t4ezNkuMeta?.path ?? "analysis",
    children: [
  {
    name: compare_45ownerREcV2U89V3Meta?.name ?? "toc-analysis-compare-owner",
    path: compare_45ownerREcV2U89V3Meta?.path ?? "compare-owner",
    meta: compare_45ownerREcV2U89V3Meta || {},
    alias: compare_45ownerREcV2U89V3Meta?.alias || [],
    redirect: compare_45ownerREcV2U89V3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/compare-owner.vue").then(m => m.default || m)
  },
  {
    name: compare_45region1piR78OrYZMeta?.name ?? "toc-analysis-compare-region",
    path: compare_45region1piR78OrYZMeta?.path ?? "compare-region",
    meta: compare_45region1piR78OrYZMeta || {},
    alias: compare_45region1piR78OrYZMeta?.alias || [],
    redirect: compare_45region1piR78OrYZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/compare-region.vue").then(m => m.default || m)
  },
  {
    name: geoFy7ugrnLBMMeta?.name ?? "toc-analysis-component-geo",
    path: geoFy7ugrnLBMMeta?.path ?? "component/geo",
    meta: geoFy7ugrnLBMMeta || {},
    alias: geoFy7ugrnLBMMeta?.alias || [],
    redirect: geoFy7ugrnLBMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/component/geo.vue").then(m => m.default || m)
  },
  {
    name: ownerSearchModalumHUBtK2SiMeta?.name ?? "toc-analysis-component-ownerSearchModal",
    path: ownerSearchModalumHUBtK2SiMeta?.path ?? "component/ownerSearchModal",
    meta: ownerSearchModalumHUBtK2SiMeta || {},
    alias: ownerSearchModalumHUBtK2SiMeta?.alias || [],
    redirect: ownerSearchModalumHUBtK2SiMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/component/ownerSearchModal.vue").then(m => m.default || m)
  },
  {
    name: pv9ZYdHtBDoTMeta?.name ?? "toc-analysis-component-pv",
    path: pv9ZYdHtBDoTMeta?.path ?? "component/pv",
    meta: pv9ZYdHtBDoTMeta || {},
    alias: pv9ZYdHtBDoTMeta?.alias || [],
    redirect: pv9ZYdHtBDoTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/component/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatPNIelAfq80Meta?.name ?? "toc-analysis-component-solarheat",
    path: solarheatPNIelAfq80Meta?.path ?? "component/solarheat",
    meta: solarheatPNIelAfq80Meta || {},
    alias: solarheatPNIelAfq80Meta?.alias || [],
    redirect: solarheatPNIelAfq80Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/component/solarheat.vue").then(m => m.default || m)
  },
  {
    name: owner2KnuIa4CctMeta?.name ?? "toc-analysis-owner",
    path: owner2KnuIa4CctMeta?.path ?? "owner",
    meta: owner2KnuIa4CctMeta || {},
    alias: owner2KnuIa4CctMeta?.alias || [],
    redirect: owner2KnuIa4CctMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis/owner.vue").then(m => m.default || m)
  }
],
    meta: analysisV40t4ezNkuMeta || {},
    alias: analysisV40t4ezNkuMeta?.alias || [],
    redirect: analysisV40t4ezNkuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/analysis.vue").then(m => m.default || m)
  },
  {
    name: Energy_45ListlkBcvyNijKMeta?.name ?? "toc-component-Dashboard-Energy-List",
    path: Energy_45ListlkBcvyNijKMeta?.path ?? "component/Dashboard/Energy-List",
    meta: Energy_45ListlkBcvyNijKMeta || {},
    alias: Energy_45ListlkBcvyNijKMeta?.alias || [],
    redirect: Energy_45ListlkBcvyNijKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/Energy-List.vue").then(m => m.default || m)
  },
  {
    name: card_45base5NQrwo7IcIMeta?.name ?? "toc-component-Dashboard-card-base",
    path: card_45base5NQrwo7IcIMeta?.path ?? "component/Dashboard/card-base",
    meta: card_45base5NQrwo7IcIMeta || {},
    alias: card_45base5NQrwo7IcIMeta?.alias || [],
    redirect: card_45base5NQrwo7IcIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/card-base.vue").then(m => m.default || m)
  },
  {
    name: energy_45cardvSiztHtrWrMeta?.name ?? "toc-component-Dashboard-energy-card",
    path: energy_45cardvSiztHtrWrMeta?.path ?? "component/Dashboard/energy-card",
    meta: energy_45cardvSiztHtrWrMeta || {},
    alias: energy_45cardvSiztHtrWrMeta?.alias || [],
    redirect: energy_45cardvSiztHtrWrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/energy-card.vue").then(m => m.default || m)
  },
  {
    name: energy_45card2ZXKdzrj1oeMeta?.name ?? "toc-component-Dashboard-energy-card2",
    path: energy_45card2ZXKdzrj1oeMeta?.path ?? "component/Dashboard/energy-card2",
    meta: energy_45card2ZXKdzrj1oeMeta || {},
    alias: energy_45card2ZXKdzrj1oeMeta?.alias || [],
    redirect: energy_45card2ZXKdzrj1oeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/energy-card2.vue").then(m => m.default || m)
  },
  {
    name: info_45card8M5WadTLAEMeta?.name ?? "toc-component-Dashboard-info-card",
    path: info_45card8M5WadTLAEMeta?.path ?? "component/Dashboard/info-card",
    meta: info_45card8M5WadTLAEMeta || {},
    alias: info_45card8M5WadTLAEMeta?.alias || [],
    redirect: info_45card8M5WadTLAEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/info-card.vue").then(m => m.default || m)
  },
  {
    name: link_45rate_45card6TZBPloFCGMeta?.name ?? "toc-component-Dashboard-link-rate-card",
    path: link_45rate_45card6TZBPloFCGMeta?.path ?? "component/Dashboard/link-rate-card",
    meta: link_45rate_45card6TZBPloFCGMeta || {},
    alias: link_45rate_45card6TZBPloFCGMeta?.alias || [],
    redirect: link_45rate_45card6TZBPloFCGMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Dashboard/link-rate-card.vue").then(m => m.default || m)
  },
  {
    name: FileUploadBFXJ6by9kPMeta?.name ?? "toc-component-FileUpload",
    path: FileUploadBFXJ6by9kPMeta?.path ?? "component/FileUpload",
    meta: FileUploadBFXJ6by9kPMeta || {},
    alias: FileUploadBFXJ6by9kPMeta?.alias || [],
    redirect: FileUploadBFXJ6by9kPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/FileUpload.vue").then(m => m.default || m)
  },
  {
    name: indexwpcWiiAdk0Meta?.name ?? "toc-component-InstallInfo",
    path: indexwpcWiiAdk0Meta?.path ?? "component/InstallInfo",
    meta: indexwpcWiiAdk0Meta || {},
    alias: indexwpcWiiAdk0Meta?.alias || [],
    redirect: indexwpcWiiAdk0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/InstallInfo/index.vue").then(m => m.default || m)
  },
  {
    name: pvjWo2DscdXHMeta?.name ?? "toc-component-InstallInfo-pv",
    path: pvjWo2DscdXHMeta?.path ?? "component/InstallInfo/pv",
    meta: pvjWo2DscdXHMeta || {},
    alias: pvjWo2DscdXHMeta?.alias || [],
    redirect: pvjWo2DscdXHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/InstallInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatZHkxgGHwdZMeta?.name ?? "toc-component-InstallInfo-solarheat",
    path: solarheatZHkxgGHwdZMeta?.path ?? "component/InstallInfo/solarheat",
    meta: solarheatZHkxgGHwdZMeta || {},
    alias: solarheatZHkxgGHwdZMeta?.alias || [],
    redirect: solarheatZHkxgGHwdZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/InstallInfo/solarheat.vue").then(m => m.default || m)
  },
  {
    name: pvEMEODNvJmWMeta?.name ?? "toc-component-InstruInfo-pv",
    path: pvEMEODNvJmWMeta?.path ?? "component/InstruInfo/pv",
    meta: pvEMEODNvJmWMeta || {},
    alias: pvEMEODNvJmWMeta?.alias || [],
    redirect: pvEMEODNvJmWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/InstruInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: indexw0HxA1k91XMeta?.name ?? "toc-component-ManagerInfo",
    path: indexw0HxA1k91XMeta?.path ?? "component/ManagerInfo",
    meta: indexw0HxA1k91XMeta || {},
    alias: indexw0HxA1k91XMeta?.alias || [],
    redirect: indexw0HxA1k91XMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/ManagerInfo/index.vue").then(m => m.default || m)
  },
  {
    name: pvCrjeKNE9jbMeta?.name ?? "toc-component-ManagerInfo-pv",
    path: pvCrjeKNE9jbMeta?.path ?? "component/ManagerInfo/pv",
    meta: pvCrjeKNE9jbMeta || {},
    alias: pvCrjeKNE9jbMeta?.alias || [],
    redirect: pvCrjeKNE9jbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/ManagerInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheathi4AU9vrkgMeta?.name ?? "toc-component-ManagerInfo-solarheat",
    path: solarheathi4AU9vrkgMeta?.path ?? "component/ManagerInfo/solarheat",
    meta: solarheathi4AU9vrkgMeta || {},
    alias: solarheathi4AU9vrkgMeta?.alias || [],
    redirect: solarheathi4AU9vrkgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/ManagerInfo/solarheat.vue").then(m => m.default || m)
  },
  {
    name: pvt2t8OQsVS4Meta?.name ?? "toc-component-OwnerInfo-ManagerInfo-pv",
    path: pvt2t8OQsVS4Meta?.path ?? "component/OwnerInfo/ManagerInfo/pv",
    meta: pvt2t8OQsVS4Meta || {},
    alias: pvt2t8OQsVS4Meta?.alias || [],
    redirect: pvt2t8OQsVS4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/OwnerInfo/ManagerInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatnx8xMyYiItMeta?.name ?? "toc-component-OwnerInfo-ManagerInfo-solarheat",
    path: solarheatnx8xMyYiItMeta?.path ?? "component/OwnerInfo/ManagerInfo/solarheat",
    meta: solarheatnx8xMyYiItMeta || {},
    alias: solarheatnx8xMyYiItMeta?.alias || [],
    redirect: solarheatnx8xMyYiItMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/OwnerInfo/ManagerInfo/solarheat.vue").then(m => m.default || m)
  },
  {
    name: index1VnMCWuLWxMeta?.name ?? "toc-component-OwnerInfo",
    path: index1VnMCWuLWxMeta?.path ?? "component/OwnerInfo",
    meta: index1VnMCWuLWxMeta || {},
    alias: index1VnMCWuLWxMeta?.alias || [],
    redirect: index1VnMCWuLWxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/OwnerInfo/index.vue").then(m => m.default || m)
  },
  {
    name: pvFYx95WluolMeta?.name ?? "toc-component-OwnerInfo-pv",
    path: pvFYx95WluolMeta?.path ?? "component/OwnerInfo/pv",
    meta: pvFYx95WluolMeta || {},
    alias: pvFYx95WluolMeta?.alias || [],
    redirect: pvFYx95WluolMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/OwnerInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: solar9NLBST37DwMeta?.name ?? "toc-component-OwnerInfo-solar",
    path: solar9NLBST37DwMeta?.path ?? "component/OwnerInfo/solar",
    meta: solar9NLBST37DwMeta || {},
    alias: solar9NLBST37DwMeta?.alias || [],
    redirect: solar9NLBST37DwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/OwnerInfo/solar.vue").then(m => m.default || m)
  },
  {
    name: indexwj8wQSEIGSMeta?.name ?? "toc-component-RtuInfo",
    path: indexwj8wQSEIGSMeta?.path ?? "component/RtuInfo",
    meta: indexwj8wQSEIGSMeta || {},
    alias: indexwj8wQSEIGSMeta?.alias || [],
    redirect: indexwj8wQSEIGSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/RtuInfo/index.vue").then(m => m.default || m)
  },
  {
    name: common_45code_45dropdownAEtlgs4XmBMeta?.name ?? "toc-component-SearchBox-common-code-dropdown",
    path: common_45code_45dropdownAEtlgs4XmBMeta?.path ?? "component/SearchBox/common-code-dropdown",
    meta: common_45code_45dropdownAEtlgs4XmBMeta || {},
    alias: common_45code_45dropdownAEtlgs4XmBMeta?.alias || [],
    redirect: common_45code_45dropdownAEtlgs4XmBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SearchBox/common-code-dropdown.vue").then(m => m.default || m)
  },
  {
    name: date_45set_45reportEiVIE8oOD3Meta?.name ?? "toc-component-SearchBox-date-set-report",
    path: date_45set_45reportEiVIE8oOD3Meta?.path ?? "component/SearchBox/date-set-report",
    meta: date_45set_45reportEiVIE8oOD3Meta || {},
    alias: date_45set_45reportEiVIE8oOD3Meta?.alias || [],
    redirect: date_45set_45reportEiVIE8oOD3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SearchBox/date-set-report.vue").then(m => m.default || m)
  },
  {
    name: date_45setTHTzvwxslUMeta?.name ?? "toc-component-SearchBox-date-set",
    path: date_45setTHTzvwxslUMeta?.path ?? "component/SearchBox/date-set",
    meta: date_45setTHTzvwxslUMeta || {},
    alias: date_45setTHTzvwxslUMeta?.alias || [],
    redirect: date_45setTHTzvwxslUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SearchBox/date-set.vue").then(m => m.default || m)
  },
  {
    name: plain_45date_45setjZyPEn09YgMeta?.name ?? "toc-component-SearchBox-plain-date-set",
    path: plain_45date_45setjZyPEn09YgMeta?.path ?? "component/SearchBox/plain-date-set",
    meta: plain_45date_45setjZyPEn09YgMeta || {},
    alias: plain_45date_45setjZyPEn09YgMeta?.alias || [],
    redirect: plain_45date_45setjZyPEn09YgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SearchBox/plain-date-set.vue").then(m => m.default || m)
  },
  {
    name: region_45setajDBOA3J3BMeta?.name ?? "toc-component-SearchBox-region-set",
    path: region_45setajDBOA3J3BMeta?.path ?? "component/SearchBox/region-set",
    meta: region_45setajDBOA3J3BMeta || {},
    alias: region_45setajDBOA3J3BMeta?.alias || [],
    redirect: region_45setajDBOA3J3BMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SearchBox/region-set.vue").then(m => m.default || m)
  },
  {
    name: geoYeV2nIPQRmMeta?.name ?? "toc-component-SpecInfo-geo",
    path: geoYeV2nIPQRmMeta?.path ?? "component/SpecInfo/geo",
    meta: geoYeV2nIPQRmMeta || {},
    alias: geoYeV2nIPQRmMeta?.alias || [],
    redirect: geoYeV2nIPQRmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SpecInfo/geo.vue").then(m => m.default || m)
  },
  {
    name: pvhQljqa5Q8gMeta?.name ?? "toc-component-SpecInfo-pv",
    path: pvhQljqa5Q8gMeta?.path ?? "component/SpecInfo/pv",
    meta: pvhQljqa5Q8gMeta || {},
    alias: pvhQljqa5Q8gMeta?.alias || [],
    redirect: pvhQljqa5Q8gMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SpecInfo/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatnsB7uGr7DTMeta?.name ?? "toc-component-SpecInfo-solarheat",
    path: solarheatnsB7uGr7DTMeta?.path ?? "component/SpecInfo/solarheat",
    meta: solarheatnsB7uGr7DTMeta || {},
    alias: solarheatnsB7uGr7DTMeta?.alias || [],
    redirect: solarheatnsB7uGr7DTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/SpecInfo/solarheat.vue").then(m => m.default || m)
  },
  {
    name: Table_45BoxiZEJQwuJkvMeta?.name ?? "toc-component-Table-Box",
    path: Table_45BoxiZEJQwuJkvMeta?.path ?? "component/Table-Box",
    meta: Table_45BoxiZEJQwuJkvMeta || {},
    alias: Table_45BoxiZEJQwuJkvMeta?.alias || [],
    redirect: Table_45BoxiZEJQwuJkvMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/Table-Box.vue").then(m => m.default || m)
  },
  {
    name: api_45search_45box6pvbqi0Rt8Meta?.name ?? "toc-component-api-search-box",
    path: api_45search_45box6pvbqi0Rt8Meta?.path ?? "component/api-search-box",
    meta: api_45search_45box6pvbqi0Rt8Meta || {},
    alias: api_45search_45box6pvbqi0Rt8Meta?.alias || [],
    redirect: api_45search_45box6pvbqi0Rt8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/api-search-box.vue").then(m => m.default || m)
  },
  {
    name: data_45tableIG3HUIuZNnMeta?.name ?? "toc-component-data-table",
    path: data_45tableIG3HUIuZNnMeta?.path ?? "component/data-table",
    meta: data_45tableIG3HUIuZNnMeta || {},
    alias: data_45tableIG3HUIuZNnMeta?.alias || [],
    redirect: data_45tableIG3HUIuZNnMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/data-table.vue").then(m => m.default || m)
  },
  {
    name: event_45search_45gridxXrzTSCAk9Meta?.name ?? "toc-component-event-search-grid",
    path: event_45search_45gridxXrzTSCAk9Meta?.path ?? "component/event-search-grid",
    meta: event_45search_45gridxXrzTSCAk9Meta || {},
    alias: event_45search_45gridxXrzTSCAk9Meta?.alias || [],
    redirect: event_45search_45gridxXrzTSCAk9Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/event-search-grid.vue").then(m => m.default || m)
  },
  {
    name: info_45boxUnyKmQqWB0Meta?.name ?? "toc-component-info-box",
    path: info_45boxUnyKmQqWB0Meta?.path ?? "component/info-box",
    meta: info_45boxUnyKmQqWB0Meta || {},
    alias: info_45boxUnyKmQqWB0Meta?.alias || [],
    redirect: info_45boxUnyKmQqWB0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/info-box.vue").then(m => m.default || m)
  },
  {
    name: plain_45search_45boxViL2mgKQGZMeta?.name ?? "toc-component-plain-search-box",
    path: plain_45search_45boxViL2mgKQGZMeta?.path ?? "component/plain-search-box",
    meta: plain_45search_45boxViL2mgKQGZMeta || {},
    alias: plain_45search_45boxViL2mgKQGZMeta?.alias || [],
    redirect: plain_45search_45boxViL2mgKQGZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/plain-search-box.vue").then(m => m.default || m)
  },
  {
    name: region_45selectYyhuaOoRg8Meta?.name ?? "toc-component-region-select",
    path: region_45selectYyhuaOoRg8Meta?.path ?? "component/region-select",
    meta: region_45selectYyhuaOoRg8Meta || {},
    alias: region_45selectYyhuaOoRg8Meta?.alias || [],
    redirect: region_45selectYyhuaOoRg8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/region-select.vue").then(m => m.default || m)
  },
  {
    name: search_45boxrj545dRYokMeta?.name ?? "toc-component-search-box",
    path: search_45boxrj545dRYokMeta?.path ?? "component/search-box",
    meta: search_45boxrj545dRYokMeta || {},
    alias: search_45boxrj545dRYokMeta?.alias || [],
    redirect: search_45boxrj545dRYokMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/search-box.vue").then(m => m.default || m)
  },
  {
    name: table_45pagingRd9YzmQWp0Meta?.name ?? "toc-component-table-paging",
    path: table_45pagingRd9YzmQWp0Meta?.path ?? "component/table-paging",
    meta: table_45pagingRd9YzmQWp0Meta || {},
    alias: table_45pagingRd9YzmQWp0Meta?.alias || [],
    redirect: table_45pagingRd9YzmQWp0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/table-paging.vue").then(m => m.default || m)
  },
  {
    name: toc_45templateYD5sOfSTlmMeta?.name ?? "toc-component-template-toc-template",
    path: toc_45templateYD5sOfSTlmMeta?.path ?? "component/template/toc-template",
    meta: toc_45templateYD5sOfSTlmMeta || {},
    alias: toc_45templateYD5sOfSTlmMeta?.alias || [],
    redirect: toc_45templateYD5sOfSTlmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/template/toc-template.vue").then(m => m.default || m)
  },
  {
    name: test_45grid6ja8QqbtUqMeta?.name ?? "toc-component-test-grid",
    path: test_45grid6ja8QqbtUqMeta?.path ?? "component/test-grid",
    meta: test_45grid6ja8QqbtUqMeta || {},
    alias: test_45grid6ja8QqbtUqMeta?.alias || [],
    redirect: test_45grid6ja8QqbtUqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/component/test-grid.vue").then(m => m.default || m)
  },
  {
    name: customerTVXLAru08XMeta?.name ?? "toc-customer",
    path: customerTVXLAru08XMeta?.path ?? "customer",
    children: [
  {
    name: _91id_937pcLoLwkWRMeta?.name ?? "toc-customer-faq-id",
    path: _91id_937pcLoLwkWRMeta?.path ?? "faq/:id",
    meta: _91id_937pcLoLwkWRMeta || {},
    alias: _91id_937pcLoLwkWRMeta?.alias || [],
    redirect: _91id_937pcLoLwkWRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/faq/[id].vue").then(m => m.default || m)
  },
  {
    name: index2l9RlEWuDcMeta?.name ?? "toc-customer-faq",
    path: index2l9RlEWuDcMeta?.path ?? "faq",
    meta: index2l9RlEWuDcMeta || {},
    alias: index2l9RlEWuDcMeta?.alias || [],
    redirect: index2l9RlEWuDcMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/faq/index.vue").then(m => m.default || m)
  },
  {
    name: faq_companyyKRJvVBVZZMeta?.name ?? "toc-customer-faq_company",
    path: faq_companyyKRJvVBVZZMeta?.path ?? "faq_company",
    meta: faq_companyyKRJvVBVZZMeta || {},
    alias: faq_companyyKRJvVBVZZMeta?.alias || [],
    redirect: faq_companyyKRJvVBVZZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/faq_company.vue").then(m => m.default || m)
  },
  {
    name: login_45termsbrwmNGwtqhMeta?.name ?? "toc-customer-login-terms",
    path: login_45termsbrwmNGwtqhMeta?.path ?? "login-terms",
    meta: login_45termsbrwmNGwtqhMeta || {},
    alias: login_45termsbrwmNGwtqhMeta?.alias || [],
    redirect: login_45termsbrwmNGwtqhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/login-terms.vue").then(m => m.default || m)
  },
  {
    path: noticeH3HTs7zw5YMeta?.path ?? "notice",
    children: [
  {
    name: _91id_93qj3MdQcdYPMeta?.name ?? "toc-customer-notice-id",
    path: _91id_93qj3MdQcdYPMeta?.path ?? ":id",
    meta: _91id_93qj3MdQcdYPMeta || {},
    alias: _91id_93qj3MdQcdYPMeta?.alias || [],
    redirect: _91id_93qj3MdQcdYPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/notice/[id].vue").then(m => m.default || m)
  },
  {
    name: index1yVUukORuKMeta?.name ?? "toc-customer-notice",
    path: index1yVUukORuKMeta?.path ?? "",
    meta: index1yVUukORuKMeta || {},
    alias: index1yVUukORuKMeta?.alias || [],
    redirect: index1yVUukORuKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/notice/index.vue").then(m => m.default || m)
  }
],
    name: noticeH3HTs7zw5YMeta?.name ?? undefined,
    meta: noticeH3HTs7zw5YMeta || {},
    alias: noticeH3HTs7zw5YMeta?.alias || [],
    redirect: noticeH3HTs7zw5YMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/notice.vue").then(m => m.default || m)
  },
  {
    path: qna1jX9EF711KMeta?.path ?? "qna",
    children: [
  {
    name: _91id_93NqfjpqEVDOMeta?.name ?? "toc-customer-qna-id",
    path: _91id_93NqfjpqEVDOMeta?.path ?? ":id",
    meta: _91id_93NqfjpqEVDOMeta || {},
    alias: _91id_93NqfjpqEVDOMeta?.alias || [],
    redirect: _91id_93NqfjpqEVDOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/qna/[id].vue").then(m => m.default || m)
  },
  {
    name: addaBndsbcdE0Meta?.name ?? "toc-customer-qna-add",
    path: addaBndsbcdE0Meta?.path ?? "add",
    meta: addaBndsbcdE0Meta || {},
    alias: addaBndsbcdE0Meta?.alias || [],
    redirect: addaBndsbcdE0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/qna/add.vue").then(m => m.default || m)
  },
  {
    name: indexMrL2kx6htIMeta?.name ?? "toc-customer-qna",
    path: indexMrL2kx6htIMeta?.path ?? "",
    meta: indexMrL2kx6htIMeta || {},
    alias: indexMrL2kx6htIMeta?.alias || [],
    redirect: indexMrL2kx6htIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/qna/index.vue").then(m => m.default || m)
  }
],
    name: qna1jX9EF711KMeta?.name ?? undefined,
    meta: qna1jX9EF711KMeta || {},
    alias: qna1jX9EF711KMeta?.alias || [],
    redirect: qna1jX9EF711KMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/qna.vue").then(m => m.default || m)
  },
  {
    path: referenceDfOwQGHTtyMeta?.path ?? "reference",
    children: [
  {
    name: _91id_93HFrk4JGRN7Meta?.name ?? "toc-customer-reference-id",
    path: _91id_93HFrk4JGRN7Meta?.path ?? ":id",
    meta: _91id_93HFrk4JGRN7Meta || {},
    alias: _91id_93HFrk4JGRN7Meta?.alias || [],
    redirect: _91id_93HFrk4JGRN7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/reference/[id].vue").then(m => m.default || m)
  },
  {
    name: indexRXApMp6VDRMeta?.name ?? "toc-customer-reference",
    path: indexRXApMp6VDRMeta?.path ?? "",
    meta: indexRXApMp6VDRMeta || {},
    alias: indexRXApMp6VDRMeta?.alias || [],
    redirect: indexRXApMp6VDRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/reference/index.vue").then(m => m.default || m)
  }
],
    name: referenceDfOwQGHTtyMeta?.name ?? undefined,
    meta: referenceDfOwQGHTtyMeta || {},
    alias: referenceDfOwQGHTtyMeta?.alias || [],
    redirect: referenceDfOwQGHTtyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/reference.vue").then(m => m.default || m)
  },
  {
    name: terms1dzOWJxIguOMeta?.name ?? "toc-customer-terms-list-terms1",
    path: terms1dzOWJxIguOMeta?.path ?? "terms-list/terms1",
    meta: terms1dzOWJxIguOMeta || {},
    alias: terms1dzOWJxIguOMeta?.alias || [],
    redirect: terms1dzOWJxIguOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/terms-list/terms1.vue").then(m => m.default || m)
  },
  {
    name: terms2DvYPppf15KMeta?.name ?? "toc-customer-terms-list-terms2",
    path: terms2DvYPppf15KMeta?.path ?? "terms-list/terms2",
    meta: terms2DvYPppf15KMeta || {},
    alias: terms2DvYPppf15KMeta?.alias || [],
    redirect: terms2DvYPppf15KMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/terms-list/terms2.vue").then(m => m.default || m)
  },
  {
    name: termsGc1OpbLz5MMeta?.name ?? "toc-customer-terms",
    path: termsGc1OpbLz5MMeta?.path ?? "terms",
    meta: termsGc1OpbLz5MMeta || {},
    alias: termsGc1OpbLz5MMeta?.alias || [],
    redirect: termsGc1OpbLz5MMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer/terms.vue").then(m => m.default || m)
  }
],
    meta: customerTVXLAru08XMeta || {},
    alias: customerTVXLAru08XMeta?.alias || [],
    redirect: customerTVXLAru08XMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/customer.vue").then(m => m.default || m)
  },
  {
    name: equipnBhvoO3FtOMeta?.name ?? "toc-equip",
    path: equipnBhvoO3FtOMeta?.path ?? "equip",
    children: [
  {
    name: equip_45detailkGGa0mwPIOMeta?.name ?? "toc-equip-pathinfo-equip-detail",
    path: equip_45detailkGGa0mwPIOMeta?.path ?? ":pathinfo/equip-detail",
    children: [
  {
    name: _91cid_932B48DwJmLPMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid",
    path: _91cid_932B48DwJmLPMeta?.path ?? ":cid",
    children: [
  {
    name: geo_45prod_45cardaM73Tp5ZdBMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-geo-prod-card",
    path: geo_45prod_45cardaM73Tp5ZdBMeta?.path ?? "component/geo-prod-card",
    meta: geo_45prod_45cardaM73Tp5ZdBMeta || {},
    alias: geo_45prod_45cardaM73Tp5ZdBMeta?.alias || [],
    redirect: geo_45prod_45cardaM73Tp5ZdBMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-prod-card.vue").then(m => m.default || m)
  },
  {
    name: geo_45prod_45chartihws93A6wCMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-geo-prod-chart",
    path: geo_45prod_45chartihws93A6wCMeta?.path ?? "component/geo-prod-chart",
    meta: geo_45prod_45chartihws93A6wCMeta || {},
    alias: geo_45prod_45chartihws93A6wCMeta?.alias || [],
    redirect: geo_45prod_45chartihws93A6wCMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-prod-chart.vue").then(m => m.default || m)
  },
  {
    name: geo_45usage_45cardXoyoxJFesvMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-geo-usage-card",
    path: geo_45usage_45cardXoyoxJFesvMeta?.path ?? "component/geo-usage-card",
    meta: geo_45usage_45cardXoyoxJFesvMeta || {},
    alias: geo_45usage_45cardXoyoxJFesvMeta?.alias || [],
    redirect: geo_45usage_45cardXoyoxJFesvMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-usage-card.vue").then(m => m.default || m)
  },
  {
    name: geo_45usage_45chartLOhWX0zyeIMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-geo-usage-chart",
    path: geo_45usage_45chartLOhWX0zyeIMeta?.path ?? "component/geo-usage-chart",
    meta: geo_45usage_45chartLOhWX0zyeIMeta || {},
    alias: geo_45usage_45chartLOhWX0zyeIMeta?.alias || [],
    redirect: geo_45usage_45chartLOhWX0zyeIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/geo-usage-chart.vue").then(m => m.default || m)
  },
  {
    name: raw_45data_45chartyGDhcseML2Meta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-raw-data-chart",
    path: raw_45data_45chartyGDhcseML2Meta?.path ?? "component/raw-data-chart",
    meta: raw_45data_45chartyGDhcseML2Meta || {},
    alias: raw_45data_45chartyGDhcseML2Meta?.alias || [],
    redirect: raw_45data_45chartyGDhcseML2Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/raw-data-chart.vue").then(m => m.default || m)
  },
  {
    name: raw_45data_45infoRkv8S6Z9vqMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-raw-data-info",
    path: raw_45data_45infoRkv8S6Z9vqMeta?.path ?? "component/raw-data-info",
    meta: raw_45data_45infoRkv8S6Z9vqMeta || {},
    alias: raw_45data_45infoRkv8S6Z9vqMeta?.alias || [],
    redirect: raw_45data_45infoRkv8S6Z9vqMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/raw-data-info.vue").then(m => m.default || m)
  },
  {
    name: solarheat_45prod_45cardC9tk04myUnMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-solarheat-prod-card",
    path: solarheat_45prod_45cardC9tk04myUnMeta?.path ?? "component/solarheat-prod-card",
    meta: solarheat_45prod_45cardC9tk04myUnMeta || {},
    alias: solarheat_45prod_45cardC9tk04myUnMeta?.alias || [],
    redirect: solarheat_45prod_45cardC9tk04myUnMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-prod-card.vue").then(m => m.default || m)
  },
  {
    name: solarheat_45prod_45chartYKUVhvMSfYMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-solarheat-prod-chart",
    path: solarheat_45prod_45chartYKUVhvMSfYMeta?.path ?? "component/solarheat-prod-chart",
    meta: solarheat_45prod_45chartYKUVhvMSfYMeta || {},
    alias: solarheat_45prod_45chartYKUVhvMSfYMeta?.alias || [],
    redirect: solarheat_45prod_45chartYKUVhvMSfYMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-prod-chart.vue").then(m => m.default || m)
  },
  {
    name: solarheat_45usage_45cardmDwGnB40hZMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-solarheat-usage-card",
    path: solarheat_45usage_45cardmDwGnB40hZMeta?.path ?? "component/solarheat-usage-card",
    meta: solarheat_45usage_45cardmDwGnB40hZMeta || {},
    alias: solarheat_45usage_45cardmDwGnB40hZMeta?.alias || [],
    redirect: solarheat_45usage_45cardmDwGnB40hZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-usage-card.vue").then(m => m.default || m)
  },
  {
    name: solarheat_45usage_45chartoBgjKwlMv8Meta?.name ?? "toc-equip-pathinfo-equip-detail-cid-component-solarheat-usage-chart",
    path: solarheat_45usage_45chartoBgjKwlMv8Meta?.path ?? "component/solarheat-usage-chart",
    meta: solarheat_45usage_45chartoBgjKwlMv8Meta || {},
    alias: solarheat_45usage_45chartoBgjKwlMv8Meta?.alias || [],
    redirect: solarheat_45usage_45chartoBgjKwlMv8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/component/solarheat-usage-chart.vue").then(m => m.default || m)
  },
  {
    name: geo_45prodnFoZHqX169Meta?.name ?? "toc-equip-pathinfo-equip-detail-cid-geo-prod",
    path: geo_45prodnFoZHqX169Meta?.path ?? "geo-prod",
    meta: geo_45prodnFoZHqX169Meta || {},
    alias: geo_45prodnFoZHqX169Meta?.alias || [],
    redirect: geo_45prodnFoZHqX169Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo-prod.vue").then(m => m.default || m)
  },
  {
    name: geo_45usageoUvOl8pJRzMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-geo-usage",
    path: geo_45usageoUvOl8pJRzMeta?.path ?? "geo-usage",
    meta: geo_45usageoUvOl8pJRzMeta || {},
    alias: geo_45usageoUvOl8pJRzMeta?.alias || [],
    redirect: geo_45usageoUvOl8pJRzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo-usage.vue").then(m => m.default || m)
  },
  {
    name: geoGETsmGVTbfMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-geo",
    path: geoGETsmGVTbfMeta?.path ?? "geo",
    meta: geoGETsmGVTbfMeta || {},
    alias: geoGETsmGVTbfMeta?.alias || [],
    redirect: geoGETsmGVTbfMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/geo.vue").then(m => m.default || m)
  },
  {
    name: pvtTEFRi55OYMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-pv",
    path: pvtTEFRi55OYMeta?.path ?? "pv",
    meta: pvtTEFRi55OYMeta || {},
    alias: pvtTEFRi55OYMeta?.alias || [],
    redirect: pvtTEFRi55OYMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatncph8OKdDpMeta?.name ?? "toc-equip-pathinfo-equip-detail-cid-solarheat",
    path: solarheatncph8OKdDpMeta?.path ?? "solarheat",
    meta: solarheatncph8OKdDpMeta || {},
    alias: solarheatncph8OKdDpMeta?.alias || [],
    redirect: solarheatncph8OKdDpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid]/solarheat.vue").then(m => m.default || m)
  }
],
    meta: _91cid_932B48DwJmLPMeta || {},
    alias: _91cid_932B48DwJmLPMeta?.alias || [],
    redirect: _91cid_932B48DwJmLPMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail/[cid].vue").then(m => m.default || m)
  }
],
    meta: equip_45detailkGGa0mwPIOMeta || {},
    alias: equip_45detailkGGa0mwPIOMeta?.alias || [],
    redirect: equip_45detailkGGa0mwPIOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-detail.vue").then(m => m.default || m)
  },
  {
    name: equip_45list7PxcA0qV7bMeta?.name ?? "toc-equip-pathinfo-equip-list",
    path: equip_45list7PxcA0qV7bMeta?.path ?? ":pathinfo/equip-list",
    meta: equip_45list7PxcA0qV7bMeta || {},
    alias: equip_45list7PxcA0qV7bMeta?.alias || [],
    redirect: equip_45list7PxcA0qV7bMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-list.vue").then(m => m.default || m)
  },
  {
    name: equip_45mapVyAySJchiQMeta?.name ?? "toc-equip-pathinfo-equip-map",
    path: equip_45mapVyAySJchiQMeta?.path ?? ":pathinfo/equip-map",
    meta: equip_45mapVyAySJchiQMeta || {},
    alias: equip_45mapVyAySJchiQMeta?.alias || [],
    redirect: equip_45mapVyAySJchiQMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/equip-map.vue").then(m => m.default || m)
  },
  {
    name: measureo5Q3ZCMEKGMeta?.name ?? "toc-equip-pathinfo-measure",
    path: measureo5Q3ZCMEKGMeta?.path ?? ":pathinfo/measure",
    meta: measureo5Q3ZCMEKGMeta || {},
    alias: measureo5Q3ZCMEKGMeta?.alias || [],
    redirect: measureo5Q3ZCMEKGMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/measure.vue").then(m => m.default || m)
  },
  {
    name: monitoring_45mapojZPJMa2UYMeta?.name ?? "toc-equip-pathinfo-monitoring-map",
    path: monitoring_45mapojZPJMa2UYMeta?.path ?? ":pathinfo/monitoring-map",
    meta: monitoring_45mapojZPJMa2UYMeta || {},
    alias: monitoring_45mapojZPJMa2UYMeta?.alias || [],
    redirect: monitoring_45mapojZPJMa2UYMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/monitoring-map.vue").then(m => m.default || m)
  },
  {
    path: power_45generatesfCHX7KiHWMeta?.path ?? ":pathinfo/power-generate",
    children: [
  {
    name: indexbWO8sybH7BMeta?.name ?? "toc-equip-pathinfo-power-generate",
    path: indexbWO8sybH7BMeta?.path ?? "",
    meta: indexbWO8sybH7BMeta || {},
    alias: indexbWO8sybH7BMeta?.alias || [],
    redirect: indexbWO8sybH7BMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/power-generate/index.vue").then(m => m.default || m)
  }
],
    name: power_45generatesfCHX7KiHWMeta?.name ?? undefined,
    meta: power_45generatesfCHX7KiHWMeta || {},
    alias: power_45generatesfCHX7KiHWMeta?.alias || [],
    redirect: power_45generatesfCHX7KiHWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/power-generate.vue").then(m => m.default || m)
  },
  {
    name: rtu7q0sGTBAbpMeta?.name ?? "toc-equip-pathinfo-rtu",
    path: rtu7q0sGTBAbpMeta?.path ?? ":pathinfo/rtu",
    meta: rtu7q0sGTBAbpMeta || {},
    alias: rtu7q0sGTBAbpMeta?.alias || [],
    redirect: rtu7q0sGTBAbpMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/rtu.vue").then(m => m.default || m)
  },
  {
    path: siteC23kAPScFAMeta?.path ?? ":pathinfo/site",
    children: [
  {
    name: geo4Td68yrpqoMeta?.name ?? "toc-equip-pathinfo-site-newsitename-geo",
    path: geo4Td68yrpqoMeta?.path ?? ":newsitename/geo",
    meta: geo4Td68yrpqoMeta || {},
    alias: geo4Td68yrpqoMeta?.alias || [],
    redirect: geo4Td68yrpqoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/geo.vue").then(m => m.default || m)
  },
  {
    name: pvmG7KI09NT9Meta?.name ?? "toc-equip-pathinfo-site-newsitename-pv",
    path: pvmG7KI09NT9Meta?.path ?? ":newsitename/pv",
    meta: pvmG7KI09NT9Meta || {},
    alias: pvmG7KI09NT9Meta?.alias || [],
    redirect: pvmG7KI09NT9Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatqw2dqJ2EuWMeta?.name ?? "toc-equip-pathinfo-site-newsitename-solarheat",
    path: solarheatqw2dqJ2EuWMeta?.path ?? ":newsitename/solarheat",
    meta: solarheatqw2dqJ2EuWMeta || {},
    alias: solarheatqw2dqJ2EuWMeta?.alias || [],
    redirect: solarheatqw2dqJ2EuWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[newsitename]/solarheat.vue").then(m => m.default || m)
  },
  {
    name: _91sitename_93wMsXHZRfPdMeta?.name ?? "toc-equip-pathinfo-site-sitename",
    path: _91sitename_93wMsXHZRfPdMeta?.path ?? ":sitename",
    children: [
  {
    name: geojuDjGvOX47Meta?.name ?? "toc-equip-pathinfo-site-sitename-geo",
    path: geojuDjGvOX47Meta?.path ?? "geo",
    meta: geojuDjGvOX47Meta || {},
    alias: geojuDjGvOX47Meta?.alias || [],
    redirect: geojuDjGvOX47Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/geo.vue").then(m => m.default || m)
  },
  {
    name: pvOrKOg5LvDXMeta?.name ?? "toc-equip-pathinfo-site-sitename-pv",
    path: pvOrKOg5LvDXMeta?.path ?? "pv",
    meta: pvOrKOg5LvDXMeta || {},
    alias: pvOrKOg5LvDXMeta?.alias || [],
    redirect: pvOrKOg5LvDXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatMe6YgBS1EDMeta?.name ?? "toc-equip-pathinfo-site-sitename-solarheat",
    path: solarheatMe6YgBS1EDMeta?.path ?? "solarheat",
    meta: solarheatMe6YgBS1EDMeta || {},
    alias: solarheatMe6YgBS1EDMeta?.alias || [],
    redirect: solarheatMe6YgBS1EDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename]/solarheat.vue").then(m => m.default || m)
  }
],
    meta: _91sitename_93wMsXHZRfPdMeta || {},
    alias: _91sitename_93wMsXHZRfPdMeta?.alias || [],
    redirect: _91sitename_93wMsXHZRfPdMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/[sitename].vue").then(m => m.default || m)
  },
  {
    name: indexgyNLtITETRMeta?.name ?? "toc-equip-pathinfo-site",
    path: indexgyNLtITETRMeta?.path ?? "",
    meta: indexgyNLtITETRMeta || {},
    alias: indexgyNLtITETRMeta?.alias || [],
    redirect: indexgyNLtITETRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/index.vue").then(m => m.default || m)
  },
  {
    name: _91newsitename_93HKfYFd4AszMeta?.name ?? "toc-equip-pathinfo-site-test-newsitename",
    path: _91newsitename_93HKfYFd4AszMeta?.path ?? "test/:newsitename",
    meta: _91newsitename_93HKfYFd4AszMeta || {},
    alias: _91newsitename_93HKfYFd4AszMeta?.alias || [],
    redirect: _91newsitename_93HKfYFd4AszMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site/test/[newsitename].vue").then(m => m.default || m)
  }
],
    name: siteC23kAPScFAMeta?.name ?? undefined,
    meta: siteC23kAPScFAMeta || {},
    alias: siteC23kAPScFAMeta?.alias || [],
    redirect: siteC23kAPScFAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip/[pathinfo]/site.vue").then(m => m.default || m)
  }
],
    meta: equipnBhvoO3FtOMeta || {},
    alias: equipnBhvoO3FtOMeta?.alias || [],
    redirect: equipnBhvoO3FtOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equip.vue").then(m => m.default || m)
  },
  {
    name: equipinfoOXbPvtEFJ7Meta?.name ?? "toc-equipinfo",
    path: equipinfoOXbPvtEFJ7Meta?.path ?? "equipinfo",
    meta: equipinfoOXbPvtEFJ7Meta || {},
    alias: equipinfoOXbPvtEFJ7Meta?.alias || [],
    redirect: equipinfoOXbPvtEFJ7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/equipinfo.vue").then(m => m.default || m)
  },
  {
    name: errorIdztcyDUpbMeta?.name ?? "toc-error",
    path: errorIdztcyDUpbMeta?.path ?? "error",
    meta: errorIdztcyDUpbMeta || {},
    alias: errorIdztcyDUpbMeta?.alias || [],
    redirect: errorIdztcyDUpbMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/error.vue").then(m => m.default || m)
  },
  {
    path: eventnmy4yXKqpRMeta?.path ?? "event",
    children: [
  {
    name: event_45listnNFIELmhBzMeta?.name ?? "toc-event-event-list",
    path: event_45listnNFIELmhBzMeta?.path ?? "event-list",
    children: [
  {
    name: _91eventId_93QMnfWb99bRMeta?.name ?? "toc-event-event-list-eventId",
    path: _91eventId_93QMnfWb99bRMeta?.path ?? ":eventId",
    meta: _91eventId_93QMnfWb99bRMeta || {},
    alias: _91eventId_93QMnfWb99bRMeta?.alias || [],
    redirect: _91eventId_93QMnfWb99bRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/event/event-list/[eventId].vue").then(m => m.default || m)
  }
],
    meta: event_45listnNFIELmhBzMeta || {},
    alias: event_45listnNFIELmhBzMeta?.alias || [],
    redirect: event_45listnNFIELmhBzMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/event/event-list.vue").then(m => m.default || m)
  },
  {
    name: index0LTps87GEOMeta?.name ?? "toc-event",
    path: index0LTps87GEOMeta?.path ?? "",
    meta: index0LTps87GEOMeta || {},
    alias: index0LTps87GEOMeta?.alias || [],
    redirect: index0LTps87GEOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/event/index.vue").then(m => m.default || m)
  }
],
    name: eventnmy4yXKqpRMeta?.name ?? undefined,
    meta: eventnmy4yXKqpRMeta || {},
    alias: eventnmy4yXKqpRMeta?.alias || [],
    redirect: eventnmy4yXKqpRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/event.vue").then(m => m.default || m)
  },
  {
    name: installXNKiQBGNQ6Meta?.name ?? "toc-install",
    path: installXNKiQBGNQ6Meta?.path ?? "install",
    meta: installXNKiQBGNQ6Meta || {},
    alias: installXNKiQBGNQ6Meta?.alias || [],
    redirect: installXNKiQBGNQ6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/install.vue").then(m => m.default || m)
  },
  {
    name: inventorypDiQA2qar2Meta?.name ?? "toc-inventory",
    path: inventorypDiQA2qar2Meta?.path ?? "inventory",
    children: [
  {
    name: addraTcmAHHSOMeta?.name ?? "toc-inventory-equip-company-add",
    path: addraTcmAHHSOMeta?.path ?? "equip-company/add",
    meta: addraTcmAHHSOMeta || {},
    alias: addraTcmAHHSOMeta?.alias || [],
    redirect: addraTcmAHHSOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/inventory/equip-company/add.vue").then(m => m.default || m)
  },
  {
    name: productHkkDzNh0eTMeta?.name ?? "toc-inventory-equip-company-product",
    path: productHkkDzNh0eTMeta?.path ?? "equip-company/product",
    meta: productHkkDzNh0eTMeta || {},
    alias: productHkkDzNh0eTMeta?.alias || [],
    redirect: productHkkDzNh0eTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/inventory/equip-company/product.vue").then(m => m.default || m)
  }
],
    meta: inventorypDiQA2qar2Meta || {},
    alias: inventorypDiQA2qar2Meta?.alias || [],
    redirect: inventorypDiQA2qar2Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/inventory.vue").then(m => m.default || m)
  },
  {
    name: maintainencemMWyEF6YV0Meta?.name ?? "toc-maintainence",
    path: maintainencemMWyEF6YV0Meta?.path ?? "maintainence",
    meta: maintainencemMWyEF6YV0Meta || {},
    alias: maintainencemMWyEF6YV0Meta?.alias || [],
    redirect: maintainencemMWyEF6YV0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/maintainence.vue").then(m => m.default || m)
  },
  {
    path: bpm9roC7nJsEwMeta?.path ?? "management/bpm",
    children: [
  {
    name: bpm_45detailE3kauLIG5MMeta?.name ?? "toc-management-bpm-bpm-detail",
    path: bpm_45detailE3kauLIG5MMeta?.path ?? "bpm-detail",
    meta: bpm_45detailE3kauLIG5MMeta || {},
    alias: bpm_45detailE3kauLIG5MMeta?.alias || [],
    redirect: bpm_45detailE3kauLIG5MMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm/bpm-detail.vue").then(m => m.default || m)
  },
  {
    name: bpm_45table_45boxMgddtumOUOMeta?.name ?? "toc-management-bpm-bpm-table-box",
    path: bpm_45table_45boxMgddtumOUOMeta?.path ?? "bpm-table-box",
    meta: bpm_45table_45boxMgddtumOUOMeta || {},
    alias: bpm_45table_45boxMgddtumOUOMeta?.alias || [],
    redirect: bpm_45table_45boxMgddtumOUOMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm/bpm-table-box.vue").then(m => m.default || m)
  },
  {
    name: bpm_45upload_45modalOrJUfjAKxUMeta?.name ?? "toc-management-bpm-bpm-upload-modal",
    path: bpm_45upload_45modalOrJUfjAKxUMeta?.path ?? "bpm-upload-modal",
    meta: bpm_45upload_45modalOrJUfjAKxUMeta || {},
    alias: bpm_45upload_45modalOrJUfjAKxUMeta?.alias || [],
    redirect: bpm_45upload_45modalOrJUfjAKxUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm/bpm-upload-modal.vue").then(m => m.default || m)
  },
  {
    name: bpm_45upload_45progress_45modalykw7kHa8EdMeta?.name ?? "toc-management-bpm-bpm-upload-progress-modal",
    path: bpm_45upload_45progress_45modalykw7kHa8EdMeta?.path ?? "bpm-upload-progress-modal",
    meta: bpm_45upload_45progress_45modalykw7kHa8EdMeta || {},
    alias: bpm_45upload_45progress_45modalykw7kHa8EdMeta?.alias || [],
    redirect: bpm_45upload_45progress_45modalykw7kHa8EdMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm/bpm-upload-progress-modal.vue").then(m => m.default || m)
  },
  {
    name: indexWvqql8GP4DMeta?.name ?? "toc-management-bpm",
    path: indexWvqql8GP4DMeta?.path ?? "",
    meta: indexWvqql8GP4DMeta || {},
    alias: indexWvqql8GP4DMeta?.alias || [],
    redirect: indexWvqql8GP4DMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm/index.vue").then(m => m.default || m)
  }
],
    name: bpm9roC7nJsEwMeta?.name ?? undefined,
    meta: bpm9roC7nJsEwMeta || {},
    alias: bpm9roC7nJsEwMeta?.alias || [],
    redirect: bpm9roC7nJsEwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/bpm.vue").then(m => m.default || m)
  },
  {
    path: companywmmz7UHNiVMeta?.path ?? "management/company",
    children: [
  {
    name: adddXxCNB7oHQMeta?.name ?? "toc-management-company-add",
    path: adddXxCNB7oHQMeta?.path ?? "add",
    meta: adddXxCNB7oHQMeta || {},
    alias: adddXxCNB7oHQMeta?.alias || [],
    redirect: adddXxCNB7oHQMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/company/add.vue").then(m => m.default || m)
  },
  {
    name: indexqXGzHKqEaZMeta?.name ?? "toc-management-company",
    path: indexqXGzHKqEaZMeta?.path ?? "",
    meta: indexqXGzHKqEaZMeta || {},
    alias: indexqXGzHKqEaZMeta?.alias || [],
    redirect: indexqXGzHKqEaZMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/company/index.vue").then(m => m.default || m)
  }
],
    name: companywmmz7UHNiVMeta?.name ?? undefined,
    meta: companywmmz7UHNiVMeta || {},
    alias: companywmmz7UHNiVMeta?.alias || [],
    redirect: companywmmz7UHNiVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/company.vue").then(m => m.default || m)
  },
  {
    name: equip_45modelFJz4rL4nDaMeta?.name ?? "toc-management-equip-model",
    path: equip_45modelFJz4rL4nDaMeta?.path ?? "management/equip-model",
    meta: equip_45modelFJz4rL4nDaMeta || {},
    alias: equip_45modelFJz4rL4nDaMeta?.alias || [],
    redirect: equip_45modelFJz4rL4nDaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip-model.vue").then(m => m.default || m)
  },
  {
    path: equipfeysV7ejlNMeta?.path ?? "management/equip",
    children: [
  {
    name: addw1oY11yl7AMeta?.name ?? "toc-management-equip-add",
    path: addw1oY11yl7AMeta?.path ?? "add",
    children: [
  {
    name: find_45ownerW7nhZrwEEKMeta?.name ?? "toc-management-equip-add-find-owner",
    path: find_45ownerW7nhZrwEEKMeta?.path ?? "find-owner",
    meta: find_45ownerW7nhZrwEEKMeta || {},
    alias: find_45ownerW7nhZrwEEKMeta?.alias || [],
    redirect: find_45ownerW7nhZrwEEKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/add/find-owner.vue").then(m => m.default || m)
  },
  {
    name: geo_45specibPgG65rjAMeta?.name ?? "toc-management-equip-add-geo-spec",
    path: geo_45specibPgG65rjAMeta?.path ?? "geo-spec",
    meta: geo_45specibPgG65rjAMeta || {},
    alias: geo_45specibPgG65rjAMeta?.alias || [],
    redirect: geo_45specibPgG65rjAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/add/geo-spec.vue").then(m => m.default || m)
  },
  {
    name: pv_45specy5YVNMTNKMMeta?.name ?? "toc-management-equip-add-pv-spec",
    path: pv_45specy5YVNMTNKMMeta?.path ?? "pv-spec",
    meta: pv_45specy5YVNMTNKMMeta || {},
    alias: pv_45specy5YVNMTNKMMeta?.alias || [],
    redirect: pv_45specy5YVNMTNKMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/add/pv-spec.vue").then(m => m.default || m)
  },
  {
    name: solarheat_45specjNywurCmLkMeta?.name ?? "toc-management-equip-add-solarheat-spec",
    path: solarheat_45specjNywurCmLkMeta?.path ?? "solarheat-spec",
    meta: solarheat_45specjNywurCmLkMeta || {},
    alias: solarheat_45specjNywurCmLkMeta?.alias || [],
    redirect: solarheat_45specjNywurCmLkMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/add/solarheat-spec.vue").then(m => m.default || m)
  }
],
    meta: addw1oY11yl7AMeta || {},
    alias: addw1oY11yl7AMeta?.alias || [],
    redirect: addw1oY11yl7AMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/add.vue").then(m => m.default || m)
  },
  {
    name: indexW3qWgZaYdJMeta?.name ?? "toc-management-equip",
    path: indexW3qWgZaYdJMeta?.path ?? "",
    meta: indexW3qWgZaYdJMeta || {},
    alias: indexW3qWgZaYdJMeta?.alias || [],
    redirect: indexW3qWgZaYdJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip/index.vue").then(m => m.default || m)
  }
],
    name: equipfeysV7ejlNMeta?.name ?? undefined,
    meta: equipfeysV7ejlNMeta || {},
    alias: equipfeysV7ejlNMeta?.alias || [],
    redirect: equipfeysV7ejlNMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/equip.vue").then(m => m.default || m)
  },
  {
    path: installerq33YFabtq3Meta?.path ?? "management/installer",
    children: [
  {
    name: indexdtOUXrczAAMeta?.name ?? "toc-management-installer",
    path: indexdtOUXrczAAMeta?.path ?? "",
    meta: indexdtOUXrczAAMeta || {},
    alias: indexdtOUXrczAAMeta?.alias || [],
    redirect: indexdtOUXrczAAMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/installer/index.vue").then(m => m.default || m)
  },
  {
    name: installer_45req_45modalbJLgqZaD3uMeta?.name ?? "toc-management-installer-installer-req-modal",
    path: installer_45req_45modalbJLgqZaD3uMeta?.path ?? "installer-req-modal",
    meta: installer_45req_45modalbJLgqZaD3uMeta || {},
    alias: installer_45req_45modalbJLgqZaD3uMeta?.alias || [],
    redirect: installer_45req_45modalbJLgqZaD3uMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/installer/installer-req-modal.vue").then(m => m.default || m)
  }
],
    name: installerq33YFabtq3Meta?.name ?? undefined,
    meta: installerq33YFabtq3Meta || {},
    alias: installerq33YFabtq3Meta?.alias || [],
    redirect: installerq33YFabtq3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/installer.vue").then(m => m.default || m)
  },
  {
    name: management46Qxl8286WMeta?.name ?? "toc-management-management",
    path: management46Qxl8286WMeta?.path ?? "management/management",
    meta: management46Qxl8286WMeta || {},
    alias: management46Qxl8286WMeta?.alias || [],
    redirect: management46Qxl8286WMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/management.vue").then(m => m.default || m)
  },
  {
    name: indexx4KtKwuOODMeta?.name ?? "toc-management-manager",
    path: indexx4KtKwuOODMeta?.path ?? "management/manager",
    meta: indexx4KtKwuOODMeta || {},
    alias: indexx4KtKwuOODMeta?.alias || [],
    redirect: indexx4KtKwuOODMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/manager/index.vue").then(m => m.default || m)
  },
  {
    name: noticeHkpQYwJNBTMeta?.name ?? "toc-management-notice",
    path: noticeHkpQYwJNBTMeta?.path ?? "management/notice",
    meta: noticeHkpQYwJNBTMeta || {},
    alias: noticeHkpQYwJNBTMeta?.alias || [],
    redirect: noticeHkpQYwJNBTMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/notice.vue").then(m => m.default || m)
  },
  {
    path: owner3BOLtxAD17Meta?.path ?? "management/owner",
    children: [
  {
    name: add_45componentyew87FOYHxMeta?.name ?? "toc-management-owner-add-component",
    path: add_45componentyew87FOYHxMeta?.path ?? "add-component",
    meta: add_45componentyew87FOYHxMeta || {},
    alias: add_45componentyew87FOYHxMeta?.alias || [],
    redirect: add_45componentyew87FOYHxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/owner/add-component.vue").then(m => m.default || m)
  },
  {
    name: add0MTaf7pJXhMeta?.name ?? "toc-management-owner-add",
    path: add0MTaf7pJXhMeta?.path ?? "add",
    meta: add0MTaf7pJXhMeta || {},
    alias: add0MTaf7pJXhMeta?.alias || [],
    redirect: add0MTaf7pJXhMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/owner/add.vue").then(m => m.default || m)
  },
  {
    name: indexyrePqMXEfJMeta?.name ?? "toc-management-owner",
    path: indexyrePqMXEfJMeta?.path ?? "",
    meta: indexyrePqMXEfJMeta || {},
    alias: indexyrePqMXEfJMeta?.alias || [],
    redirect: indexyrePqMXEfJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/owner/index.vue").then(m => m.default || m)
  }
],
    name: owner3BOLtxAD17Meta?.name ?? undefined,
    meta: owner3BOLtxAD17Meta || {},
    alias: owner3BOLtxAD17Meta?.alias || [],
    redirect: owner3BOLtxAD17Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/owner.vue").then(m => m.default || m)
  },
  {
    path: permitI7OLVj90JSMeta?.path ?? "management/permit",
    children: [
  {
    name: indexyxGyHuMsBUMeta?.name ?? "toc-management-permit",
    path: indexyxGyHuMsBUMeta?.path ?? "",
    meta: indexyxGyHuMsBUMeta || {},
    alias: indexyxGyHuMsBUMeta?.alias || [],
    redirect: indexyxGyHuMsBUMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/permit/index.vue").then(m => m.default || m)
  }
],
    name: permitI7OLVj90JSMeta?.name ?? undefined,
    meta: permitI7OLVj90JSMeta || {},
    alias: permitI7OLVj90JSMeta?.alias || [],
    redirect: permitI7OLVj90JSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/permit.vue").then(m => m.default || m)
  },
  {
    path: rtu_45operZPRnPPQngKMeta?.path ?? "management/rtu-oper",
    children: [
  {
    name: indexjRJkPjfhwdMeta?.name ?? "toc-management-rtu-oper",
    path: indexjRJkPjfhwdMeta?.path ?? "",
    meta: indexjRJkPjfhwdMeta || {},
    alias: indexjRJkPjfhwdMeta?.alias || [],
    redirect: indexjRJkPjfhwdMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/rtu-oper/index.vue").then(m => m.default || m)
  },
  {
    name: send_45rems_45modalKYoz0J17WoMeta?.name ?? "toc-management-rtu-oper-send-rems-modal",
    path: send_45rems_45modalKYoz0J17WoMeta?.path ?? "send-rems-modal",
    meta: send_45rems_45modalKYoz0J17WoMeta || {},
    alias: send_45rems_45modalKYoz0J17WoMeta?.alias || [],
    redirect: send_45rems_45modalKYoz0J17WoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/rtu-oper/send-rems-modal.vue").then(m => m.default || m)
  }
],
    name: rtu_45operZPRnPPQngKMeta?.name ?? undefined,
    meta: rtu_45operZPRnPPQngKMeta || {},
    alias: rtu_45operZPRnPPQngKMeta?.alias || [],
    redirect: rtu_45operZPRnPPQngKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/management/rtu-oper.vue").then(m => m.default || m)
  },
  {
    name: memberY5S10LujOjMeta?.name ?? "toc-member",
    path: memberY5S10LujOjMeta?.path ?? "member",
    children: [
  {
    name: operator5p4HcVJ0AmMeta?.name ?? "toc-member-operator",
    path: operator5p4HcVJ0AmMeta?.path ?? "operator",
    meta: operator5p4HcVJ0AmMeta || {},
    alias: operator5p4HcVJ0AmMeta?.alias || [],
    redirect: operator5p4HcVJ0AmMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/operator.vue").then(m => m.default || m)
  },
  {
    name: _91id_93r9lTpKGJE5Meta?.name ?? "toc-member-owner-member-id",
    path: _91id_93r9lTpKGJE5Meta?.path ?? "owner-member/:id",
    children: [
  {
    name: geoDjHJsxgcSgMeta?.name ?? "toc-member-owner-member-id-geo",
    path: geoDjHJsxgcSgMeta?.path ?? "geo",
    meta: geoDjHJsxgcSgMeta || {},
    alias: geoDjHJsxgcSgMeta?.alias || [],
    redirect: geoDjHJsxgcSgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/[id]/geo.vue").then(m => m.default || m)
  },
  {
    name: pvfmb9LS4YLKMeta?.name ?? "toc-member-owner-member-id-pv",
    path: pvfmb9LS4YLKMeta?.path ?? "pv",
    meta: pvfmb9LS4YLKMeta || {},
    alias: pvfmb9LS4YLKMeta?.alias || [],
    redirect: pvfmb9LS4YLKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/[id]/pv.vue").then(m => m.default || m)
  },
  {
    name: solarheatFAwHrRvuxSMeta?.name ?? "toc-member-owner-member-id-solarheat",
    path: solarheatFAwHrRvuxSMeta?.path ?? "solarheat",
    meta: solarheatFAwHrRvuxSMeta || {},
    alias: solarheatFAwHrRvuxSMeta?.alias || [],
    redirect: solarheatFAwHrRvuxSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/[id]/solarheat.vue").then(m => m.default || m)
  }
],
    meta: _91id_93r9lTpKGJE5Meta || {},
    alias: _91id_93r9lTpKGJE5Meta?.alias || [],
    redirect: _91id_93r9lTpKGJE5Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/[id].vue").then(m => m.default || m)
  },
  {
    name: owner_45registS00Zc5AyC6Meta?.name ?? "toc-member-owner-member-owner-regist",
    path: owner_45registS00Zc5AyC6Meta?.path ?? "owner-member/owner-regist",
    meta: owner_45registS00Zc5AyC6Meta || {},
    alias: owner_45registS00Zc5AyC6Meta?.alias || [],
    redirect: owner_45registS00Zc5AyC6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/owner-regist.vue").then(m => m.default || m)
  },
  {
    name: owner_45searchbFec8NN4ICMeta?.name ?? "toc-member-owner-member-owner-search",
    path: owner_45searchbFec8NN4ICMeta?.path ?? "owner-member/owner-search",
    meta: owner_45searchbFec8NN4ICMeta || {},
    alias: owner_45searchbFec8NN4ICMeta?.alias || [],
    redirect: owner_45searchbFec8NN4ICMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner-member/owner-search.vue").then(m => m.default || m)
  },
  {
    name: ownerZuCUCc0MbyMeta?.name ?? "toc-member-owner",
    path: ownerZuCUCc0MbyMeta?.path ?? "owner",
    meta: ownerZuCUCc0MbyMeta || {},
    alias: ownerZuCUCc0MbyMeta?.alias || [],
    redirect: ownerZuCUCc0MbyMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/owner.vue").then(m => m.default || m)
  },
  {
    name: systemsGq3gUaPQEMeta?.name ?? "toc-member-system",
    path: systemsGq3gUaPQEMeta?.path ?? "system",
    meta: systemsGq3gUaPQEMeta || {},
    alias: systemsGq3gUaPQEMeta?.alias || [],
    redirect: systemsGq3gUaPQEMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member/system.vue").then(m => m.default || m)
  }
],
    meta: memberY5S10LujOjMeta || {},
    alias: memberY5S10LujOjMeta?.alias || [],
    redirect: memberY5S10LujOjMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/member.vue").then(m => m.default || m)
  },
  {
    name: messagegGle26j6NoMeta?.name ?? "toc-message",
    path: messagegGle26j6NoMeta?.path ?? "message",
    children: [
  {
    name: alarm_45sendingoVVnHCubmHMeta?.name ?? "toc-message-alarm-sending",
    path: alarm_45sendingoVVnHCubmHMeta?.path ?? "alarm-sending",
    meta: alarm_45sendingoVVnHCubmHMeta || {},
    alias: alarm_45sendingoVVnHCubmHMeta?.alias || [],
    redirect: alarm_45sendingoVVnHCubmHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/message/alarm-sending.vue").then(m => m.default || m)
  },
  {
    name: email_45sending7GCBLiLuGeMeta?.name ?? "toc-message-email-sending",
    path: email_45sending7GCBLiLuGeMeta?.path ?? "email-sending",
    meta: email_45sending7GCBLiLuGeMeta || {},
    alias: email_45sending7GCBLiLuGeMeta?.alias || [],
    redirect: email_45sending7GCBLiLuGeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/message/email-sending.vue").then(m => m.default || m)
  }
],
    meta: messagegGle26j6NoMeta || {},
    alias: messagegGle26j6NoMeta?.alias || [],
    redirect: messagegGle26j6NoMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/message.vue").then(m => m.default || m)
  },
  {
    name: monitoringYDLAykCA3fMeta?.name ?? "toc-monitoring",
    path: monitoringYDLAykCA3fMeta?.path ?? "monitoring",
    children: [
  {
    name: comprehensive_45slidefjwtxgogEMMeta?.name ?? "toc-monitoring-comprehensive-slide",
    path: comprehensive_45slidefjwtxgogEMMeta?.path ?? "comprehensive-slide",
    meta: comprehensive_45slidefjwtxgogEMMeta || {},
    alias: comprehensive_45slidefjwtxgogEMMeta?.alias || [],
    redirect: comprehensive_45slidefjwtxgogEMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/comprehensive-slide.vue").then(m => m.default || m)
  },
  {
    name: dashboardOQu0MPO9FSMeta?.name ?? "toc-monitoring-dashboard",
    path: dashboardOQu0MPO9FSMeta?.path ?? "dashboard",
    meta: dashboardOQu0MPO9FSMeta || {},
    alias: dashboardOQu0MPO9FSMeta?.alias || [],
    redirect: dashboardOQu0MPO9FSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/dashboard.vue").then(m => m.default || m)
  },
  {
    name: equip_dashboardciTMMCgnkxMeta?.name ?? "toc-monitoring-equip_dashboard",
    path: equip_dashboardciTMMCgnkxMeta?.path ?? "equip_dashboard",
    meta: equip_dashboardciTMMCgnkxMeta || {},
    alias: equip_dashboardciTMMCgnkxMeta?.alias || [],
    redirect: equip_dashboardciTMMCgnkxMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/equip_dashboard.vue").then(m => m.default || m)
  },
  {
    name: newDashboardgPy5ZC8ctKMeta?.name ?? "toc-monitoring-newDashboard",
    path: newDashboardgPy5ZC8ctKMeta?.path ?? "newDashboard",
    meta: newDashboardgPy5ZC8ctKMeta || {},
    alias: newDashboardgPy5ZC8ctKMeta?.alias || [],
    redirect: newDashboardgPy5ZC8ctKMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/newDashboard.vue").then(m => m.default || m)
  },
  {
    name: prod_45slideqscf4zBUKIMeta?.name ?? "toc-monitoring-prod-slide",
    path: prod_45slideqscf4zBUKIMeta?.path ?? "prod-slide",
    meta: prod_45slideqscf4zBUKIMeta || {},
    alias: prod_45slideqscf4zBUKIMeta?.alias || [],
    redirect: prod_45slideqscf4zBUKIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/prod-slide.vue").then(m => m.default || m)
  },
  {
    name: temp_newDashboardFRjOIADYneMeta?.name ?? "toc-monitoring-temp_newDashboard",
    path: temp_newDashboardFRjOIADYneMeta?.path ?? "temp_newDashboard",
    meta: temp_newDashboardFRjOIADYneMeta || {},
    alias: temp_newDashboardFRjOIADYneMeta?.alias || [],
    redirect: temp_newDashboardFRjOIADYneMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring/temp_newDashboard.vue").then(m => m.default || m)
  }
],
    meta: monitoringYDLAykCA3fMeta || {},
    alias: monitoringYDLAykCA3fMeta?.alias || [],
    redirect: monitoringYDLAykCA3fMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/monitoring.vue").then(m => m.default || m)
  },
  {
    name: not_45foundeAtdoFsRPMMeta?.name ?? "toc-not-found",
    path: not_45foundeAtdoFsRPMMeta?.path ?? "not-found",
    meta: not_45foundeAtdoFsRPMMeta || {},
    alias: not_45foundeAtdoFsRPMMeta?.alias || [],
    redirect: not_45foundeAtdoFsRPMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/not-found.vue").then(m => m.default || m)
  },
  {
    name: operate2hQ0mZx4rXMeta?.name ?? "toc-operate",
    path: operate2hQ0mZx4rXMeta?.path ?? "operate",
    meta: operate2hQ0mZx4rXMeta || {},
    alias: operate2hQ0mZx4rXMeta?.alias || [],
    redirect: operate2hQ0mZx4rXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/operate.vue").then(m => m.default || m)
  },
  {
    name: reporteQTfNPHzo0Meta?.name ?? "toc-report",
    path: reporteQTfNPHzo0Meta?.path ?? "report",
    children: [
  {
    name: analyze_45efficientnWVlM3rUpXMeta?.name ?? "toc-report-analyze-efficient",
    path: analyze_45efficientnWVlM3rUpXMeta?.path ?? "analyze-efficient",
    children: [
  {
    name: ownersXMSKWTVPPwMeta?.name ?? "toc-report-analyze-efficient-owners",
    path: ownersXMSKWTVPPwMeta?.path ?? "owners",
    meta: ownersXMSKWTVPPwMeta || {},
    alias: ownersXMSKWTVPPwMeta?.alias || [],
    redirect: ownersXMSKWTVPPwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-efficient/owners.vue").then(m => m.default || m)
  },
  {
    name: prjkindsvSo4mY9TckMeta?.name ?? "toc-report-analyze-efficient-prjkinds",
    path: prjkindsvSo4mY9TckMeta?.path ?? "prjkinds",
    meta: prjkindsvSo4mY9TckMeta || {},
    alias: prjkindsvSo4mY9TckMeta?.alias || [],
    redirect: prjkindsvSo4mY9TckMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-efficient/prjkinds.vue").then(m => m.default || m)
  },
  {
    name: regionsvyqrXuJQUCMeta?.name ?? "toc-report-analyze-efficient-regions",
    path: regionsvyqrXuJQUCMeta?.path ?? "regions",
    meta: regionsvyqrXuJQUCMeta || {},
    alias: regionsvyqrXuJQUCMeta?.alias || [],
    redirect: regionsvyqrXuJQUCMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-efficient/regions.vue").then(m => m.default || m)
  }
],
    meta: analyze_45efficientnWVlM3rUpXMeta || {},
    alias: analyze_45efficientnWVlM3rUpXMeta?.alias || [],
    redirect: analyze_45efficientnWVlM3rUpXMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-efficient.vue").then(m => m.default || m)
  },
  {
    name: analyze_45product7AfSA9wtfeMeta?.name ?? "toc-report-analyze-product",
    path: analyze_45product7AfSA9wtfeMeta?.path ?? "analyze-product",
    children: [
  {
    name: ownersrvmO3HwHBlMeta?.name ?? "toc-report-analyze-product-owners",
    path: ownersrvmO3HwHBlMeta?.path ?? "owners",
    meta: ownersrvmO3HwHBlMeta || {},
    alias: ownersrvmO3HwHBlMeta?.alias || [],
    redirect: ownersrvmO3HwHBlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-product/owners.vue").then(m => m.default || m)
  },
  {
    name: prjkindsuVWtp4hdQHMeta?.name ?? "toc-report-analyze-product-prjkinds",
    path: prjkindsuVWtp4hdQHMeta?.path ?? "prjkinds",
    meta: prjkindsuVWtp4hdQHMeta || {},
    alias: prjkindsuVWtp4hdQHMeta?.alias || [],
    redirect: prjkindsuVWtp4hdQHMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-product/prjkinds.vue").then(m => m.default || m)
  },
  {
    name: regions5tuAQHUUf3Meta?.name ?? "toc-report-analyze-product-regions",
    path: regions5tuAQHUUf3Meta?.path ?? "regions",
    meta: regions5tuAQHUUf3Meta || {},
    alias: regions5tuAQHUUf3Meta?.alias || [],
    redirect: regions5tuAQHUUf3Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-product/regions.vue").then(m => m.default || m)
  }
],
    meta: analyze_45product7AfSA9wtfeMeta || {},
    alias: analyze_45product7AfSA9wtfeMeta?.alias || [],
    redirect: analyze_45product7AfSA9wtfeMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/analyze-product.vue").then(m => m.default || m)
  },
  {
    name: env_45factorNs7PifOINWMeta?.name ?? "toc-report-env-factor",
    path: env_45factorNs7PifOINWMeta?.path ?? "env-factor",
    meta: env_45factorNs7PifOINWMeta || {},
    alias: env_45factorNs7PifOINWMeta?.alias || [],
    redirect: env_45factorNs7PifOINWMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/env-factor.vue").then(m => m.default || m)
  },
  {
    name: eventQZuH7UHp9BMeta?.name ?? "toc-report-event",
    path: eventQZuH7UHp9BMeta?.path ?? "event",
    meta: eventQZuH7UHp9BMeta || {},
    alias: eventQZuH7UHp9BMeta?.alias || [],
    redirect: eventQZuH7UHp9BMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/event.vue").then(m => m.default || m)
  },
  {
    name: predictOc8NLwoUvVMeta?.name ?? "toc-report-predict",
    path: predictOc8NLwoUvVMeta?.path ?? "predict",
    meta: predictOc8NLwoUvVMeta || {},
    alias: predictOc8NLwoUvVMeta?.alias || [],
    redirect: predictOc8NLwoUvVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/predict.vue").then(m => m.default || m)
  },
  {
    name: productXNrbypNBU6Meta?.name ?? "toc-report-product",
    path: productXNrbypNBU6Meta?.path ?? "product",
    meta: productXNrbypNBU6Meta || {},
    alias: productXNrbypNBU6Meta?.alias || [],
    redirect: productXNrbypNBU6Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report/product.vue").then(m => m.default || m)
  }
],
    meta: reporteQTfNPHzo0Meta || {},
    alias: reporteQTfNPHzo0Meta?.alias || [],
    redirect: reporteQTfNPHzo0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/report.vue").then(m => m.default || m)
  },
  {
    name: service_45infoz31N6C6vitMeta?.name ?? "toc-service-info",
    path: service_45infoz31N6C6vitMeta?.path ?? "service-info",
    children: [
  {
    name: app_45versioneQoMeMz6wMMeta?.name ?? "toc-service-info-app-version",
    path: app_45versioneQoMeMz6wMMeta?.path ?? "app-version",
    meta: app_45versioneQoMeMz6wMMeta || {},
    alias: app_45versioneQoMeMz6wMMeta?.alias || [],
    redirect: app_45versioneQoMeMz6wMMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/service-info/app-version.vue").then(m => m.default || m)
  }
],
    meta: service_45infoz31N6C6vitMeta || {},
    alias: service_45infoz31N6C6vitMeta?.alias || [],
    redirect: service_45infoz31N6C6vitMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/service-info.vue").then(m => m.default || m)
  },
  {
    name: test1Af9BPP2PrMeta?.name ?? "toc-test",
    path: test1Af9BPP2PrMeta?.path ?? "test",
    meta: test1Af9BPP2PrMeta || {},
    alias: test1Af9BPP2PrMeta?.alias || [],
    redirect: test1Af9BPP2PrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/test.vue").then(m => m.default || m)
  },
  {
    name: user_45serviceRyvDUJhYbsMeta?.name ?? "toc-user-service",
    path: user_45serviceRyvDUJhYbsMeta?.path ?? "user-service",
    children: [
  {
    path: install_45request68PZLotpb2Meta?.path ?? "install-request",
    children: [
  {
    name: complement_45modalWIl2PFNF8fMeta?.name ?? "toc-user-service-install-request-complement-modal",
    path: complement_45modalWIl2PFNF8fMeta?.path ?? "complement-modal",
    meta: complement_45modalWIl2PFNF8fMeta || {},
    alias: complement_45modalWIl2PFNF8fMeta?.alias || [],
    redirect: complement_45modalWIl2PFNF8fMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/complement-modal.vue").then(m => m.default || m)
  },
  {
    name: complete_45modaltYVA7LPPSDMeta?.name ?? "toc-user-service-install-request-complete-modal",
    path: complete_45modaltYVA7LPPSDMeta?.path ?? "complete-modal",
    meta: complete_45modaltYVA7LPPSDMeta || {},
    alias: complete_45modaltYVA7LPPSDMeta?.alias || [],
    redirect: complete_45modaltYVA7LPPSDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/complete-modal.vue").then(m => m.default || m)
  },
  {
    name: work_45history_46infonBZP1A83DwMeta?.name ?? "toc-user-service-install-request-detailComponent-work-history.info",
    path: work_45history_46infonBZP1A83DwMeta?.path ?? "detailComponent/work-history.info",
    meta: work_45history_46infonBZP1A83DwMeta || {},
    alias: work_45history_46infonBZP1A83DwMeta?.alias || [],
    redirect: work_45history_46infonBZP1A83DwMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/detailComponent/work-history.info.vue").then(m => m.default || m)
  },
  {
    name: work_45install_45infopipSBrvil0Meta?.name ?? "toc-user-service-install-request-detailComponent-work-install-info",
    path: work_45install_45infopipSBrvil0Meta?.path ?? "detailComponent/work-install-info",
    meta: work_45install_45infopipSBrvil0Meta || {},
    alias: work_45install_45infopipSBrvil0Meta?.alias || [],
    redirect: work_45install_45infopipSBrvil0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/detailComponent/work-install-info.vue").then(m => m.default || m)
  },
  {
    name: index6e66svvpSSMeta?.name ?? "toc-user-service-install-request",
    path: index6e66svvpSSMeta?.path ?? "",
    meta: index6e66svvpSSMeta || {},
    alias: index6e66svvpSSMeta?.alias || [],
    redirect: index6e66svvpSSMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/index.vue").then(m => m.default || m)
  },
  {
    name: owner_45modal5AIc4QfomVMeta?.name ?? "toc-user-service-install-request-owner-modal",
    path: owner_45modal5AIc4QfomVMeta?.path ?? "owner-modal",
    meta: owner_45modal5AIc4QfomVMeta || {},
    alias: owner_45modal5AIc4QfomVMeta?.alias || [],
    redirect: owner_45modal5AIc4QfomVMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/owner-modal.vue").then(m => m.default || m)
  },
  {
    name: req_45detailwlCkAaC3CRMeta?.name ?? "toc-user-service-install-request-req-detail",
    path: req_45detailwlCkAaC3CRMeta?.path ?? "req-detail",
    meta: req_45detailwlCkAaC3CRMeta || {},
    alias: req_45detailwlCkAaC3CRMeta?.alias || [],
    redirect: req_45detailwlCkAaC3CRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/req-detail.vue").then(m => m.default || m)
  },
  {
    name: rtu_45chg_45modaln7ZXYRsBRRMeta?.name ?? "toc-user-service-install-request-rtu-chg-modal",
    path: rtu_45chg_45modaln7ZXYRsBRRMeta?.path ?? "rtu-chg-modal",
    meta: rtu_45chg_45modaln7ZXYRsBRRMeta || {},
    alias: rtu_45chg_45modaln7ZXYRsBRRMeta?.alias || [],
    redirect: rtu_45chg_45modaln7ZXYRsBRRMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request/rtu-chg-modal.vue").then(m => m.default || m)
  }
],
    name: install_45request68PZLotpb2Meta?.name ?? undefined,
    meta: install_45request68PZLotpb2Meta || {},
    alias: install_45request68PZLotpb2Meta?.alias || [],
    redirect: install_45request68PZLotpb2Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/install-request.vue").then(m => m.default || m)
  },
  {
    name: manager_45info9CA1zyi4EIMeta?.name ?? "toc-user-service-manager-info",
    path: manager_45info9CA1zyi4EIMeta?.path ?? "manager-info",
    meta: manager_45info9CA1zyi4EIMeta || {},
    alias: manager_45info9CA1zyi4EIMeta?.alias || [],
    redirect: manager_45info9CA1zyi4EIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/manager-info.vue").then(m => m.default || m)
  },
  {
    name: confirm_45modalQdriLbcZiLMeta?.name ?? "toc-user-service-modal-confirm-modal",
    path: confirm_45modalQdriLbcZiLMeta?.path ?? "modal/confirm-modal",
    meta: confirm_45modalQdriLbcZiLMeta || {},
    alias: confirm_45modalQdriLbcZiLMeta?.alias || [],
    redirect: confirm_45modalQdriLbcZiLMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/modal/confirm-modal.vue").then(m => m.default || m)
  },
  {
    name: manager_45add_45modalVRdD058MjgMeta?.name ?? "toc-user-service-modal-manager-add-modal",
    path: manager_45add_45modalVRdD058MjgMeta?.path ?? "modal/manager-add-modal",
    meta: manager_45add_45modalVRdD058MjgMeta || {},
    alias: manager_45add_45modalVRdD058MjgMeta?.alias || [],
    redirect: manager_45add_45modalVRdD058MjgMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/modal/manager-add-modal.vue").then(m => m.default || m)
  },
  {
    name: manager_45modify_45modalzIHzPFyP4YMeta?.name ?? "toc-user-service-modal-manager-modify-modal",
    path: manager_45modify_45modalzIHzPFyP4YMeta?.path ?? "modal/manager-modify-modal",
    meta: manager_45modify_45modalzIHzPFyP4YMeta || {},
    alias: manager_45modify_45modalzIHzPFyP4YMeta?.alias || [],
    redirect: manager_45modify_45modalzIHzPFyP4YMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/modal/manager-modify-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45manager_45all_45modal6T6r7dbE1UMeta?.name ?? "toc-user-service-modal-set-manager-all-modal",
    path: set_45manager_45all_45modal6T6r7dbE1UMeta?.path ?? "modal/set-manager-all-modal",
    meta: set_45manager_45all_45modal6T6r7dbE1UMeta || {},
    alias: set_45manager_45all_45modal6T6r7dbE1UMeta?.alias || [],
    redirect: set_45manager_45all_45modal6T6r7dbE1UMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/modal/set-manager-all-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45manager_45select_45modalrQjZn7fLMsMeta?.name ?? "toc-user-service-modal-set-manager-select-modal",
    path: set_45manager_45select_45modalrQjZn7fLMsMeta?.path ?? "modal/set-manager-select-modal",
    meta: set_45manager_45select_45modalrQjZn7fLMsMeta || {},
    alias: set_45manager_45select_45modalrQjZn7fLMsMeta?.alias || [],
    redirect: set_45manager_45select_45modalrQjZn7fLMsMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/modal/set-manager-select-modal.vue").then(m => m.default || m)
  },
  {
    name: set_45managerpC1XrULe8uMeta?.name ?? "toc-user-service-set-manager",
    path: set_45managerpC1XrULe8uMeta?.path ?? "set-manager",
    meta: set_45managerpC1XrULe8uMeta || {},
    alias: set_45managerpC1XrULe8uMeta?.alias || [],
    redirect: set_45managerpC1XrULe8uMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/set-manager.vue").then(m => m.default || m)
  },
  {
    path: user_45as_45companywJMbWlm6esMeta?.path ?? "user-as-company",
    children: [
  {
    name: indexU5rzUOySK4Meta?.name ?? "toc-user-service-user-as-company",
    path: indexU5rzUOySK4Meta?.path ?? "",
    meta: indexU5rzUOySK4Meta || {},
    alias: indexU5rzUOySK4Meta?.alias || [],
    redirect: indexU5rzUOySK4Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-company/index.vue").then(m => m.default || m)
  }
],
    name: user_45as_45companywJMbWlm6esMeta?.name ?? undefined,
    meta: user_45as_45companywJMbWlm6esMeta || {},
    alias: user_45as_45companywJMbWlm6esMeta?.alias || [],
    redirect: user_45as_45companywJMbWlm6esMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-company.vue").then(m => m.default || m)
  },
  {
    path: user_45as_45equipinfoGUweeSIgP0Meta?.path ?? "user-as-equipinfo",
    children: [
  {
    name: equip_45detailxyZhHRSDfDMeta?.name ?? "toc-user-service-user-as-equipinfo-equip-detail",
    path: equip_45detailxyZhHRSDfDMeta?.path ?? "equip-detail",
    meta: equip_45detailxyZhHRSDfDMeta || {},
    alias: equip_45detailxyZhHRSDfDMeta?.alias || [],
    redirect: equip_45detailxyZhHRSDfDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-equipinfo/equip-detail.vue").then(m => m.default || m)
  },
  {
    name: indexV5Pa4AWV7zMeta?.name ?? "toc-user-service-user-as-equipinfo",
    path: indexV5Pa4AWV7zMeta?.path ?? "",
    meta: indexV5Pa4AWV7zMeta || {},
    alias: indexV5Pa4AWV7zMeta?.alias || [],
    redirect: indexV5Pa4AWV7zMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-equipinfo/index.vue").then(m => m.default || m)
  }
],
    name: user_45as_45equipinfoGUweeSIgP0Meta?.name ?? undefined,
    meta: user_45as_45equipinfoGUweeSIgP0Meta || {},
    alias: user_45as_45equipinfoGUweeSIgP0Meta?.alias || [],
    redirect: user_45as_45equipinfoGUweeSIgP0Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-equipinfo.vue").then(m => m.default || m)
  },
  {
    path: user_45as_45managementCUE6RPjuANMeta?.path ?? "user-as-management",
    children: [
  {
    name: indexwFCuNGk6mDMeta?.name ?? "toc-user-service-user-as-management",
    path: indexwFCuNGk6mDMeta?.path ?? "",
    meta: indexwFCuNGk6mDMeta || {},
    alias: indexwFCuNGk6mDMeta?.alias || [],
    redirect: indexwFCuNGk6mDMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-management/index.vue").then(m => m.default || m)
  },
  {
    name: infoVoDvfnfpqlMeta?.name ?? "toc-user-service-user-as-management-info",
    path: infoVoDvfnfpqlMeta?.path ?? "info",
    meta: infoVoDvfnfpqlMeta || {},
    alias: infoVoDvfnfpqlMeta?.alias || [],
    redirect: infoVoDvfnfpqlMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-management/info.vue").then(m => m.default || m)
  }
],
    name: user_45as_45managementCUE6RPjuANMeta?.name ?? undefined,
    meta: user_45as_45managementCUE6RPjuANMeta || {},
    alias: user_45as_45managementCUE6RPjuANMeta?.alias || [],
    redirect: user_45as_45managementCUE6RPjuANMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-management.vue").then(m => m.default || m)
  },
  {
    path: user_45as_45ownerinfoC7BqSnbyqrMeta?.path ?? "user-as-ownerinfo",
    children: [
  {
    name: indexGQqkWJ7TXiMeta?.name ?? "toc-user-service-user-as-ownerinfo",
    path: indexGQqkWJ7TXiMeta?.path ?? "",
    meta: indexGQqkWJ7TXiMeta || {},
    alias: indexGQqkWJ7TXiMeta?.alias || [],
    redirect: indexGQqkWJ7TXiMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-ownerinfo/index.vue").then(m => m.default || m)
  },
  {
    name: owner_45detailSPukpxIazIMeta?.name ?? "toc-user-service-user-as-ownerinfo-owner-detail",
    path: owner_45detailSPukpxIazIMeta?.path ?? "owner-detail",
    meta: owner_45detailSPukpxIazIMeta || {},
    alias: owner_45detailSPukpxIazIMeta?.alias || [],
    redirect: owner_45detailSPukpxIazIMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-ownerinfo/owner-detail.vue").then(m => m.default || m)
  }
],
    name: user_45as_45ownerinfoC7BqSnbyqrMeta?.name ?? undefined,
    meta: user_45as_45ownerinfoC7BqSnbyqrMeta || {},
    alias: user_45as_45ownerinfoC7BqSnbyqrMeta?.alias || [],
    redirect: user_45as_45ownerinfoC7BqSnbyqrMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-ownerinfo.vue").then(m => m.default || m)
  },
  {
    path: user_45as_45requesthpQ0LIptE7Meta?.path ?? "user-as-request",
    children: [
  {
    name: indexNfbGaYWRZ7Meta?.name ?? "toc-user-service-user-as-request",
    path: indexNfbGaYWRZ7Meta?.path ?? "",
    meta: indexNfbGaYWRZ7Meta || {},
    alias: indexNfbGaYWRZ7Meta?.alias || [],
    redirect: indexNfbGaYWRZ7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-request/index.vue").then(m => m.default || m)
  },
  {
    name: infoYdoy9rPZT8Meta?.name ?? "toc-user-service-user-as-request-info",
    path: infoYdoy9rPZT8Meta?.path ?? "info",
    meta: infoYdoy9rPZT8Meta || {},
    alias: infoYdoy9rPZT8Meta?.alias || [],
    redirect: infoYdoy9rPZT8Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-request/info.vue").then(m => m.default || m)
  }
],
    name: user_45as_45requesthpQ0LIptE7Meta?.name ?? undefined,
    meta: user_45as_45requesthpQ0LIptE7Meta || {},
    alias: user_45as_45requesthpQ0LIptE7Meta?.alias || [],
    redirect: user_45as_45requesthpQ0LIptE7Meta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-as-request.vue").then(m => m.default || m)
  },
  {
    name: user_45infohdzNvUZMOuMeta?.name ?? "toc-user-service-user-info",
    path: user_45infohdzNvUZMOuMeta?.path ?? "user-info",
    meta: user_45infohdzNvUZMOuMeta || {},
    alias: user_45infohdzNvUZMOuMeta?.alias || [],
    redirect: user_45infohdzNvUZMOuMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-info.vue").then(m => m.default || m)
  },
  {
    name: user_45settingKd0fk3baNCMeta?.name ?? "toc-user-service-user-setting",
    path: user_45settingKd0fk3baNCMeta?.path ?? "user-setting",
    meta: user_45settingKd0fk3baNCMeta || {},
    alias: user_45settingKd0fk3baNCMeta?.alias || [],
    redirect: user_45settingKd0fk3baNCMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service/user-setting.vue").then(m => m.default || m)
  }
],
    meta: user_45serviceRyvDUJhYbsMeta || {},
    alias: user_45serviceRyvDUJhYbsMeta?.alias || [],
    redirect: user_45serviceRyvDUJhYbsMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user-service.vue").then(m => m.default || m)
  },
  {
    name: find_45id5r16OoY32MMeta?.name ?? "toc-user-find-id",
    path: find_45id5r16OoY32MMeta?.path ?? "user/find-id",
    meta: find_45id5r16OoY32MMeta || {},
    alias: find_45id5r16OoY32MMeta?.alias || [],
    redirect: find_45id5r16OoY32MMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user/find-id.vue").then(m => m.default || m)
  },
  {
    name: index11JOt9jAqJMeta?.name ?? "toc-user",
    path: index11JOt9jAqJMeta?.path ?? "user",
    meta: index11JOt9jAqJMeta || {},
    alias: index11JOt9jAqJMeta?.alias || [],
    redirect: index11JOt9jAqJMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user/index.vue").then(m => m.default || m)
  },
  {
    name: loginNUHbzvlnoaMeta?.name ?? "toc-user-login",
    path: loginNUHbzvlnoaMeta?.path ?? "user/login",
    meta: loginNUHbzvlnoaMeta || {},
    alias: loginNUHbzvlnoaMeta?.alias || [],
    redirect: loginNUHbzvlnoaMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc/user/login.vue").then(m => m.default || m)
  }
],
    meta: tocxWmTkQMz4uMeta || {},
    alias: tocxWmTkQMz4uMeta?.alias || [],
    redirect: tocxWmTkQMz4uMeta?.redirect || undefined,
    component: () => import("/app/src/client/pages/toc.vue").then(m => m.default || m)
  }
]